
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("gnpMO", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $4cOi8 = parcelRequire("4cOi8");

var $1Yx9c = parcelRequire("1Yx9c");

var $fOKpq = parcelRequire("fOKpq");

/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 





var $069d581736ad089f$exports = {};

var $jr8iR = parcelRequire("jr8iR");


var $hRuRu = parcelRequire("hRuRu");


var $ehlgT = parcelRequire("ehlgT");

/** Used as references for various `Number` constants. */ var $069d581736ad089f$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used as references for the maximum length and index of an array. */ var $069d581736ad089f$var$MAX_ARRAY_LENGTH = 4294967295;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $069d581736ad089f$var$nativeMin = Math.min;
/**
 * Invokes the iteratee `n` times, returning an array of the results of
 * each invocation. The iteratee is invoked with one argument; (index).
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 * @example
 *
 * _.times(3, String);
 * // => ['0', '1', '2']
 *
 *  _.times(4, _.constant(0));
 * // => [0, 0, 0, 0]
 */ function $069d581736ad089f$var$times(n, iteratee) {
    n = $ehlgT(n);
    if (n < 1 || n > $069d581736ad089f$var$MAX_SAFE_INTEGER) return [];
    var index = $069d581736ad089f$var$MAX_ARRAY_LENGTH, length = $069d581736ad089f$var$nativeMin(n, $069d581736ad089f$var$MAX_ARRAY_LENGTH);
    iteratee = $hRuRu(iteratee);
    n -= $069d581736ad089f$var$MAX_ARRAY_LENGTH;
    var result = $jr8iR(length, iteratee);
    while(++index < n)iteratee(index);
    return result;
}
$069d581736ad089f$exports = $069d581736ad089f$var$times;



var $1Whri = parcelRequire("1Whri");


var $dh538 = parcelRequire("dh538");


var $eyWa4 = parcelRequire("eyWa4");

/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");


var $8Yfbq = parcelRequire("8Yfbq");





var $gdv5Z = parcelRequire("gdv5Z");




var $4JDbp = parcelRequire("4JDbp");


var $IBZYB = parcelRequire("IBZYB");


var $lPcXt = parcelRequire("lPcXt");


var $ahPKE = parcelRequire("ahPKE");

const $cbc545f2775878ae$export$ba1fe8828f2c393e = 16;
const $cbc545f2775878ae$export$f4a9066d04eb34fe = 16;
const $cbc545f2775878ae$var$styles = {
    flexBox: "_1e0c1txw _kqswh2mm _19bvze3t",
    stacked: "_1n261g80",
    row: "_1reo15vq _18m915vq",
    left: "_1bah1y6m",
    center: "_1bah1h6o",
    right: "_1bahesu3"
};
const $cbc545f2775878ae$export$37f8d84bb48ae4b7 = ({ numberOfCards: numberOfCards, cardDimensions: cardDimensions, alignment: alignment, isStacked: isStacked, isInViewMode: isInViewMode, extensionLocalId: extensionLocalId, cards: cards, renderCard: renderCard, showAIDisclaimer: showAIDisclaimer, cardsContentFooter: CardsContentFooter, testId: testId })=>{
    const { calculations: calculations, setCurrentCardsGridWidth: setCurrentCardsGridWidth, setCurrentCardWidth: setCurrentCardWidth } = (0, $lPcXt.useWidthAndSpacingCalculations)({
        numberOfCards: numberOfCards,
        cardDimensions: cardDimensions
    });
    const { cardWidthOnFullRow: cardWidthOnFullRow, isFirstRowFull: isFirstRowFull, isGridSmallerOrEqualWidthToCards: isGridSmallerOrEqualWidthToCards, gaps: gaps, maxNumberOfCardsPerRow: maxNumberOfCardsPerRow } = calculations;
    const throttledSetWidth = (0, (/*@__PURE__*/$parcel$interopDefault($8Yfbq)))(setCurrentCardsGridWidth, 200);
    const orientation = isStacked ? 'grid' : 'row';
    const spaceBetweenCards = gaps.spaceBetweenCards;
    const { isAtBeginning: isAtBeginning, isAtEnd: isAtEnd, scrollToPrevious: scrollToPrevious, scrollToNext: scrollToNext, scrollToIndex: scrollToIndex, requestScrollIndex: requestScrollIndex, resetScrollIndex: resetScrollIndex } = (0, $IBZYB.useOrientationScrolling)({
        maxNumberOfItemsPerRow: maxNumberOfCardsPerRow,
        numberOfItems: cards?.length,
        isRow: !isStacked
    });
    const allCardsShown = isInViewMode && isAtBeginning && isAtEnd;
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
        testId: testId,
        children: [
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                testId: `link-cards-content-cards-${orientation}`,
                xcss: (0, $1Whri.cx)($cbc545f2775878ae$var$styles.flexBox, isStacked ? $cbc545f2775878ae$var$styles.stacked : $cbc545f2775878ae$var$styles.row, /**
     * Align left regardless of alignment if
     * - orientation is row
     * - the grid width is smaller or equal to the minimum width of the card size
     */ !isStacked || isGridSmallerOrEqualWidthToCards ? $cbc545f2775878ae$var$styles.left : $cbc545f2775878ae$var$styles[alignment]),
                style: {
                    gap: `${spaceBetweenCards}px`
                },
                children: [
                    cards.map((card, index)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $ahPKE.CardOrientationWrapper), {
                            cardId: card.cardId,
                            isFirstRowFull: isFirstRowFull,
                            cardWidthOnFullRow: cardWidthOnFullRow,
                            itemDimensions: cardDimensions,
                            setWidth: index === 0 ? setCurrentCardWidth : undefined,
                            scrollToCard: index === scrollToIndex,
                            clearScrollToCard: resetScrollIndex,
                            testId: `link-cards-content-cards-${orientation}-card-${index}`,
                            index: index,
                            requestScrollIndex: requestScrollIndex,
                            extensionLocalId: extensionLocalId,
                            children: renderCard(card)
                        }, index)),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $4JDbp.WidthObserver), {
                        setWidth: throttledSetWidth,
                        offscreen: true
                    })
                ]
            }),
            cards.length > 0 && CardsContentFooter && /*#__PURE__*/ (0, $l998X.jsx)(CardsContentFooter, {
                isStacked: isStacked,
                showAIDisclaimer: showAIDisclaimer,
                allCardsShown: allCardsShown,
                isAtBeginning: isAtBeginning,
                isAtEnd: isAtEnd,
                scrollToPrevious: scrollToPrevious,
                scrollToNext: scrollToNext
            })
        ]
    });
};


var $eagtR = parcelRequire("eagtR");







var $gtD4K = parcelRequire("gtD4K");


var $a3fRD = parcelRequire("a3fRD");


var $dcJ7R = parcelRequire("dcJ7R");

var $5dK2X = parcelRequire("5dK2X");

var $ecnYn = parcelRequire("ecnYn");





var $cgtv4 = parcelRequire("cgtv4");

const $244e38cc9236b946$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    errorLoadingCardsPreamble: {
        id: "company-hub.company-hub-common.link-cards-content.card-components.error-states.loading-cards-error-preamble",
        defaultMessage: "We\u2019re having trouble loading these cards."
    },
    errorLoadingCardsSupport: {
        id: "company-hub.company-hub-common.link-cards-content.card-components.error-states.loading-cards-error-support",
        defaultMessage: "Reload to try again."
    }
});


const $92f476fa60bd9f29$var$inlineStyles = (0, $ecnYn.xcss)({
    marginTop: 'space.150'
});
const $92f476fa60bd9f29$export$533cd3269e981a31 = ({ error: error })=>{
    const { submitError: submitError } = (0, $fOKpq.useProductDependencies)();
    (0, $42omo.useEffect)(()=>{
        submitError?.(error);
    }, [
        error,
        submitError
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $dcJ7R.default), {
        space: "space.100",
        alignBlock: "center",
        xcss: $92f476fa60bd9f29$var$inlineStyles,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a3fRD))), {
                label: "error",
                color: "var(--ds-icon-danger, #C9372C)"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                weight: "medium",
                size: "medium",
                color: "color.text",
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                    ...(0, $244e38cc9236b946$export$defe85febe8b728c).errorLoadingCardsPreamble
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                weight: "medium",
                size: "medium",
                color: "color.text.subtlest",
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                    ...(0, $244e38cc9236b946$export$defe85febe8b728c).errorLoadingCardsSupport
                })
            })
        ]
    });
};









const $ef7e4501b98ea11b$export$93c098ff84870fcb = ({ isCompanyHub: isCompanyHub, isSegmentationShown: isSegmentationShown, isTargetAudience: isTargetAudience, cards: cards, isInViewMode: isInViewMode, segmentationTarget: segmentationTarget, audienceSegmentationGroupIds: audienceSegmentationGroupIds, renderVariant: renderVariant })=>{
    const shouldApplySegmentation = (0, $42omo.useMemo)(()=>isCompanyHub && isSegmentationShown, [
        isCompanyHub,
        isSegmentationShown
    ]);
    const filteredCards = (0, $42omo.useMemo)(()=>{
        const isAudienceSegmentationEnabled = isInViewMode && shouldApplySegmentation;
        const isDynamicOrManualWithAllTarget = renderVariant === (0, $4cOi8.RenderVariant).DYNAMIC || renderVariant === (0, $4cOi8.RenderVariant).MANUAL && segmentationTarget === (0, $4cOi8.SegmentationTargets).ALL;
        if (!isAudienceSegmentationEnabled) return cards;
        if (isDynamicOrManualWithAllTarget) return isTargetAudience(audienceSegmentationGroupIds) ? cards : [];
        return cards.filter((card)=>isTargetAudience(card.audienceSegmentationGroupIds));
    }, [
        isInViewMode,
        shouldApplySegmentation,
        segmentationTarget,
        cards,
        renderVariant,
        isTargetAudience,
        audienceSegmentationGroupIds
    ]);
    return {
        filteredCards: filteredCards
    };
};




const $18092cac9334e981$export$c6c5cac0793c45d9 = (items)=>{
    const itemIdSet = (0, $42omo.useMemo)(()=>new Set(items.map((item)=>item.cardId)), [
        items
    ]);
    const [areAllItemsLoaded, setAreAllItemsLoaded] = (0, $42omo.useState)(false);
    const [itemFailureError, setItemFailureError] = (0, $42omo.useState)(null);
    const onItemFailed = (0, $42omo.useCallback)((error)=>{
        setItemFailureError(error);
    }, []);
    const onItemSucceeded = (0, $42omo.useCallback)((itemId)=>{
        itemIdSet.delete(itemId);
        if (itemIdSet.size === 0) setAreAllItemsLoaded(true);
    }, [
        itemIdSet
    ]);
    return (0, $42omo.useMemo)(()=>({
            areAllItemsLoaded: areAllItemsLoaded,
            itemFailureError: itemFailureError,
            onItemSucceeded: onItemSucceeded,
            onItemFailed: onItemFailed
        }), [
        areAllItemsLoaded,
        itemFailureError,
        onItemSucceeded,
        onItemFailed
    ]);
};














var $7w8ah = parcelRequire("7w8ah");

var $iqWjJ = parcelRequire("iqWjJ");


var $gK4nz = parcelRequire("gK4nz");

var $glYzA = parcelRequire("glYzA");

var $4ERNs = parcelRequire("4ERNs");


var $33vwh = parcelRequire("33vwh");


var $e51Sk = parcelRequire("e51Sk");

const $8e24f0fc13788755$var$getFilterValue = (filter)=>{
    return filter?.split(',') || [];
};
const $8e24f0fc13788755$var$getFilterDateRange = (filters)=>{
    const { lastModified: lastModified } = filters;
    if (lastModified && lastModified !== 'custom') return [
        (0, $33vwh.getConfluenceDateOptionValues)(lastModified)
    ];
    else if (lastModified === 'custom') {
        if (filters?.from && filters?.to) return [
            (0, $33vwh.getConfluenceDateOptionFromCustomDates)(filters.from, filters.to)
        ];
    }
    return [];
};
const $8e24f0fc13788755$var$getEntities = (type)=>{
    if (type === 'page') return [
        (0, $gK4nz.PAGE_ATI)
    ];
    else if (type === 'blogpost') return [
        (0, $gK4nz.BLOGPOST_ATI)
    ];
    return [
        (0, $gK4nz.PAGE_ATI),
        (0, $gK4nz.BLOGPOST_ATI)
    ];
};
const $8e24f0fc13788755$var$getConfluenceFilters = (filters)=>{
    const { spaces: spaces, owners: owners, labels: labels, contributors: contributors, ancestor: ancestor, verified: verified } = filters;
    return {
        spacesFilter: $8e24f0fc13788755$var$getFilterValue(spaces),
        isVerified: verified || undefined,
        contributorsFilter: $8e24f0fc13788755$var$getFilterValue(contributors),
        ancestorIdsFilter: $8e24f0fc13788755$var$getFilterValue(ancestor),
        range: $8e24f0fc13788755$var$getFilterDateRange(filters),
        owners: $8e24f0fc13788755$var$getFilterValue(owners),
        labelsFilter: $8e24f0fc13788755$var$getFilterValue(labels)
    };
};
const $8e24f0fc13788755$var$getSearchPageQueryVariables = (cardCount, filters, cloudId, searchSessionId)=>{
    const entities = $8e24f0fc13788755$var$getEntities(filters.type);
    return {
        query: '',
        cloudIdARI: `ari:cloud:confluence::site/${cloudId}`,
        tenantId: cloudId,
        limit: cardCount,
        entities: entities,
        commonFilters: {},
        confluenceFilters: $8e24f0fc13788755$var$getConfluenceFilters(filters),
        jiraFilters: {
            issueFilter: {
                projectARIs: [],
                assigneeARIs: []
            }
        },
        thirdPartyFilters: {
            titleMatchOnly: false,
            subtypes: []
        },
        queryVersion: 1,
        searchSessionId: searchSessionId ?? '',
        sort: [
            {
                field: filters.sortField || (0, $4ERNs.SORT_FIELD_KEY).LAST_MODIFIED_DATE,
                order: filters.sortOrder || (0, $4ERNs.SORT_ORDER).DESC
            }
        ]
    };
};
const $8e24f0fc13788755$export$7bf81438544569b5 = ()=>{
    const { cloudId: cloudId, searchConfigProvider: searchConfigProvider } = (0, $fOKpq.useProductDependencies)();
    const { searchSessionId: searchSessionId } = searchConfigProvider || {};
    const getDynamicCards = (0, $42omo.useCallback)(async (cardCount, filters)=>{
        const variables = $8e24f0fc13788755$var$getSearchPageQueryVariables(cardCount, filters, cloudId, searchSessionId);
        const { data: data, errors: errors } = await (0, $glYzA.searchPageQuery)({
            variables: variables
        });
        const results = data?.search.results.edges.map((edge)=>edge.node) || [];
        if (results.length === 0 || errors) return {
            cards: [],
            errors: errors
        };
        const trimmedResults = results?.slice(0, Math.min(cardCount, results.length));
        const dynamicCards = trimmedResults?.map((result)=>{
            const { title: title, description: description, url: url, id: id, confluenceEntity: confluenceEntity } = result;
            const newCard = (0, $e51Sk.createNewCardWithDefaultParameters)();
            newCard.link = url;
            newCard.title = title;
            newCard.description = description;
            newCard.confluencePageId = id.split('/')[1];
            if (confluenceEntity) {
                const { subtype: subtype, properties: properties } = confluenceEntity;
                const isLivePage = subtype === 'live';
                let imageProperty;
                if (isLivePage) imageProperty = properties?.find((image)=>image?.key === (0, $7w8ah.CoverPictureIdPropertyKey).DRAFT);
                else {
                    imageProperty = properties?.find((image)=>image?.key === (0, $7w8ah.CoverPictureIdPropertyKey).PUBLISHED);
                    if (!imageProperty) imageProperty = properties?.find((image)=>image?.key === (0, $7w8ah.CoverPictureIdPropertyKey).DRAFT);
                }
                let imageSrc = (0, $7w8ah.propertyToId)(imageProperty)?.value?.id;
                if (imageSrc && !(0, $iqWjJ.isUnsplashImage)(imageSrc)) imageSrc = `${newCard.confluencePageId}/${imageSrc}`;
                newCard.imageSrc = imageSrc;
            }
            return newCard;
        });
        return {
            cards: dynamicCards,
            errors: errors
        };
    }, [
        cloudId,
        searchSessionId
    ]);
    return (0, $42omo.useMemo)(()=>({
            getDynamicCards: getDynamicCards
        }), [
        getDynamicCards
    ]);
};


const $08734f16b0a13216$export$5fe928848609fec7 = (parameters)=>{
    const { cardCount: cardCount, filters: filters } = parameters;
    const [cards, setCards] = (0, $42omo.useState)([]);
    const [loading, setLoading] = (0, $42omo.useState)(true);
    const [error, setError] = (0, $42omo.useState)(null);
    const { getDynamicCards: getDynamicCards } = (0, $8e24f0fc13788755$export$7bf81438544569b5)();
    (0, $42omo.useEffect)(()=>{
        if (!!cardCount && !!filters) getDynamicCards(cardCount, filters).then(({ cards: dynamicCards, errors: aggErrors })=>{
            if (aggErrors) setError(new Error(JSON.stringify(aggErrors)));
            setCards(dynamicCards);
        }).catch((err)=>{
            setError(err);
        }).finally(()=>{
            setLoading(false);
        });
    }, [
        getDynamicCards,
        cardCount,
        filters
    ]);
    return (0, $42omo.useMemo)(()=>({
            cards: cards,
            loading: loading,
            error: error
        }), [
        cards,
        loading,
        error
    ]);
};



var $1VNax = parcelRequire("1VNax");




var $5un3P = parcelRequire("5un3P");



const $7165bea3d0a8ca43$var$checkIsParameterValueValid = (parameter, expectedValues)=>{
    return expectedValues.includes(parameter) ? parameter : null;
};
const $7165bea3d0a8ca43$var$checkSize = (size)=>$7165bea3d0a8ca43$var$checkIsParameterValueValid(size, [
        (0, $4cOi8.Height).SMALL,
        (0, $4cOi8.Height).MEDIUM,
        (0, $4cOi8.Height).LARGE
    ]);
const $7165bea3d0a8ca43$var$checkLayout = (layout)=>$7165bea3d0a8ca43$var$checkIsParameterValueValid(layout, [
        (0, $5un3P.CardsLayout).FIXED_IMAGE_HEIGHT,
        (0, $5un3P.CardsLayout).FLEXIBLE_IMAGE_HEIGHT
    ]);
const $7165bea3d0a8ca43$export$9a666555160249c1 = (currentParameters)=>{
    const validatedCards = (0, $1VNax.checkItems)(currentParameters.cards);
    const validatedSize = $7165bea3d0a8ca43$var$checkSize(currentParameters.size);
    const validatedLayout = $7165bea3d0a8ca43$var$checkLayout(currentParameters.layout);
    const validatedRequiredParameters = {
        ...currentParameters,
        size: validatedSize || (0, $4cOi8.Height).MEDIUM,
        cards: validatedCards || [],
        layout: validatedLayout || (0, $5un3P.CardsLayout).FLEXIBLE_IMAGE_HEIGHT
    };
    const { orientation: orientation, alignment: alignment, isAutoscrollEnabled: isAutoscrollEnabled } = validatedRequiredParameters;
    return {
        ...validatedRequiredParameters,
        // if alignment is not available (cards created before alignment), default to center
        alignment: alignment ?? (0, $5un3P.Alignment).CENTER,
        // if orientation is not available (cards created before orientation), default to stacked
        orientation: orientation ?? (0, $5un3P.Orientation).STACKED,
        isAutoscrollEnabled: orientation === (0, $5un3P.Orientation).STACKED ? false : isAutoscrollEnabled,
        // if audience segmentation new format is enabled and params are outdated, use the first card's audience segmentation group ids
        audienceSegmentationGroupIds: currentParameters.segmentationTarget === (0, $4cOi8.SegmentationTargets).ALL && currentParameters.audienceSegmentationGroupIds === undefined ? currentParameters.cards[0]?.audienceSegmentationGroupIds : currentParameters?.audienceSegmentationGroupIds
    };
};







/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $gMc0m = parcelRequire("gMc0m");








var $1qfLF = parcelRequire("1qfLF");


var $7YEWU = parcelRequire("7YEWU");


var $lOHzS = parcelRequire("lOHzS");




var $u9agA = parcelRequire("u9agA");










var $bGmGb = parcelRequire("bGmGb");




const $63428b374bc2c5f8$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    pause: {
        id: "company-hub.cards-extension.autoscroll-wrapper.pause",
        defaultMessage: "Pause"
    },
    play: {
        id: "company-hub.cards-extension.autoscroll-wrapper.play",
        defaultMessage: "Play"
    }
});


const $d1c18879ec5e414d$export$ba1fe8828f2c393e = 16;
const $d1c18879ec5e414d$export$f4a9066d04eb34fe = 16;
const $d1c18879ec5e414d$var$wrapperStyles = null;
const $d1c18879ec5e414d$var$pausedStyles = null;
const $d1c18879ec5e414d$var$scrollAnimation = null;
const $d1c18879ec5e414d$var$styles = {
    iconBackgroundStyles: "_2rko1rr0 _bfhk1bhr _1e0c1txw _4cvr1h6o _1bah1h6o",
    iconPadding: "_ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc",
    cardsGroup: "_1e0c1txw",
    container: "_kqswh2mm"
};
const $d1c18879ec5e414d$var$unboundedStyles = {
    wrapperStyles: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1rjcv77o _kqswh2mm"
};
const $d1c18879ec5e414d$var$animationStyles = null;
const $d1c18879ec5e414d$var$shortDuration = null;
const $d1c18879ec5e414d$var$mediumDuration = null;
const $d1c18879ec5e414d$var$longDuration = null;
const $d1c18879ec5e414d$export$ac70d6b7d7a09503 = ({ numberOfCards: numberOfCards, cardDimensions: cardDimensions, cards: cards, renderCard: renderCard, showAIDisclaimer: showAIDisclaimer, testId: testId })=>{
    // there are 2 ways to pause the autoscroll
    // 1. Hover over a card. Should resume back to speed when unhovered
    // 2. Pause button click. Should resume when clicked again. This is implemented to meet a11y standards
    const [isPaused, setIsPaused] = (0, $42omo.useState)(false);
    const handlePauseClick = ()=>setIsPaused(!isPaused);
    const { calculations: calculations, setCurrentCardsGridWidth: setCurrentCardsGridWidth } = (0, $lPcXt.useWidthAndSpacingCalculations)({
        numberOfCards: numberOfCards,
        cardDimensions: cardDimensions
    });
    const throttledSetWidth = (0, (/*@__PURE__*/$parcel$interopDefault($8Yfbq)))(setCurrentCardsGridWidth, 200);
    const { cardWidthOnFullRow: cardWidthOnFullRow, isFirstRowOverflown: isAnimationEnabled } = calculations;
    const renderCardsGroup = ()=>/*#__PURE__*/ (0, $l998X.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
        , {
            style: {
                gap: `${$d1c18879ec5e414d$export$ba1fe8828f2c393e}px`,
                paddingRight: `${$d1c18879ec5e414d$export$ba1fe8828f2c393e}px`
            },
            className: (0, $gMc0m.default)([
                $d1c18879ec5e414d$var$styles.cardsGroup,
                isAnimationEnabled && "",
                isAnimationEnabled && "_y44v543u",
                numberOfCards <= 5 ? "_5sagx094" : numberOfCards <= 10 ? "_5sag1als" : "_5sag1bqb"
            ]),
            children: cards.map((card, cardIndex)=>{
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Fragment), {
                    children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
                        style: {
                            minWidth: `${cardWidthOnFullRow}px`,
                            maxWidth: `${cardWidthOnFullRow}px`
                        },
                        className: (0, $gMc0m.default)([
                            $d1c18879ec5e414d$var$unboundedStyles.wrapperStyles
                        ]),
                        children: renderCard(card)
                    })
                }, cardIndex);
            })
        }); // we are making a duplicate call to renderCardsGroup to make the infinte scroll experience more seamless
    // duplicate call is only required when animation is enabled, meaning there is overflow of cards than the number of cards a row can fit
    // in which case, no autoscroll will take effect
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
        testId: testId,
        xcss: $d1c18879ec5e414d$var$styles.container,
        space: "space.075",
        children: [
            /*#__PURE__*/ (0, $l998X.jsxs)("div", {
                "data-testid": "cards-autoscroll-wrapper",
                className: (0, $gMc0m.default)([
                    "_1reo15vq _1e0c1txw _1wudtrqk",
                    isPaused && "_10r1trqk"
                ]),
                children: [
                    renderCardsGroup(),
                    isAnimationEnabled && renderCardsGroup(),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $4JDbp.WidthObserver), {
                        setWidth: throttledSetWidth,
                        offscreen: true
                    })
                ]
            }),
            isAnimationEnabled && /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
                alignInline: "start",
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    xcss: $d1c18879ec5e414d$var$styles.iconPadding,
                    children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                        space: "space.075",
                        alignBlock: "center",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                xcss: $d1c18879ec5e414d$var$styles.iconBackgroundStyles,
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                                    shape: "circle",
                                    icon: isPaused ? (0, (/*@__PURE__*/$parcel$interopDefault($lOHzS))) : (0, (/*@__PURE__*/$parcel$interopDefault($7YEWU))),
                                    label: isPaused ? /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                        ...(0, $63428b374bc2c5f8$export$defe85febe8b728c).play
                                    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                        ...(0, $63428b374bc2c5f8$export$defe85febe8b728c).pause
                                    }),
                                    onClick: handlePauseClick
                                })
                            }),
                            showAIDisclaimer && /*#__PURE__*/ (0, $l998X.jsx)((0, $bGmGb.CardsAIDisclaimer), {})
                        ]
                    })
                })
            })
        ]
    });
};








const $7b58fd4258e6a026$export$efa81a508b70a345 = {
    [(0, $4cOi8.Height).SMALL]: {
        minWidth: 221,
        maxWidth: 380,
        height: 72
    },
    [(0, $4cOi8.Height).MEDIUM]: {
        minWidth: 240,
        maxWidth: 308,
        height: 312
    },
    [(0, $4cOi8.Height).LARGE]: {
        minWidth: 358,
        maxWidth: 640,
        height: 312
    }
};
const $7b58fd4258e6a026$export$3bfbe20f0978c75 = {
    [(0, $4cOi8.Height).SMALL]: {
        minWidth: 240,
        maxWidth: 294,
        height: 84
    },
    [(0, $4cOi8.Height).MEDIUM]: {
        minWidth: 240,
        maxWidth: 294,
        height: 320
    },
    [(0, $4cOi8.Height).LARGE]: {
        minWidth: 326,
        maxWidth: 392,
        height: 320
    }
};
const $7b58fd4258e6a026$export$696b4d9e2c5c95c5 = {
    [(0, $4cOi8.Height).SMALL]: {
        ...$7b58fd4258e6a026$export$3bfbe20f0978c75[(0, $4cOi8.Height).SMALL]
    },
    [(0, $4cOi8.Height).MEDIUM]: {
        minWidth: 240,
        maxWidth: 294,
        minHeight: 52,
        maxHeight: 348
    },
    [(0, $4cOi8.Height).LARGE]: {
        minWidth: 326,
        maxWidth: 392,
        minHeight: 64,
        maxHeight: 424
    }
};


const $e41f25d61305a67d$export$90cc9ab68d35b5b9 = ({ cardSize: cardSize, layout: layout, isCardsVisualUpdateEnabled: isCardsVisualUpdateEnabled, isCardsV2Enabled: isCardsV2Enabled })=>{
    if (isCardsV2Enabled && layout === (0, $5un3P.CardsLayout).FIXED_IMAGE_HEIGHT) return (0, $7b58fd4258e6a026$export$696b4d9e2c5c95c5)[cardSize];
    if (isCardsVisualUpdateEnabled && layout === (0, $5un3P.CardsLayout).FLEXIBLE_IMAGE_HEIGHT) return (0, $7b58fd4258e6a026$export$3bfbe20f0978c75)[cardSize];
    return (0, $7b58fd4258e6a026$export$efa81a508b70a345)[cardSize];
};

/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");





var $8C5kA = parcelRequire("8C5kA");












var $3LC7V = parcelRequire("3LC7V");

var $5TXU5 = parcelRequire("5TXU5");

var $8zS2j = parcelRequire("8zS2j");


var $9CM6e = parcelRequire("9CM6e");

/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 












var $6F6hl = parcelRequire("6F6hl");





var $fQWPs = parcelRequire("fQWPs");


var $fZitC = parcelRequire("fZitC");


var $1u5CA = parcelRequire("1u5CA");

const $3dfe810951ca69c6$var$DARK_THRESHOLD = 50;
const $3dfe810951ca69c6$var$convertToHoveredShade = (hexColor)=>{
    const lightnessPercentage = (0, $fZitC.getLightnessPercentage)(hexColor);
    if (lightnessPercentage === undefined) return hexColor;
    // Lighten dark colors; darken light colors slightly based on LCH lightness
    // 0 - 100 dark to light
    const LIGHTEN_TO = Math.min(100, Math.round(lightnessPercentage + 10));
    const DARKEN_TO = Math.max(0, Math.round(lightnessPercentage - 10));
    if (lightnessPercentage < $3dfe810951ca69c6$var$DARK_THRESHOLD) return (0, $fZitC.increaseLightness)(hexColor, LIGHTEN_TO);
    return (0, $fZitC.reduceLightness)(hexColor, DARKEN_TO);
};
const $3dfe810951ca69c6$export$8af9b0107e419002 = (backgroundColor)=>{
    const tokenizedHoveredBackgroundColor = (0, $1u5CA.getBackgroundHoveredColor)(backgroundColor);
    if (tokenizedHoveredBackgroundColor) return tokenizedHoveredBackgroundColor;
    const convertedColor = (0, $fQWPs.convertLegacyColor)(backgroundColor);
    if (convertedColor.isValid()) return $3dfe810951ca69c6$var$convertToHoveredShade(convertedColor.toHexString());
    return backgroundColor;
};


const $ef8b32455958df4d$export$1b6000962053a12c = (color)=>{
    const [backgroundColor, setBackgroundColor] = (0, $42omo.useState)();
    const [hoveredBackgroundColor, setHoveredBackgroundColor] = (0, $42omo.useState)();
    const [shownBackgroundColor, setShownBackgroundColor] = (0, $42omo.useState)();
    (0, $42omo.useEffect)(()=>{
        const hoveredBgColor = color ? (0, $3dfe810951ca69c6$export$8af9b0107e419002)(color) : undefined;
        setBackgroundColor(color);
        setShownBackgroundColor(color);
        setHoveredBackgroundColor(hoveredBgColor);
    }, [
        color
    ]);
    const handleHover = (0, $42omo.useCallback)(()=>{
        setShownBackgroundColor(hoveredBackgroundColor);
    }, [
        hoveredBackgroundColor
    ]);
    const handleUnhover = (0, $42omo.useCallback)(()=>{
        setShownBackgroundColor(backgroundColor);
    }, [
        backgroundColor
    ]);
    return {
        backgroundColor: shownBackgroundColor || backgroundColor,
        handleHover: handleHover,
        handleUnhover: handleUnhover
    };
};


var $19TyP = parcelRequire("19TyP");


var $g3LxX = parcelRequire("g3LxX");










var $d7ebe172edcc0fde$export$2e2bcd8739ae039 = (0, $cgtv4.defineMessages)({
    selectToEditAriaLabel: {
        id: "company-hub.company-hub-common.items-shared.item-container.button.edit.aria-label",
        defaultMessage: "Select card to edit"
    }
});


const $875e9f2f375ca359$var$unboundedStyles = {
    containerBase: "_1reo15vq _18m915vq _1dqonqa1 _189ee4h9 _1h6d1l7x _vchhusvi _19pkv77o _2hwxv77o _otyrv77o _18u0v77o _4t3i1osq _syazi7uo _bfhk1bhr",
    containerCorner: "_2rko1mok",
    viewOnHover: "_irr36o2t _d0altlke",
    overlayButtonForSelectToEdit: "_19itglyw _kqswstnw _b35bglyw _bfhk1j28 _154iidpf _1ltvidpf _1xi2idpf _94n5idpf _1pbykb7n",
    selectedToEdit: "_1a37dfik",
    selectedToRemove: "_1a3719ep _1kt9b3bt _1cs8stnw _1aukidpf _qnecidpf _oounidpf _19woidpf _1g0vkb7n _154p105o _1rus1gly"
};
const $875e9f2f375ca359$var$SelectToEditButton = ({ cardId: cardId, extensionLocalId: extensionLocalId, onSelectStateUpdate: onSelectStateUpdate })=>{
    const [{ selectedExtensionLocalId: selectedExtensionLocalId, selectedToEditCardId: selectedToEditCardId, selectedToRemoveCardId: selectedToRemoveCardId }, { setIsInAutoFocusMode: setIsInAutoFocusMode, setSelectedToEditCardId: setSelectedToEditCardId }] = (0, $g3LxX.useExtensionsState)();
    const handleClick = (0, $42omo.useCallback)(()=>{
        if (cardId && extensionLocalId === selectedExtensionLocalId) {
            setIsInAutoFocusMode(true);
            setSelectedToEditCardId(cardId);
        }
    }, [
        cardId,
        extensionLocalId,
        selectedExtensionLocalId,
        setSelectedToEditCardId,
        setIsInAutoFocusMode
    ]);
    const isSelectedToEdit = selectedToEditCardId === cardId && extensionLocalId === selectedExtensionLocalId;
    const isSelectedToRemove = selectedToRemoveCardId === cardId && extensionLocalId === selectedExtensionLocalId;
    (0, $42omo.useEffect)(()=>{
        onSelectStateUpdate?.({
            isSelectedToEdit: isSelectedToEdit,
            isSelectedToRemove: isSelectedToRemove
        });
    }, [
        isSelectedToEdit,
        isSelectedToRemove,
        onSelectStateUpdate
    ]); /*
                                                                   	Overlay an invisible button to allow click interaction on edit.
                                                                   	Also avoid violating A11y rules for making non-interactive element interactive by putting onClick on the container.
                                                                   */ 
    // eslint-disable-next-line @atlaskit/design-system/no-html-button
    return /*#__PURE__*/ (0, $l998X.jsx)("button", {
        onClick: handleClick,
        className: (0, $gMc0m.default)([
            $875e9f2f375ca359$var$unboundedStyles.overlayButtonForSelectToEdit
        ]),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $6F6hl.default), {
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                ...(0, $d7ebe172edcc0fde$export$2e2bcd8739ae039).selectToEditAriaLabel
            })
        })
    });
}; /**
    *
    * This component is used to wrap the card content and set the followings of the card
    * - border
    * - height (optional)
    * - background color
    * - hover effect ( for view)
    * - outline (for edit)
    * - color
    */ 
const $875e9f2f375ca359$export$8a23e74e5cf3ca41 = ({ id: id, cardHeight: cardHeight, isInViewMode: isInViewMode, children: children, hasLink: hasLink, cardId: cardId, extensionLocalId: extensionLocalId, cornerStyle: cornerStyle, backgroundColor: savedBackgroundColor, textColor: savedTextColor, borderColor: borderColor, isEditable: isEditable, isHoverable: isHoverable = true })=>{
    const isCardEditable = !isInViewMode && isEditable;
    const isCardHoverable = isInViewMode && hasLink && isHoverable;
    const [isSelectedToEdit, setIsSelectedToEdit] = (0, $42omo.useState)(false);
    const [isSelectedToRemove, setIsSelectedToRemove] = (0, $42omo.useState)(false); // handle theme responsiveness for text and background colors
    const { isSSRProductInDarkMode: isSSRProductInDarkMode } = (0, $fOKpq.useProductDependencies)();
    const { getDarkModeCompatibleTextColor: getDarkModeCompatibleTextColor, getDarkModeCompatibleBackgroundColor: getDarkModeCompatibleBackgroundColor } = (0, $19TyP.useDarkModeColors)(isSSRProductInDarkMode);
    const textColor = (0, $42omo.useMemo)(()=>savedTextColor ? getDarkModeCompatibleTextColor(savedTextColor) : undefined, [
        savedTextColor,
        getDarkModeCompatibleTextColor
    ]);
    const backgroundColor = (0, $42omo.useMemo)(()=>savedBackgroundColor ? getDarkModeCompatibleBackgroundColor(savedBackgroundColor) : undefined, [
        savedBackgroundColor,
        getDarkModeCompatibleBackgroundColor
    ]);
    const { backgroundColor: currentBackgroundColor, handleHover: handleHover, handleUnhover: handleUnhover } = (0, $ef8b32455958df4d$export$1b6000962053a12c)(backgroundColor);
    const handleMouseEnter = (0, $42omo.useCallback)(()=>{
        handleHover();
    }, [
        handleHover
    ]);
    const handleMouseLeave = (0, $42omo.useCallback)(()=>{
        handleUnhover();
    }, [
        handleUnhover
    ]); // handle select to edit
    const handleSelectStateUpdate = (0, $42omo.useCallback)(({ isSelectedToEdit: isSelectedToEdit, isSelectedToRemove: isSelectedToRemove })=>{
        setIsSelectedToEdit(isSelectedToEdit);
        setIsSelectedToRemove(isSelectedToRemove);
    }, [
        setIsSelectedToEdit,
        setIsSelectedToRemove
    ]);
    const hideCorner = cornerStyle === (0, $4cOi8.CornerStyle).SQUARED;
    return /*#__PURE__*/ (0, $l998X.jsxs)("div", {
        "data-testid": id,
        style: {
            height: cardHeight,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            color: textColor,
            backgroundColor: currentBackgroundColor,
            borderColor: borderColor
        },
        ...isCardHoverable && !!savedBackgroundColor ? {
            onMouseEnter: handleMouseEnter,
            onMouseLeave: handleMouseLeave
        } : {},
        className: (0, $gMc0m.default)([
            $875e9f2f375ca359$var$unboundedStyles.containerBase,
            !hideCorner && $875e9f2f375ca359$var$unboundedStyles.containerCorner,
            isCardHoverable && $875e9f2f375ca359$var$unboundedStyles.viewOnHover,
            isSelectedToEdit && $875e9f2f375ca359$var$unboundedStyles.selectedToEdit,
            isSelectedToRemove && $875e9f2f375ca359$var$unboundedStyles.selectedToRemove
        ]),
        children: [
            isCardEditable && /*#__PURE__*/ (0, $l998X.jsx)($875e9f2f375ca359$var$SelectToEditButton, {
                onSelectStateUpdate: handleSelectStateUpdate,
                cardId: cardId,
                extensionLocalId: extensionLocalId
            }),
            children
        ]
    });
};


var $aPwHF = parcelRequire("aPwHF");


var $jqjsu = parcelRequire("jqjsu");

var $evEMm = parcelRequire("evEMm");




const $aeeaf0d423f7dea3$export$28a088c1679c6579 = ({ isOwnerInfoShown: isOwnerInfoShown, isModifiedOnShown: isModifiedOnShown, isSocialStatsShown: isSocialStatsShown })=>{
    // smart card elements render states
    const [isAvatarAvailable, setIsAvatarAvailable] = (0, $42omo.useState)();
    const [isOwnerNameAvailable, setIsOwnerNameAvailable] = (0, $42omo.useState)();
    const [isModifiedOnAvailable, setIsModifiedOnAvailable] = (0, $42omo.useState)();
    const [isCommentCountAvailable, setIsCommentCountAvailable] = (0, $42omo.useState)();
    const [isReactCountAvailable, setIsReactCountAvailable] = (0, $42omo.useState)();
    (0, $42omo.useEffect)(()=>{
        // attempt to render the elements when they are supposed to be shown to get data availability
        setIsAvatarAvailable(!!isOwnerInfoShown);
        setIsOwnerNameAvailable(!!isOwnerInfoShown);
        setIsModifiedOnAvailable(!!isModifiedOnShown);
        setIsCommentCountAvailable(!!isSocialStatsShown);
        setIsReactCountAvailable(!!isSocialStatsShown);
    }, [
        isOwnerInfoShown,
        isModifiedOnShown,
        isSocialStatsShown
    ]);
    const shouldRenderOwnerInfo = (0, $42omo.useMemo)(()=>isAvatarAvailable || isOwnerNameAvailable, [
        isAvatarAvailable,
        isOwnerNameAvailable
    ]);
    const shouldRenderMetadata = (0, $42omo.useMemo)(()=>shouldRenderOwnerInfo || isModifiedOnAvailable, [
        shouldRenderOwnerInfo,
        isModifiedOnAvailable
    ]);
    const shouldRenderSocials = (0, $42omo.useMemo)(()=>isReactCountAvailable || isCommentCountAvailable, [
        isReactCountAvailable,
        isCommentCountAvailable
    ]);
    return {
        setIsAvatarAvailable: setIsAvatarAvailable,
        setIsOwnerNameAvailable: setIsOwnerNameAvailable,
        setIsModifiedOnAvailable: setIsModifiedOnAvailable,
        setIsReactCountAvailable: setIsReactCountAvailable,
        setIsCommentCountAvailable: setIsCommentCountAvailable,
        shouldRenderOwnerInfo: shouldRenderOwnerInfo,
        shouldRenderMetadata: shouldRenderMetadata,
        shouldRenderSocials: shouldRenderSocials
    };
};





parcelRequire("42omo");




/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 









var $4wH3g = parcelRequire("4wH3g");


var $e0Oqq = parcelRequire("e0Oqq");


const $89b35c68973ec39a$export$836160481278e63f = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "vUDoI",
    name: "LazyEmojiComponentLoader",
    _vcPlaceholderIgnored: true,
    loader: async ()=>(await (parcelRequire("aNq5K"))).EmojiComponent,
    loading: (props)=>props.emoji ? /*#__PURE__*/ (0, $l998X.jsx)((0, $e0Oqq.EmojiPlaceholder), {
            ...props
        }) : null
});
const $89b35c68973ec39a$var$styles = {
    wrapper: "_1e0c1txw _1bah1h6o"
};
const $89b35c68973ec39a$export$56e4c85b6a8d02e6 = ({ emojiId: emojiId, height: height = 40, width: width = 40 })=>{
    const wrapper = (0, $42omo.useMemo)(()=>(props)=>/*#__PURE__*/ (0, $l998X.jsx)("div", {
                style: {
                    maxWidth: `${width}px`
                },
                ...props,
                className: (0, $gMc0m.default)([
                    $89b35c68973ec39a$var$styles.wrapper
                ])
            }), [
        width
    ]);
    if (!emojiId) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)($89b35c68973ec39a$export$836160481278e63f, {
        emoji: emojiId,
        height: height,
        wrapper: wrapper,
        renderResourcedEmoji: true
    });
};





var $k00oi = parcelRequire("k00oi");




const $9e2ac3240ff02a0e$var$sanitizeEmojiValue = (value)=>value && value.replace(/['"]+/g, '').replace(/null/, '') || '';
const $9e2ac3240ff02a0e$export$6ed6867e3290476 = (link)=>{
    const { submitError: submitError } = (0, $fOKpq.useProductDependencies)();
    const [emojiId, setEmojiId] = (0, $42omo.useState)();
    const getEmoji = (0, $42omo.useCallback)(async ()=>{
        const client = new (0, $k00oi.default)();
        try {
            const queriedEmojiObject = await client.fetchData(link);
            setEmojiId($9e2ac3240ff02a0e$var$sanitizeEmojiValue(queriedEmojiObject.data['atlassian:titlePrefix']?.text));
        } catch (error) {
            submitError?.(error);
        }
    }, [
        link,
        submitError
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!!link) getEmoji();
    }, [
        link,
        getEmoji
    ]);
    return {
        emojiId: !!emojiId ? emojiId : null
    };
};


const $e0e95a63d1499075$export$69387b41dfc808f7 = ({ link: link })=>{
    const { emojiId: emojiId } = (0, $9e2ac3240ff02a0e$export$6ed6867e3290476)(link);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $3LC7V.LinkIconElement), {
        iconTileSize: 24,
        render: emojiId ? ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $89b35c68973ec39a$export$56e4c85b6a8d02e6), {
                emojiId: emojiId,
                height: 24,
                width: 24
            }) : undefined
    });
};


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");




var $8b4757f8612ed1f0$export$6eeb615c261d1c6b = /*#__PURE__*/ function(FontVariant) {
    FontVariant["HeadingMedium"] = "headingMedium";
    FontVariant["HeadingSmall"] = "headingSmall";
    FontVariant["HeadingXSmall"] = "headingXSmall";
    FontVariant["Body"] = "body";
    FontVariant["BodyLarge"] = "bodyLarge";
    return FontVariant;
}({});
const $8b4757f8612ed1f0$var$unboundedStyles = {
    baseText: "_1reo15vq _18m915vq _1bto1l2s _1e0ccj1k _sudp1e54 _1yyj11wp",
    title: "_1bsb1osq",
    description: "_o5724jg8",
    headingMedium: "_11c8lodh",
    headingSmall: "_11c8nbxd",
    headingXSmall: "_11c8140y",
    bodyLarge: "_11c81ixg",
    body: "_11c82smr"
};
const $8b4757f8612ed1f0$export$474db65c3c394e1c = ({ children: children, maxLine: maxLine, fontVariant: fontVariant })=>/*#__PURE__*/ (0, $l998X.jsx)("span", {
        style: {
            WebkitLineClamp: maxLine
        },
        className: (0, $gMc0m.default)([
            $8b4757f8612ed1f0$var$unboundedStyles.baseText,
            $8b4757f8612ed1f0$var$unboundedStyles.title,
            $8b4757f8612ed1f0$var$unboundedStyles[fontVariant]
        ]),
        children: children
    });
const $8b4757f8612ed1f0$export$16e0ed4cb97c00d4 = ({ children: children, maxLine: maxLine, fontVariant: fontVariant })=>/*#__PURE__*/ (0, $l998X.jsx)("span", {
        style: {
            WebkitLineClamp: maxLine
        },
        className: (0, $gMc0m.default)([
            $8b4757f8612ed1f0$var$unboundedStyles.baseText,
            $8b4757f8612ed1f0$var$unboundedStyles.description,
            $8b4757f8612ed1f0$var$unboundedStyles[fontVariant]
        ]),
        children: children
    });





const $8cd68a7a628e8835$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    emptyStatePlaceholderTitle: {
        id: "company-hub.card-extensions.large-card.large-card-v1.empty-state.title-placeholder",
        defaultMessage: "Give your card a title"
    }
});


const $13e5f254f9926788$var$unboundedStyles = {
    avatar: "_c71l1tcg _19pkmyb0 _1lplidpf _px5oidpf _m5lyidpf _1oxkidpf _18alidpf _1mxvidpf _suiuidpf _1bc3idpf _tvjiidpf _1y56idpf _rjv6idpf _mbyhidpf",
    snippetOverride: "_syaz1kw7 _5fky1ixg _mavj1kw7"
};
const $13e5f254f9926788$var$styles = {
    content: "_1reo15vq _18m915vq _1e0c1txw _2lx21bp4",
    image: "_1reo15vq _18m915vq _16jlkb7n _1o9zkb7n _i0dl1wug _4t3i1osq",
    floatingIcon: "_1reoewfl _18m9ewfl _bozgpxbi _154ixmi2 _4t3iidpf _kqswh2mm",
    body: "_ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi",
    socials: "_19pk1wug",
    unresolvedAction: "_1reo15vq _18m915vq _11c81ixg _1bsb1osq _1bto1l2s _syazazsu"
};
const $13e5f254f9926788$var$MIN_TITLE_LINES = 2;
const $13e5f254f9926788$var$MAX_TITLE_LINES = 4;
const $13e5f254f9926788$var$MIN_DESCRIPTION_LINES = 3;
const $13e5f254f9926788$var$MAX_DESCRIPTION_LINES = 6;
const $13e5f254f9926788$var$getTitleDescriptionMaxLine = ({ hasImage: hasImage, shouldRenderMetadata: shouldRenderMetadata, shouldRenderSocials: shouldRenderSocials })=>{
    let titleMaxLine = $13e5f254f9926788$var$MIN_TITLE_LINES;
    let descriptionMaxLine = $13e5f254f9926788$var$MIN_DESCRIPTION_LINES;
    if (!hasImage) {
        titleMaxLine += 1;
        descriptionMaxLine += 1;
        if (!shouldRenderMetadata) {
            titleMaxLine += 1;
            descriptionMaxLine += 1;
        }
        if (!shouldRenderSocials) descriptionMaxLine += 1;
    }
    if (titleMaxLine > $13e5f254f9926788$var$MAX_TITLE_LINES) titleMaxLine = $13e5f254f9926788$var$MAX_TITLE_LINES;
    if (descriptionMaxLine > $13e5f254f9926788$var$MAX_DESCRIPTION_LINES) descriptionMaxLine = $13e5f254f9926788$var$MAX_DESCRIPTION_LINES;
    return {
        titleMaxLine: titleMaxLine,
        descriptionMaxLine: descriptionMaxLine
    };
};
const $13e5f254f9926788$export$299421c7aa71f32d = ({ contentId: contentId, cardId: cardId, link: link, title: title, imageSrc: imageSrc, cardDimensions: cardDimensions, isAvatarShown: isAvatarShown, isPublishDateShown: isPublishDateShown, isSocialStatsShown: isSocialStatsShown, isIconShown: isIconShown, description: description, showDescription: showDescription, isInViewMode: isInViewMode, onCardSucceeded: onCardSucceeded, onCardFailed: onCardFailed, imageAltText: imageAltText, extensionLocalId: extensionLocalId, isManualVariant: isManualVariant, backgroundColor: backgroundColor, textColor: textColor, cornerStyle: cornerStyle, enableSnippetRenderer: enableSnippetRenderer })=>{
    const hasLink = !!link;
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const cardHeight = cardDimensions.height;
    const { setIsAvatarAvailable: setIsAvatarAvailable, setIsOwnerNameAvailable: setIsOwnerNameAvailable, setIsModifiedOnAvailable: setIsModifiedOnAvailable, setIsReactCountAvailable: setIsReactCountAvailable, setIsCommentCountAvailable: setIsCommentCountAvailable, shouldRenderOwnerInfo: shouldRenderOwnerInfo, shouldRenderMetadata: shouldRenderMetadata, shouldRenderSocials: shouldRenderSocials } = (0, $aeeaf0d423f7dea3$export$28a088c1679c6579)({
        isOwnerInfoShown: isAvatarShown && hasLink,
        isModifiedOnShown: isPublishDateShown && hasLink,
        isSocialStatsShown: isSocialStatsShown && hasLink
    });
    const { hasImage: hasImage } = (0, $jqjsu.getImageTypeToShow)({
        imageSrc: imageSrc
    });
    const { isResolved: isResolved, errorCardStatus: hasError, trackAndCategorizeError: trackAndCategorizeError, trackSuccess: trackSuccess } = (0, $aPwHF.useTrackedSmartCardState)(cardId, link, onCardSucceeded, onCardFailed);
    const { titleMaxLine: titleMaxLine, descriptionMaxLine: descriptionMaxLine } = $13e5f254f9926788$var$getTitleDescriptionMaxLine({
        hasImage: hasImage,
        shouldRenderMetadata: shouldRenderMetadata,
        shouldRenderSocials: shouldRenderSocials
    });
    const cardBodyItems = hasLink ? [
        // Icon for non-image cards
        isIconShown && !hasImage && /*#__PURE__*/ (0, $l998X.jsx)((0, $e0e95a63d1499075$export$69387b41dfc808f7), {
            link: link
        }, "link-icon"),
        // Title
        title && /*#__PURE__*/ (0, $l998X.jsx)((0, $8b4757f8612ed1f0$export$474db65c3c394e1c), {
            maxLine: titleMaxLine,
            fontVariant: (0, $8b4757f8612ed1f0$export$6eeb615c261d1c6b).HeadingMedium,
            children: title
        }, "title"),
        // Unresolved action if there is error and no title and no description
        hasError && !title && !description && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            xcss: (0, $1Whri.cx)($13e5f254f9926788$var$styles.unresolvedAction),
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $3LC7V.UnresolvedAction), {})
        }, "unresolved-action"),
        // Avatar and Publish Date
        isResolved && !hasError && shouldRenderMetadata && /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
            testId: "large-card-v1-metadata",
            space: "space.050",
            separator: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                children: "\u2022"
            }),
            alignBlock: "center",
            children: [
                shouldRenderOwnerInfo && /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                    space: "space.050",
                    alignBlock: "center",
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)("div", {
                            className: (0, $gMc0m.default)([
                                $13e5f254f9926788$var$unboundedStyles.avatar
                            ]),
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $3LC7V.OwnedByGroupElement), {
                                onRender: setIsAvatarAvailable
                            })
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $3LC7V.OwnedByElement), {
                            color: "inherit",
                            hideFormat: true,
                            onRender: setIsOwnerNameAvailable
                        })
                    ]
                }),
                !!isPublishDateShown && /*#__PURE__*/ (0, $l998X.jsx)((0, $3LC7V.ModifiedOnElement), {
                    color: "inherit",
                    onRender: (hasData)=>setIsModifiedOnAvailable(hasData)
                })
            ]
        }, "metadata"),
        // Description
        // AI snippet
        showDescription && enableSnippetRenderer && /*#__PURE__*/ (0, $l998X.jsx)("div", {
            className: (0, $gMc0m.default)([
                $13e5f254f9926788$var$unboundedStyles.snippetOverride
            ]),
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $8zS2j.default), {
                showFooter: false,
                maxLines: descriptionMaxLine,
                text: description
            })
        }, "snippet"),
        // normal description
        showDescription && !enableSnippetRenderer && description && /*#__PURE__*/ (0, $l998X.jsx)((0, $8b4757f8612ed1f0$export$16e0ed4cb97c00d4), {
            maxLine: descriptionMaxLine,
            fontVariant: (0, $8b4757f8612ed1f0$export$6eeb615c261d1c6b).BodyLarge,
            children: description
        }, "description"),
        // Socials
        isResolved && !hasError && shouldRenderSocials && /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
            testId: "large-card-v1-socials",
            space: "space.150",
            xcss: $13e5f254f9926788$var$styles.socials,
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $3LC7V.ReactCountElement), {
                    color: "inherit",
                    onRender: setIsReactCountAvailable
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $3LC7V.CommentCountElement), {
                    color: "inherit",
                    onRender: setIsCommentCountAvailable
                })
            ]
        }, "socials")
    ].filter(Boolean) : [
        // Title or placeholder
        /*#__PURE__*/ (0, $l998X.jsx)((0, $8b4757f8612ed1f0$export$474db65c3c394e1c), {
            maxLine: titleMaxLine,
            fontVariant: (0, $8b4757f8612ed1f0$export$6eeb615c261d1c6b).HeadingMedium,
            children: title || formatMessage((0, $8cd68a7a628e8835$export$defe85febe8b728c).emptyStatePlaceholderTitle)
        }, "title"),
        // Description
        description && /*#__PURE__*/ (0, $l998X.jsx)((0, $8b4757f8612ed1f0$export$16e0ed4cb97c00d4), {
            maxLine: descriptionMaxLine,
            fontVariant: (0, $8b4757f8612ed1f0$export$6eeb615c261d1c6b).BodyLarge,
            children: description
        }, "description")
    ].filter(Boolean);
    const cardContent = /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
        testId: "large-card-content",
        xcss: (0, $1Whri.cx)($13e5f254f9926788$var$styles.content),
        style: {
            height: cardHeight
        },
        children: [
            hasImage && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: (0, $1Whri.cx)($13e5f254f9926788$var$styles.image),
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $evEMm.ImageRenderer), {
                    contentId: contentId,
                    imageSrc: imageSrc,
                    imageAlt: imageAltText,
                    shouldShowExternalSiteImage: hasLink
                })
            }),
            isIconShown && hasLink && hasImage && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: (0, $1Whri.cx)($13e5f254f9926788$var$styles.floatingIcon),
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $e0e95a63d1499075$export$69387b41dfc808f7), {
                    link: link
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $eyWa4.default), {
                testId: "large-card-body",
                space: "space.100",
                grow: "fill",
                xcss: (0, $1Whri.cx)($13e5f254f9926788$var$styles.body),
                children: cardBodyItems
            })
        ]
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $875e9f2f375ca359$export$8a23e74e5cf3ca41), {
        id: "large-card-v1-container",
        cardHeight: cardHeight,
        isInViewMode: isInViewMode,
        cardId: cardId,
        extensionLocalId: extensionLocalId,
        isEditable: isManualVariant,
        cornerStyle: cornerStyle,
        hasLink: hasLink,
        backgroundColor: backgroundColor,
        textColor: textColor,
        children: hasLink ? /*#__PURE__*/ (0, $l998X.jsx)((0, $9CM6e.CardSSR), {
            id: cardId,
            appearance: "inline",
            frameStyle: "show",
            ui: {
                theme: (0, $5TXU5.SmartLinkTheme).Black,
                clickableContainer: isInViewMode,
                size: (0, $5TXU5.SmartLinkSize).XLarge,
                removeBlockRestriction: true,
                hideBackground: true,
                hideElevation: true,
                hidePadding: true,
                enableSnippetRenderer: enableSnippetRenderer
            },
            url: link,
            onResolve: trackSuccess,
            onError: trackAndCategorizeError,
            children: cardContent
        }) : cardContent
    });
};

/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");



























/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 












var $iXCQx = parcelRequire("iXCQx");


var $lhvsH = parcelRequire("lhvsH");






const $462fd57cdee18a3d$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    emptyStatePlaceholderLabel: {
        id: "company-hub.company-hub-common.ui.empty-state.label-placeholder",
        defaultMessage: "LABEL"
    }
});


const $65b0289431fea6b1$var$styles = {
    label: "_2rkofajl _u5f31b66 _19bv1b66"
};
const $65b0289431fea6b1$export$bc1a48e1b7ed7af = ({ label: label, labelColor: labelColor })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const labelFinal = label || formatMessage((0, $462fd57cdee18a3d$export$defe85febe8b728c).emptyStatePlaceholderLabel);
    const labelColorFinal = labelColor ?? (0, $lhvsH.DEFAULT_GRAY_COLOR);
    const labelTextColorFinal = (0, $42omo.useMemo)(()=>{
        return (0, $fQWPs.isReadable)(labelColorFinal, "var(--ds-text, #292A2E)") ? 'color.text' : 'color.text.inverse';
    }, [
        labelColorFinal
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        style: {
            backgroundColor: labelColorFinal
        },
        className: (0, $gMc0m.default)([
            $65b0289431fea6b1$var$styles.label
        ]),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
            color: labelTextColorFinal,
            size: "small",
            maxLines: 1,
            weight: "bold",
            children: labelFinal?.toUpperCase()
        })
    });
};

















const $00743a112f1453da$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    emptyStatePlaceholderTitle: {
        id: "company-hub.card-extensions.large-card.large-card-v2.empty-state.title-placeholder",
        defaultMessage: "Give your card a title"
    }
});


const $b85a19d2e323979a$var$unboundedStyles = {
    avatar: "_c71l1tcg _19pk1lpd _1lplidpf _px5oidpf _m5lyidpf _1oxkidpf _18alidpf _1mxvidpf _suiuidpf _1bc3idpf _tvjiidpf _1y56idpf _rjv6idpf _mbyhidpf",
    snippetOverride: "_syaz1kw7 _5fky1ixg _mavj1kw7",
    smartCardWrapper: "_4t3i1osq _wht71osq"
};
const $b85a19d2e323979a$var$styles = {
    content: "_1reo15vq _18m915vq _1e0c1txw _2lx21bp4 _4t3i1osq _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi",
    imageCorner: "_2rko1mok",
    imageWithPadding: "_1reo15vq _18m915vq _4t3imgvx",
    imageNoPadding: "_1reo15vq _18m915vq _4t3iuuw1 _19pkmgjw _2hwxmgjw _18u0mgjw _n3td1b66",
    headerWithImagePadding: "_ca0qu2gc _19bvu2gc",
    headerWithImage: "_1e0c1txw _kqswstnw _154ipxbi _1ltvpxbi",
    unresolvedAction: "_1reo15vq _18m915vq _11c81ixg _1bsb1osq _1bto1l2s _syazazsu",
    static: "_kqswpfqs",
    relative: "_kqswh2mm"
};
const $b85a19d2e323979a$var$MIN_TITLE_LINES = 3;
const $b85a19d2e323979a$var$MAX_TITLE_LINES = 5;
const $b85a19d2e323979a$var$MIN_DESCRIPTION_LINES = 3;
const $b85a19d2e323979a$var$MAX_DESCRIPTION_LINES = 6;
const $b85a19d2e323979a$var$getTitleDescriptionMaxLine = ({ hasImage: hasImage })=>{
    let titleMaxLine = $b85a19d2e323979a$var$MIN_TITLE_LINES;
    let descriptionMaxLine = $b85a19d2e323979a$var$MIN_DESCRIPTION_LINES;
    if (!hasImage) {
        titleMaxLine += 2;
        descriptionMaxLine += 3;
    }
    if (titleMaxLine > $b85a19d2e323979a$var$MAX_TITLE_LINES) titleMaxLine = $b85a19d2e323979a$var$MAX_TITLE_LINES;
    if (descriptionMaxLine > $b85a19d2e323979a$var$MAX_DESCRIPTION_LINES) descriptionMaxLine = $b85a19d2e323979a$var$MAX_DESCRIPTION_LINES;
    return {
        titleMaxLine: titleMaxLine,
        descriptionMaxLine: descriptionMaxLine
    };
};
const $b85a19d2e323979a$export$a59c193ce67944a7 = ({ cardDimensions: cardDimensions, cardId: cardId, link: link, isInViewMode: isInViewMode, isManualVariant: isManualVariant, extensionLocalId: extensionLocalId, imageSrc: imageSrc, imageAltText: imageAltText, contentId: contentId, title: title, description: description, label: label, isLabelHidden: isLabelHidden, labelColor: labelColor, isLabelShown: isLabelShown, isPaddingEnabled: isPaddingEnabled, isAvatarShown: isAvatarShown, isPublishDateShown: isPublishDateShown, isSocialStatsShown: isSocialStatsShown, isIconShown: isIconShown, onCardSucceeded: onCardSucceeded, onCardFailed: onCardFailed, backgroundColor: backgroundColor, textColor: textColor, borderColor: borderColor, cornerStyle: cornerStyle, enableSnippetRenderer: enableSnippetRenderer, showDescription: showDescription })=>{
    const hasLink = !!link;
    const hideCorner = cornerStyle === (0, $4cOi8.CornerStyle).SQUARED;
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const cardMinHeight = cardDimensions.minHeight;
    const cardMaxHeight = cardDimensions.maxHeight;
    const { setIsAvatarAvailable: setIsAvatarAvailable, setIsOwnerNameAvailable: setIsOwnerNameAvailable, setIsModifiedOnAvailable: setIsModifiedOnAvailable, setIsReactCountAvailable: setIsReactCountAvailable, setIsCommentCountAvailable: setIsCommentCountAvailable, shouldRenderOwnerInfo: shouldRenderOwnerInfo, shouldRenderMetadata: shouldRenderMetadata, shouldRenderSocials: shouldRenderSocials } = (0, $aeeaf0d423f7dea3$export$28a088c1679c6579)({
        isOwnerInfoShown: isAvatarShown && hasLink,
        isModifiedOnShown: isPublishDateShown && hasLink,
        isSocialStatsShown: isSocialStatsShown && hasLink
    });
    const { hasImage: hasImage } = (0, $jqjsu.getImageTypeToShow)({
        imageSrc: imageSrc
    });
    const { isResolved: isResolved, errorCardStatus: hasError, trackAndCategorizeError: trackAndCategorizeError, trackSuccess: trackSuccess } = (0, $aPwHF.useTrackedSmartCardState)(cardId, link, onCardSucceeded, onCardFailed);
    const { titleMaxLine: titleMaxLine, descriptionMaxLine: descriptionMaxLine } = $b85a19d2e323979a$var$getTitleDescriptionMaxLine({
        hasImage: hasImage
    });
    const cardBodyItems = hasLink ? [
        // Title
        title && /*#__PURE__*/ (0, $l998X.jsx)((0, $8b4757f8612ed1f0$export$474db65c3c394e1c), {
            maxLine: titleMaxLine,
            fontVariant: (0, $8b4757f8612ed1f0$export$6eeb615c261d1c6b).HeadingMedium,
            children: title
        }, "title"),
        // Unresolved action
        hasError && !title && !description && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            xcss: $b85a19d2e323979a$var$styles.unresolvedAction,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $3LC7V.UnresolvedAction), {})
        }, "unresolved-action"),
        // Description
        // AI snippet
        showDescription && enableSnippetRenderer && /*#__PURE__*/ (0, $l998X.jsx)("div", {
            className: (0, $gMc0m.default)([
                $b85a19d2e323979a$var$unboundedStyles.snippetOverride
            ]),
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $8zS2j.default), {
                showFooter: false,
                maxLines: descriptionMaxLine,
                text: description
            })
        }, "snippet"),
        // normal description
        showDescription && !enableSnippetRenderer && description && /*#__PURE__*/ (0, $l998X.jsx)((0, $8b4757f8612ed1f0$export$16e0ed4cb97c00d4), {
            maxLine: descriptionMaxLine,
            fontVariant: (0, $8b4757f8612ed1f0$export$6eeb615c261d1c6b).BodyLarge,
            children: description
        }, "description")
    ].filter(Boolean) : [
        // Title or placeholder
        /*#__PURE__*/ (0, $l998X.jsx)((0, $8b4757f8612ed1f0$export$474db65c3c394e1c), {
            maxLine: titleMaxLine,
            fontVariant: (0, $8b4757f8612ed1f0$export$6eeb615c261d1c6b).HeadingMedium,
            children: title || formatMessage((0, $00743a112f1453da$export$defe85febe8b728c).emptyStatePlaceholderTitle)
        }, "title"),
        // Description
        description && /*#__PURE__*/ (0, $l998X.jsx)((0, $8b4757f8612ed1f0$export$16e0ed4cb97c00d4), {
            maxLine: descriptionMaxLine,
            fontVariant: (0, $8b4757f8612ed1f0$export$6eeb615c261d1c6b).BodyLarge,
            children: description
        }, "description")
    ].filter(Boolean);
    const cardContent = /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        testId: "large-card-v2-content",
        xcss: (0, $1Whri.cx)($b85a19d2e323979a$var$styles.content, hasLink ? $b85a19d2e323979a$var$styles.static : $b85a19d2e323979a$var$styles.relative),
        style: {
            minHeight: cardMinHeight,
            maxHeight: cardMaxHeight
        },
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
            spread: "space-between",
            space: "space.200",
            grow: "fill",
            children: [
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                    space: "space.200",
                    children: [
                        hasImage && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                            xcss: (0, $1Whri.cx)(isPaddingEnabled ? $b85a19d2e323979a$var$styles.imageWithPadding : $b85a19d2e323979a$var$styles.imageNoPadding, !hideCorner && isPaddingEnabled && $b85a19d2e323979a$var$styles.imageCorner),
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $evEMm.ImageRenderer), {
                                contentId: contentId,
                                imageSrc: imageSrc,
                                imageAlt: imageAltText,
                                shouldShowExternalSiteImage: hasLink
                            })
                        }),
                        (isIconShown && hasLink || isLabelShown && !isLabelHidden) && /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                            space: "space.100",
                            alignBlock: "center",
                            xcss: (0, $1Whri.cx)(hasImage && $b85a19d2e323979a$var$styles.headerWithImage, hasImage && isPaddingEnabled && $b85a19d2e323979a$var$styles.headerWithImagePadding),
                            children: [
                                isIconShown && hasLink && /*#__PURE__*/ (0, $l998X.jsx)((0, $e0e95a63d1499075$export$69387b41dfc808f7), {
                                    link: link
                                }),
                                isLabelShown && !isLabelHidden && /*#__PURE__*/ (0, $l998X.jsx)((0, $65b0289431fea6b1$export$bc1a48e1b7ed7af), {
                                    label: label,
                                    labelColor: labelColor
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $eyWa4.default), {
                            testId: "large-card-body",
                            space: "space.100",
                            children: cardBodyItems
                        })
                    ]
                }),
                hasLink && !hasError && isResolved && (shouldRenderMetadata || shouldRenderSocials) && /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                    alignBlock: "center",
                    spread: "space-between",
                    children: [
                        shouldRenderMetadata && /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                            space: "space.050",
                            separator: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                children: "\u2022"
                            }),
                            alignBlock: "center",
                            children: [
                                shouldRenderOwnerInfo && /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                                    space: "space.050",
                                    alignBlock: "center",
                                    children: [
                                        /*#__PURE__*/ (0, $l998X.jsx)("div", {
                                            className: (0, $gMc0m.default)([
                                                $b85a19d2e323979a$var$unboundedStyles.avatar
                                            ]),
                                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $3LC7V.OwnedByGroupElement), {
                                                onRender: setIsAvatarAvailable
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $3LC7V.OwnedByElement), {
                                            color: "inherit",
                                            hideFormat: true,
                                            onRender: setIsOwnerNameAvailable
                                        })
                                    ]
                                }),
                                !!isPublishDateShown && /*#__PURE__*/ (0, $l998X.jsx)((0, $3LC7V.ModifiedOnElement), {
                                    color: "inherit",
                                    hideDatePrefix: true,
                                    onRender: setIsModifiedOnAvailable
                                })
                            ]
                        }),
                        shouldRenderSocials && /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                            space: "space.150",
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $3LC7V.ReactCountElement), {
                                    color: "inherit",
                                    onRender: setIsReactCountAvailable
                                }),
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $3LC7V.CommentCountElement), {
                                    color: "inherit",
                                    onRender: setIsCommentCountAvailable
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $875e9f2f375ca359$export$8a23e74e5cf3ca41), {
        id: "large-card-v2-container",
        isInViewMode: isInViewMode,
        cardId: cardId,
        extensionLocalId: extensionLocalId,
        isEditable: isManualVariant,
        cornerStyle: cornerStyle,
        hasLink: hasLink,
        backgroundColor: backgroundColor,
        textColor: textColor,
        borderColor: borderColor,
        children: hasLink ? /*#__PURE__*/ (0, $l998X.jsx)("div", {
            className: (0, $gMc0m.default)([
                $b85a19d2e323979a$var$unboundedStyles.smartCardWrapper
            ]),
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $9CM6e.CardSSR), {
                id: cardId,
                appearance: "inline",
                frameStyle: "show",
                ui: {
                    theme: (0, $5TXU5.SmartLinkTheme).Black,
                    clickableContainer: isInViewMode,
                    size: (0, $5TXU5.SmartLinkSize).Large,
                    removeBlockRestriction: true,
                    hideBackground: true,
                    hideElevation: true,
                    hidePadding: true,
                    enableSnippetRenderer: enableSnippetRenderer
                },
                url: link,
                onResolve: trackSuccess,
                onError: trackAndCategorizeError,
                children: cardContent
            })
        }) : cardContent
    });
};

/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");









































const $5944223131a8f0ac$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    emptyStatePlaceholderTitle: {
        id: "company-hub.card-extensions.medium-card.medium-card-v1.empty-state.title-placeholder",
        defaultMessage: "Give your card a title"
    }
});


const $39e9dc6831e8ee6a$var$unboundedStyles = {
    avatar: "_c71l1tcg _19pkmyb0 _1lplidpf _px5oidpf _m5lyidpf _1oxkidpf _18alidpf _1mxvidpf _suiuidpf _1bc3idpf _tvjiidpf _1y56idpf _rjv6idpf _mbyhidpf",
    snippetOverride: "_syaz1kw7 _5fky2smr _mavj1kw7"
};
const $39e9dc6831e8ee6a$var$styles = {
    content: "_1reo15vq _18m915vq _1e0c1txw _2lx21bp4",
    image: "_1reo15vq _18m915vq _16jlkb7n _1o9zkb7n _i0dl1wug _4t3i1osq",
    floatingIcon: "_1reoewfl _18m9ewfl _bozgpxbi _154ixmi2 _4t3iidpf _kqswh2mm",
    body: "_ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi",
    socials: "_19pk1wug",
    unresolvedAction: "_1reo15vq _18m915vq _11c82smr _1bsb1osq _1bto1l2s _syazazsu"
};
const $39e9dc6831e8ee6a$var$MIN_TITLE_LINES = 2;
const $39e9dc6831e8ee6a$var$MAX_TITLE_LINES = 5;
const $39e9dc6831e8ee6a$var$MIN_DESCRIPTION_LINES = 3;
const $39e9dc6831e8ee6a$var$MAX_DESCRIPTION_LINES = 7;
const $39e9dc6831e8ee6a$var$getTitleDescriptionMaxLine = ({ hasImage: hasImage, shouldRenderMetadata: shouldRenderMetadata, shouldRenderSocials: shouldRenderSocials })=>{
    let titleMaxLine = $39e9dc6831e8ee6a$var$MIN_TITLE_LINES;
    let descriptionMaxLine = $39e9dc6831e8ee6a$var$MIN_DESCRIPTION_LINES;
    if (!hasImage) {
        descriptionMaxLine += 2;
        titleMaxLine += 2;
        if (!shouldRenderMetadata) {
            descriptionMaxLine += 1;
            titleMaxLine += 1;
        }
        if (!shouldRenderSocials) descriptionMaxLine += 1;
    }
    if (titleMaxLine > $39e9dc6831e8ee6a$var$MAX_TITLE_LINES) titleMaxLine = $39e9dc6831e8ee6a$var$MAX_TITLE_LINES;
    if (descriptionMaxLine > $39e9dc6831e8ee6a$var$MAX_DESCRIPTION_LINES) descriptionMaxLine = $39e9dc6831e8ee6a$var$MAX_DESCRIPTION_LINES;
    return {
        titleMaxLine: titleMaxLine,
        descriptionMaxLine: descriptionMaxLine
    };
};
const $39e9dc6831e8ee6a$export$42440eb4dfc95ce7 = ({ cardDimensions: cardDimensions, cardId: cardId, link: link, isInViewMode: isInViewMode, isManualVariant: isManualVariant, extensionLocalId: extensionLocalId, imageSrc: imageSrc, imageAltText: imageAltText, contentId: contentId, title: title, description: description, showDescription: showDescription, enableSnippetRenderer: enableSnippetRenderer, isAvatarShown: isAvatarShown, isPublishDateShown: isPublishDateShown, isSocialStatsShown: isSocialStatsShown, isIconShown: isIconShown, onCardSucceeded: onCardSucceeded, onCardFailed: onCardFailed, backgroundColor: backgroundColor, textColor: textColor, cornerStyle: cornerStyle })=>{
    const hasLink = !!link;
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const cardHeight = cardDimensions.height;
    const { setIsAvatarAvailable: setIsAvatarAvailable, setIsOwnerNameAvailable: setIsOwnerNameAvailable, setIsModifiedOnAvailable: setIsModifiedOnAvailable, setIsReactCountAvailable: setIsReactCountAvailable, setIsCommentCountAvailable: setIsCommentCountAvailable, shouldRenderMetadata: shouldRenderMetadata, shouldRenderSocials: shouldRenderSocials, shouldRenderOwnerInfo: shouldRenderOwnerInfo } = (0, $aeeaf0d423f7dea3$export$28a088c1679c6579)({
        isOwnerInfoShown: isAvatarShown && hasLink,
        isModifiedOnShown: isPublishDateShown && hasLink,
        isSocialStatsShown: isSocialStatsShown && hasLink
    });
    const { hasImage: hasImage } = (0, $jqjsu.getImageTypeToShow)({
        imageSrc: imageSrc
    });
    const { isResolved: isResolved, errorCardStatus: hasError, trackAndCategorizeError: trackAndCategorizeError, trackSuccess: trackSuccess } = (0, $aPwHF.useTrackedSmartCardState)(cardId, link, onCardSucceeded, onCardFailed);
    const { titleMaxLine: titleMaxLine, descriptionMaxLine: descriptionMaxLine } = $39e9dc6831e8ee6a$var$getTitleDescriptionMaxLine({
        hasImage: hasImage,
        shouldRenderMetadata: shouldRenderMetadata,
        shouldRenderSocials: shouldRenderSocials
    });
    const cardBodyItems = hasLink ? [
        // Icon for non-image cards
        isIconShown && !hasImage && /*#__PURE__*/ (0, $l998X.jsx)((0, $e0e95a63d1499075$export$69387b41dfc808f7), {
            link: link
        }, "link-icon"),
        // Title
        title && /*#__PURE__*/ (0, $l998X.jsx)((0, $8b4757f8612ed1f0$export$474db65c3c394e1c), {
            maxLine: titleMaxLine,
            fontVariant: (0, $8b4757f8612ed1f0$export$6eeb615c261d1c6b).HeadingSmall,
            children: title
        }, "title"),
        // Unresolved action if there is error and no title and no description
        hasError && !title && !description && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            xcss: (0, $1Whri.cx)($39e9dc6831e8ee6a$var$styles.unresolvedAction),
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $3LC7V.UnresolvedAction), {})
        }, "unresolved-action"),
        // Avatar and Publish Date
        isResolved && !hasError && shouldRenderMetadata && /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
            testId: "medium-card-v1-metadata",
            space: "space.050",
            separator: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                children: "\u2022"
            }),
            alignBlock: "center",
            children: [
                shouldRenderOwnerInfo && /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                    space: "space.050",
                    alignBlock: "center",
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)("div", {
                            className: (0, $gMc0m.default)([
                                $39e9dc6831e8ee6a$var$unboundedStyles.avatar
                            ]),
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $3LC7V.OwnedByGroupElement), {
                                onRender: setIsAvatarAvailable
                            })
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $3LC7V.OwnedByElement), {
                            color: "inherit",
                            hideFormat: true,
                            onRender: setIsOwnerNameAvailable
                        })
                    ]
                }),
                !!isPublishDateShown && /*#__PURE__*/ (0, $l998X.jsx)((0, $3LC7V.ModifiedOnElement), {
                    color: "inherit",
                    hideDatePrefix: true,
                    onRender: setIsModifiedOnAvailable
                })
            ]
        }, "metadata"),
        // Description
        // AI snippet
        showDescription && enableSnippetRenderer && /*#__PURE__*/ (0, $l998X.jsx)("div", {
            className: (0, $gMc0m.default)([
                $39e9dc6831e8ee6a$var$unboundedStyles.snippetOverride
            ]),
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $8zS2j.default), {
                showFooter: false,
                maxLines: descriptionMaxLine,
                text: description
            })
        }, "snippet"),
        // normal description
        showDescription && !enableSnippetRenderer && description && /*#__PURE__*/ (0, $l998X.jsx)((0, $8b4757f8612ed1f0$export$16e0ed4cb97c00d4), {
            maxLine: descriptionMaxLine,
            fontVariant: (0, $8b4757f8612ed1f0$export$6eeb615c261d1c6b).Body,
            children: description
        }, "description"),
        // Socials
        isResolved && !hasError && shouldRenderSocials && /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
            testId: "medium-card-v1-socials",
            space: "space.150",
            xcss: $39e9dc6831e8ee6a$var$styles.socials,
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $3LC7V.ReactCountElement), {
                    color: "inherit",
                    onRender: setIsReactCountAvailable
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $3LC7V.CommentCountElement), {
                    color: "inherit",
                    onRender: setIsCommentCountAvailable
                })
            ]
        }, "socials")
    ].filter(Boolean) : [
        // Title or placeholder
        /*#__PURE__*/ (0, $l998X.jsx)((0, $8b4757f8612ed1f0$export$474db65c3c394e1c), {
            maxLine: titleMaxLine,
            fontVariant: (0, $8b4757f8612ed1f0$export$6eeb615c261d1c6b).HeadingSmall,
            children: title || formatMessage((0, $5944223131a8f0ac$export$defe85febe8b728c).emptyStatePlaceholderTitle)
        }, "title"),
        // Description
        description && /*#__PURE__*/ (0, $l998X.jsx)((0, $8b4757f8612ed1f0$export$16e0ed4cb97c00d4), {
            maxLine: descriptionMaxLine,
            fontVariant: (0, $8b4757f8612ed1f0$export$6eeb615c261d1c6b).Body,
            children: description
        }, "description")
    ].filter(Boolean);
    const cardContent = /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
        testId: "medium-card-v1-content",
        xcss: (0, $1Whri.cx)($39e9dc6831e8ee6a$var$styles.content),
        style: {
            height: cardHeight
        },
        children: [
            hasImage && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: (0, $1Whri.cx)($39e9dc6831e8ee6a$var$styles.image),
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $evEMm.ImageRenderer), {
                    contentId: contentId,
                    imageSrc: imageSrc,
                    imageAlt: imageAltText,
                    shouldShowExternalSiteImage: hasLink
                })
            }),
            isIconShown && hasLink && hasImage && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: (0, $1Whri.cx)($39e9dc6831e8ee6a$var$styles.floatingIcon),
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $e0e95a63d1499075$export$69387b41dfc808f7), {
                    link: link
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $eyWa4.default), {
                testId: "medium-card-body",
                space: "space.100",
                grow: "fill",
                xcss: (0, $1Whri.cx)($39e9dc6831e8ee6a$var$styles.body),
                children: cardBodyItems
            })
        ]
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $875e9f2f375ca359$export$8a23e74e5cf3ca41), {
        id: "medium-card-v1-container",
        cardHeight: cardHeight,
        isInViewMode: isInViewMode,
        cardId: cardId,
        extensionLocalId: extensionLocalId,
        isEditable: isManualVariant,
        cornerStyle: cornerStyle,
        hasLink: hasLink,
        backgroundColor: backgroundColor,
        textColor: textColor,
        children: hasLink ? /*#__PURE__*/ (0, $l998X.jsx)((0, $9CM6e.CardSSR), {
            id: cardId,
            appearance: "inline",
            frameStyle: "show",
            ui: {
                theme: (0, $5TXU5.SmartLinkTheme).Black,
                clickableContainer: isInViewMode,
                size: (0, $5TXU5.SmartLinkSize).Medium,
                removeBlockRestriction: true,
                hideBackground: true,
                hideElevation: true,
                hidePadding: true,
                enableSnippetRenderer: enableSnippetRenderer
            },
            url: link,
            onResolve: trackSuccess,
            onError: trackAndCategorizeError,
            children: cardContent
        }) : cardContent
    });
};

/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");











































const $18ab0b696710a1d9$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    emptyStatePlaceholderTitle: {
        id: "company-hub.card-extensions.medium-card.medium-card-v2.empty-state.title-placeholder",
        defaultMessage: "Give your card a title"
    }
});


const $10bd7f32a1f45b52$var$unboundedStyles = {
    avatar: "_c71l1tcg _1lplidpf _px5oidpf _m5lyidpf _1oxkidpf _18alidpf _1mxvidpf _suiuidpf _1bc3idpf _tvjiidpf _1y56idpf _rjv6idpf _mbyhidpf",
    snippetOverride: "_syaz1kw7 _5fky2smr _mavj1kw7",
    smartCardWrapper: "_4t3i1osq _wht71osq"
};
const $10bd7f32a1f45b52$var$styles = {
    content: "_1reo15vq _18m915vq _1e0c1txw _2lx21bp4 _4t3i1osq _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi",
    imageCorner: "_2rko1mok",
    imageWithPadding: "_1reo15vq _18m915vq _4t3iautk",
    imageNoPadding: "_1reo15vq _18m915vq _4t3i11ux _19pkmgjw _2hwxmgjw _18u0mgjw",
    headerWithImagePadding: "_ca0qu2gc _19bvu2gc",
    headerWithImage: "_1e0c1txw _kqswstnw _154ipxbi _1ltvpxbi",
    unresolvedAction: "_1reo15vq _18m915vq _11c82smr _1bsb1osq _1bto1l2s _syazazsu",
    static: "_kqswpfqs",
    relative: "_kqswh2mm"
};
const $10bd7f32a1f45b52$var$MIN_TITLE_LINES = 3;
const $10bd7f32a1f45b52$var$MIN_DESCRIPTION_LINES = 3;
const $10bd7f32a1f45b52$var$getTitleDescriptionMaxLine = ({ hasImage: hasImage })=>{
    let titleMaxLine = $10bd7f32a1f45b52$var$MIN_TITLE_LINES;
    let descriptionMaxLine = $10bd7f32a1f45b52$var$MIN_DESCRIPTION_LINES;
    if (!hasImage) {
        titleMaxLine += 1;
        descriptionMaxLine += 2;
    }
    return {
        titleMaxLine: titleMaxLine,
        descriptionMaxLine: descriptionMaxLine
    };
};
const $10bd7f32a1f45b52$export$b38e9910221b4e7e = ({ cardDimensions: cardDimensions, cardId: cardId, link: link, isInViewMode: isInViewMode, isManualVariant: isManualVariant, extensionLocalId: extensionLocalId, imageSrc: imageSrc, imageAltText: imageAltText, contentId: contentId, title: title, description: description, label: label, isLabelHidden: isLabelHidden, labelColor: labelColor, isLabelShown: isLabelShown, isPaddingEnabled: isPaddingEnabled, isAvatarShown: isAvatarShown, isPublishDateShown: isPublishDateShown, isSocialStatsShown: isSocialStatsShown, isIconShown: isIconShown, onCardSucceeded: onCardSucceeded, onCardFailed: onCardFailed, backgroundColor: backgroundColor, textColor: textColor, borderColor: borderColor, cornerStyle: cornerStyle, enableSnippetRenderer: enableSnippetRenderer, showDescription: showDescription })=>{
    const hasLink = !!link;
    const hideCorner = cornerStyle === (0, $4cOi8.CornerStyle).SQUARED;
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const cardMinHeight = cardDimensions.minHeight;
    const cardMaxHeight = cardDimensions.maxHeight;
    const { setIsAvatarAvailable: setIsAvatarAvailable, setIsModifiedOnAvailable: setIsModifiedOnAvailable, setIsReactCountAvailable: setIsReactCountAvailable, setIsCommentCountAvailable: setIsCommentCountAvailable, shouldRenderMetadata: shouldRenderMetadata, shouldRenderSocials: shouldRenderSocials, shouldRenderOwnerInfo: shouldRenderOwnerInfo } = (0, $aeeaf0d423f7dea3$export$28a088c1679c6579)({
        isOwnerInfoShown: isAvatarShown && hasLink,
        isModifiedOnShown: isPublishDateShown && hasLink,
        isSocialStatsShown: isSocialStatsShown && hasLink
    });
    const { hasImage: hasImage } = (0, $jqjsu.getImageTypeToShow)({
        imageSrc: imageSrc
    });
    const { isResolved: isResolved, errorCardStatus: hasError, trackAndCategorizeError: trackAndCategorizeError, trackSuccess: trackSuccess } = (0, $aPwHF.useTrackedSmartCardState)(cardId, link, onCardSucceeded, onCardFailed);
    const { titleMaxLine: titleMaxLine, descriptionMaxLine: descriptionMaxLine } = $10bd7f32a1f45b52$var$getTitleDescriptionMaxLine({
        hasImage: hasImage
    });
    const cardBodyItems = hasLink ? [
        // Title
        title && /*#__PURE__*/ (0, $l998X.jsx)((0, $8b4757f8612ed1f0$export$474db65c3c394e1c), {
            maxLine: titleMaxLine,
            fontVariant: (0, $8b4757f8612ed1f0$export$6eeb615c261d1c6b).HeadingSmall,
            children: title
        }, "title"),
        // Unresolved action
        hasError && !title && !description && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            xcss: $10bd7f32a1f45b52$var$styles.unresolvedAction,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $3LC7V.UnresolvedAction), {})
        }, "unresolved-action"),
        // Description
        showDescription && enableSnippetRenderer && /*#__PURE__*/ (0, $l998X.jsx)("div", {
            className: (0, $gMc0m.default)([
                $10bd7f32a1f45b52$var$unboundedStyles.snippetOverride
            ]),
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $8zS2j.default), {
                showFooter: false,
                maxLines: descriptionMaxLine,
                text: description
            })
        }, "snippet"),
        // normal description
        showDescription && !enableSnippetRenderer && description && /*#__PURE__*/ (0, $l998X.jsx)((0, $8b4757f8612ed1f0$export$16e0ed4cb97c00d4), {
            maxLine: descriptionMaxLine,
            fontVariant: (0, $8b4757f8612ed1f0$export$6eeb615c261d1c6b).Body,
            children: description
        }, "description")
    ].filter(Boolean) : [
        // Title or placeholder
        /*#__PURE__*/ (0, $l998X.jsx)((0, $8b4757f8612ed1f0$export$474db65c3c394e1c), {
            maxLine: titleMaxLine,
            fontVariant: (0, $8b4757f8612ed1f0$export$6eeb615c261d1c6b).HeadingSmall,
            children: title || formatMessage((0, $18ab0b696710a1d9$export$defe85febe8b728c).emptyStatePlaceholderTitle)
        }, "title"),
        // Description
        description && /*#__PURE__*/ (0, $l998X.jsx)((0, $8b4757f8612ed1f0$export$16e0ed4cb97c00d4), {
            maxLine: descriptionMaxLine,
            fontVariant: (0, $8b4757f8612ed1f0$export$6eeb615c261d1c6b).Body,
            children: description
        }, "description")
    ].filter(Boolean);
    const cardContent = /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        testId: "medium-card-v2-content",
        xcss: (0, $1Whri.cx)($10bd7f32a1f45b52$var$styles.content, hasLink ? $10bd7f32a1f45b52$var$styles.static : $10bd7f32a1f45b52$var$styles.relative),
        style: {
            minHeight: cardMinHeight,
            maxHeight: cardMaxHeight
        },
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
            spread: "space-between",
            space: "space.150",
            grow: "fill",
            children: [
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                    space: "space.150",
                    children: [
                        hasImage && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                            xcss: (0, $1Whri.cx)(isPaddingEnabled ? $10bd7f32a1f45b52$var$styles.imageWithPadding : $10bd7f32a1f45b52$var$styles.imageNoPadding, !hideCorner && isPaddingEnabled && $10bd7f32a1f45b52$var$styles.imageCorner),
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $evEMm.ImageRenderer), {
                                contentId: contentId,
                                imageSrc: imageSrc,
                                imageAlt: imageAltText,
                                shouldShowExternalSiteImage: hasLink
                            })
                        }),
                        (isIconShown && hasLink || isLabelShown && !isLabelHidden) && /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                            space: "space.100",
                            alignBlock: "center",
                            xcss: (0, $1Whri.cx)(hasImage && $10bd7f32a1f45b52$var$styles.headerWithImage, hasImage && isPaddingEnabled && $10bd7f32a1f45b52$var$styles.headerWithImagePadding),
                            children: [
                                isIconShown && hasLink && /*#__PURE__*/ (0, $l998X.jsx)((0, $e0e95a63d1499075$export$69387b41dfc808f7), {
                                    link: link
                                }),
                                isLabelShown && !isLabelHidden && /*#__PURE__*/ (0, $l998X.jsx)((0, $65b0289431fea6b1$export$bc1a48e1b7ed7af), {
                                    label: label,
                                    labelColor: labelColor
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $eyWa4.default), {
                            testId: "medium-card-body",
                            space: "space.100",
                            children: cardBodyItems
                        })
                    ]
                }),
                hasLink && !hasError && isResolved && (shouldRenderMetadata || shouldRenderSocials) && /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                    alignBlock: "center",
                    spread: "space-between",
                    children: [
                        shouldRenderMetadata && /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                            space: "space.050",
                            alignBlock: "center",
                            children: [
                                shouldRenderOwnerInfo && /*#__PURE__*/ (0, $l998X.jsx)("div", {
                                    className: (0, $gMc0m.default)([
                                        $10bd7f32a1f45b52$var$unboundedStyles.avatar
                                    ]),
                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $3LC7V.OwnedByGroupElement), {
                                        onRender: setIsAvatarAvailable
                                    })
                                }),
                                !!isPublishDateShown && /*#__PURE__*/ (0, $l998X.jsx)((0, $3LC7V.ModifiedOnElement), {
                                    color: "inherit",
                                    hideDatePrefix: true,
                                    onRender: setIsModifiedOnAvailable
                                })
                            ]
                        }),
                        shouldRenderSocials && /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                            space: "space.150",
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $3LC7V.ReactCountElement), {
                                    color: "inherit",
                                    onRender: setIsReactCountAvailable
                                }),
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $3LC7V.CommentCountElement), {
                                    color: "inherit",
                                    onRender: setIsCommentCountAvailable
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $875e9f2f375ca359$export$8a23e74e5cf3ca41), {
        id: "medium-card-v2-container",
        isInViewMode: isInViewMode,
        cardId: cardId,
        extensionLocalId: extensionLocalId,
        isEditable: isManualVariant,
        cornerStyle: cornerStyle,
        hasLink: hasLink,
        backgroundColor: backgroundColor,
        textColor: textColor,
        borderColor: borderColor,
        children: hasLink ? /*#__PURE__*/ (0, $l998X.jsx)("div", {
            className: (0, $gMc0m.default)([
                $10bd7f32a1f45b52$var$unboundedStyles.smartCardWrapper
            ]),
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $9CM6e.CardSSR), {
                id: cardId,
                appearance: "inline",
                frameStyle: "show",
                ui: {
                    theme: (0, $5TXU5.SmartLinkTheme).Black,
                    clickableContainer: isInViewMode,
                    size: (0, $5TXU5.SmartLinkSize).Medium,
                    removeBlockRestriction: true,
                    hideBackground: true,
                    hideElevation: true,
                    hidePadding: true,
                    enableSnippetRenderer: enableSnippetRenderer
                },
                url: link,
                onResolve: trackSuccess,
                onError: trackAndCategorizeError,
                children: cardContent
            })
        }) : cardContent
    });
};

/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");






































const $9ab81816b1253ab1$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    emptyStatePlaceholderTitle: {
        id: "company-hub.card-extensions.small-card.small-card-v1.empty-state.title-placeholder",
        defaultMessage: "Give your card a title"
    }
});


const $a9e75a3820d58e12$var$unboundedStyles = {
    content: "_1reo15vq _18m915vq _1e0c1txw _2lx2vrvc _4cvrv2br",
    avatar: "_c71l1tcg _19pkmyb0 _1lplidpf _px5oidpf _m5lyidpf _1oxkidpf _18alidpf _1mxvidpf _suiuidpf _1bc3idpf _tvjiidpf _1y56idpf _rjv6idpf _mbyhidpf"
};
const $a9e75a3820d58e12$var$styles = {
    body: "_1reo15vq _18m915vq _ca0qu2gc _n3tdu2gc _4t3i1osq",
    bodyWithImage: "_16jlidpf _1o9zidpf _i0dl1wug _19bvu2gc _u5f3u2gc _p12fif8e _1e0c1txw",
    bodyWithoutImage: "_19bvpxbi _u5f3pxbi",
    image: "_1reo15vq _18m915vq _16jlkb7n _1o9zkb7n _i0dli9or _4t3i1osq _p12fi9or _1e0c1txw",
    unresolvedAction: "_1reo15vq _18m915vq _11c82smr _1bsb1osq _1bto1l2s _syazazsu"
};
const $a9e75a3820d58e12$export$5c35843a47cb7bc4 = ({ cardDimensions: cardDimensions, cardId: cardId, link: link, title: title, imageSrc: imageSrc, isAvatarShown: isAvatarShown, isPublishDateShown: isPublishDateShown, isInViewMode: isInViewMode, imageAltText: imageAltText, contentId: contentId, isManualVariant: isManualVariant, extensionLocalId: extensionLocalId, onCardSucceeded: onCardSucceeded, onCardFailed: onCardFailed, backgroundColor: backgroundColor, textColor: textColor, cornerStyle: cornerStyle })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const cardHeight = cardDimensions.height;
    const hasLink = !!link;
    const { errorCardStatus: hasError, trackAndCategorizeError: trackAndCategorizeError, trackSuccess: trackSuccess, isResolved: isResolved } = (0, $aPwHF.useTrackedSmartCardState)(cardId, link, onCardSucceeded, onCardFailed);
    const { setIsAvatarAvailable: setIsAvatarAvailable, setIsModifiedOnAvailable: setIsModifiedOnAvailable, shouldRenderMetadata: shouldRenderMetadata, shouldRenderOwnerInfo: shouldRenderOwnerInfo } = (0, $aeeaf0d423f7dea3$export$28a088c1679c6579)({
        isOwnerInfoShown: isAvatarShown && hasLink,
        isModifiedOnShown: isPublishDateShown && hasLink
    });
    const { hasImage: hasImage } = (0, $jqjsu.getImageTypeToShow)({
        imageSrc: imageSrc
    });
    const cardBodyItem = hasLink ? [
        title && /*#__PURE__*/ (0, $l998X.jsx)((0, $8b4757f8612ed1f0$export$474db65c3c394e1c), {
            maxLine: shouldRenderMetadata ? 2 : 3,
            fontVariant: (0, $8b4757f8612ed1f0$export$6eeb615c261d1c6b).HeadingXSmall,
            children: title
        }, "title"),
        hasError && !title && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            xcss: (0, $1Whri.cx)($a9e75a3820d58e12$var$styles.unresolvedAction),
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $3LC7V.UnresolvedAction), {})
        }, "unresolved-action"),
        isResolved && !hasError && shouldRenderMetadata && /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
            testId: "small-card-v1-metadata",
            space: "space.050",
            alignBlock: "center",
            children: [
                shouldRenderOwnerInfo && /*#__PURE__*/ (0, $l998X.jsx)("div", {
                    className: (0, $gMc0m.default)([
                        $a9e75a3820d58e12$var$unboundedStyles.avatar
                    ]),
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $3LC7V.OwnedByGroupElement), {
                        onRender: setIsAvatarAvailable
                    })
                }),
                !!isPublishDateShown && /*#__PURE__*/ (0, $l998X.jsx)((0, $3LC7V.ModifiedOnElement), {
                    color: "inherit",
                    onRender: setIsModifiedOnAvailable
                })
            ]
        }, "metadata")
    ].filter(Boolean) : [
        /*#__PURE__*/ (0, $l998X.jsx)((0, $8b4757f8612ed1f0$export$474db65c3c394e1c), {
            maxLine: 3,
            fontVariant: (0, $8b4757f8612ed1f0$export$6eeb615c261d1c6b).HeadingXSmall,
            children: title || formatMessage((0, $9ab81816b1253ab1$export$defe85febe8b728c).emptyStatePlaceholderTitle)
        }, "title")
    ].filter(Boolean);
    const cardContent = /*#__PURE__*/ (0, $l998X.jsxs)("div", {
        "data-testid": "small-card-content",
        style: {
            height: cardHeight
        },
        className: (0, $gMc0m.default)([
            $a9e75a3820d58e12$var$unboundedStyles.content
        ]),
        children: [
            hasImage && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: (0, $1Whri.cx)($a9e75a3820d58e12$var$styles.image),
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $evEMm.ImageRenderer), {
                    contentId: contentId,
                    imageSrc: imageSrc,
                    imageAlt: imageAltText,
                    shouldShowExternalSiteImage: hasLink
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $eyWa4.default), {
                testId: "small-card-body",
                space: "space.100",
                xcss: (0, $1Whri.cx)($a9e75a3820d58e12$var$styles.body, hasImage && $a9e75a3820d58e12$var$styles.bodyWithImage, !hasImage && $a9e75a3820d58e12$var$styles.bodyWithoutImage),
                alignBlock: "center",
                alignInline: "start",
                children: cardBodyItem
            })
        ]
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $875e9f2f375ca359$export$8a23e74e5cf3ca41), {
        id: "small-card-v1-container",
        cardHeight: cardHeight,
        isInViewMode: isInViewMode,
        cardId: cardId,
        extensionLocalId: extensionLocalId,
        isEditable: isManualVariant,
        cornerStyle: cornerStyle,
        hasLink: hasLink,
        backgroundColor: backgroundColor,
        textColor: textColor,
        children: hasLink ? /*#__PURE__*/ (0, $l998X.jsx)((0, $9CM6e.CardSSR), {
            id: cardId,
            appearance: "inline",
            frameStyle: "show",
            ui: {
                theme: (0, $5TXU5.SmartLinkTheme).Black,
                clickableContainer: isInViewMode,
                size: (0, $5TXU5.SmartLinkSize).Large,
                removeBlockRestriction: true,
                hideBackground: true,
                hideElevation: true,
                hidePadding: true
            },
            url: link,
            onResolve: trackSuccess,
            onError: trackAndCategorizeError,
            children: cardContent
        }) : cardContent
    });
};


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");





var $2R1C4 = parcelRequire("2R1C4");



var $1lLfV = parcelRequire("1lLfV");

var $Y5kOr = parcelRequire("Y5kOr");



var $5znEc = parcelRequire("5znEc");




/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 








var $7sObp = parcelRequire("7sObp");

const $803bff8a67e38d1e$var$commonSmartlinkOverrideStyles = null;
const $803bff8a67e38d1e$export$79272b9cdf6f42c6 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isInViewMode: isInViewMode, isEmptyCard: isEmptyCard, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_idxo15vq _1wrb15vq _t1vnglyw _of44t7xp _g6c7usvi _gwatidpf _1h8x1osq _1gpskb7n _9u4k1osq",
            __cmplp.isInViewMode && !__cmplp.isEmptyCard && "_1yg71fz5 _1dahtlke",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $803bff8a67e38d1e$export$52c1c6df1826ade4 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { hasImage: hasImage, cardHeight: cardHeight, isAvatarShown: isAvatarShown, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1q98mt3": (0, $7sObp.default)(`${__cmplp.cardHeight}px`)
        },
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1waj1b66 _qa7n1rpy _1lxuze3t _14mpe23w _mxl91h6o _bkxmidpf _1ameidpf _1obgb3bt _10j7ze3t _1662ewfl _1usmewfl",
            __cmplp.size === 'small' && __cmplp.hasImage && "_kybk1epz _4oi1u2gc",
            !__cmplp.hasImage && "_1m341txw",
            __cmplp.size === 'small' && "_vuqxt9kd",
            !__cmplp.hasImage && !__cmplp.isAvatarShown ? "_1rx611wp" : "_1rx6cs5v",
            __cmplp.className
        ])
    });
});





var $kHNfU = parcelRequire("kHNfU");









parcelRequire("42omo");








var $inPa6 = parcelRequire("inPa6");


var $89YPL = parcelRequire("89YPL");


var $kcoxM = parcelRequire("kcoxM");

/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");










var $eEA8O = parcelRequire("eEA8O");





var $abC4X = parcelRequire("abC4X");


var $gj7hi = parcelRequire("gj7hi");




const $2c721071cf26e09f$var$unboundedStyles = {
    container: "_1reo15vq _18m915vq _2rko1mok _1e0c1txw _4cvr1h6o _1bah1h6o _16qst7xp _bfhk1j9a",
    viewMode: "_1dbz1fz5 _d0altlke"
};
const $2c721071cf26e09f$var$styles = {
    subheading: "_11c82smr _18zr1ejb _syaz1rpy _otyrpxbi"
};
const $2c721071cf26e09f$export$c1ed4f415b9e7023 = ({ itemId: itemId, heading: heading, description: description, primaryAction: primaryAction, image: image, itemHeight: itemHeight, link: link, isInViewMode: isInViewMode })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const ErrorContent = ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $abC4X.default), {
            header: formatMessage(heading),
            description: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: (0, $1Whri.cx)($2c721071cf26e09f$var$styles.subheading),
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                    ...description
                })
            }),
            primaryAction: !!primaryAction && /*#__PURE__*/ (0, $l998X.jsx)((0, $eEA8O.default), {
                href: link,
                target: "_blank",
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                    ...primaryAction
                })
            }),
            renderImage: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gj7hi.default), {
                    src: image,
                    alt: formatMessage(heading)
                })
        });
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        id: itemId,
        style: {
            height: itemHeight
        },
        className: (0, $gMc0m.default)([
            $2c721071cf26e09f$var$unboundedStyles.container,
            isInViewMode && $2c721071cf26e09f$var$unboundedStyles.viewMode
        ]),
        children: /*#__PURE__*/ (0, $l998X.jsx)(ErrorContent, {})
    });
};


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");




/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");














var $auNCB = parcelRequire("auNCB");





const $379eeb186b27b9ed$var$unboundedStyles = {
    container: "_1reo15vq _18m915vq _1e0c1txw _bfhk1j9a _4t3i1osq _1bsb1osq",
    image: "_bfhkysee"
};
const $379eeb186b27b9ed$var$styles = {
    body: "_11c82smr _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi",
    link: "_syazazsu"
};
const $379eeb186b27b9ed$export$6367f02d838ccaa1 = ({ image: image, heading: heading, subheading: subheading, link: link, hideLink: hideLink })=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)("div", {
        className: (0, $gMc0m.default)([
            $379eeb186b27b9ed$var$unboundedStyles.container
        ]),
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gj7hi.default), {
                src: image,
                alt: "",
                className: (0, $gMc0m.default)([
                    $379eeb186b27b9ed$var$unboundedStyles.image
                ])
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                xcss: (0, $1Whri.cx)($379eeb186b27b9ed$var$styles.body),
                alignBlock: "center",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                        weight: "medium",
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                            ...heading
                        })
                    }),
                    !!subheading && !hideLink && /*#__PURE__*/ (0, $l998X.jsx)((0, $auNCB.default), {
                        href: link || '#',
                        target: "_blank",
                        xcss: (0, $1Whri.cx)($379eeb186b27b9ed$var$styles.link),
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                            ...subheading
                        })
                    })
                ]
            })
        ]
    });
};


const $0e14524e6cd9583a$var$styles = {
    container: "_1reo15vq _18m915vq _2rko1mok _16qst7xp",
    viewMode: "_1dbz1fz5 _d0altlke"
};
const $0e14524e6cd9583a$export$3034fb223b2850b6 = ({ itemId: itemId, height: height, isInViewMode: isInViewMode, ...props })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        "data-testid": "small-card-error-state",
        id: itemId,
        style: {
            height: height
        },
        className: (0, $gMc0m.default)([
            $0e14524e6cd9583a$var$styles.container,
            isInViewMode && $0e14524e6cd9583a$var$styles.viewMode
        ]),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $379eeb186b27b9ed$export$6367f02d838ccaa1), {
            ...props
        })
    });
};





const $760353e303a2e46b$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    noResults: {
        id: "company-hub.cards-extension.link-cards-content.card-components.error-states.no-results.header",
        defaultMessage: "We can\u2019t show you this content"
    },
    noResultsDescription: {
        id: "company-hub.cards-extension.link-cards-content.card-components.error-states.no-results.description",
        defaultMessage: "The content doesn\u2019t exist or it may have changed after this link was added"
    }
});


const $631874ee49f29a59$export$ef6006467f04ee41 = ({ cardId: cardId, cardSize: cardSize, cardHeight: cardHeight, isInViewMode: isInViewMode, errorStatus: errorStatus })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                source: (0, $kcoxM.CARDS_EXTENSION_ANALYTIC_SOURCE),
                action: 'error',
                actionSubject: 'noResult',
                attributes: {
                    extensionType: (0, $kcoxM.CARDS_EXTENSION_TYPE),
                    error: errorStatus,
                    isInViewMode: isInViewMode
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        errorStatus,
        isInViewMode
    ]);
    switch(cardSize){
        case 'small':
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $0e14524e6cd9583a$export$3034fb223b2850b6), {
                itemId: cardId,
                image: (0, (/*@__PURE__*/$parcel$interopDefault($89YPL))),
                heading: (0, $760353e303a2e46b$export$defe85febe8b728c).noResults,
                height: cardHeight,
                isInViewMode: isInViewMode
            });
        default:
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $2c721071cf26e09f$export$c1ed4f415b9e7023), {
                itemId: cardId,
                heading: (0, $760353e303a2e46b$export$defe85febe8b728c).noResults,
                description: (0, $760353e303a2e46b$export$defe85febe8b728c).noResultsDescription,
                image: (0, (/*@__PURE__*/$parcel$interopDefault($89YPL))),
                itemHeight: cardHeight,
                isInViewMode: isInViewMode
            });
    }
};











var $1624b1ead62161ba$exports = {};
$1624b1ead62161ba$exports = new URL("RestrictedContent.b8a54c0d.svg", import.meta.url).toString();










const $9de325cf4a898686$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    restrictedContent: {
        id: "company-hub.cards-extension.link-cards-content.card-components.error-states.restricted-content.header",
        defaultMessage: "Restricted content"
    },
    restrictedContentDescription: {
        id: "company-hub.cards-extension.link-cards-content.card-components.error-states.restricted-content.description",
        defaultMessage: "You\u2019ll need to request access or try another account to view this preview"
    },
    restrictedContentButtonLabel: {
        id: "company-hub.cards-extension.link-cards-content.card-components.error-states.restricted-content.button.label",
        defaultMessage: "Request access"
    }
});


const $b1a6f938c61a1a59$export$8e5bf480efc2e158 = ({ cardId: cardId, cardSize: cardSize, cardHeight: cardHeight, link: link, isInViewMode: isInViewMode, errorStatus: errorStatus })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                source: (0, $kcoxM.CARDS_EXTENSION_ANALYTIC_SOURCE),
                action: 'error',
                actionSubject: 'restricted',
                attributes: {
                    extensionType: (0, $kcoxM.CARDS_EXTENSION_TYPE),
                    error: errorStatus,
                    isInViewMode: isInViewMode
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        errorStatus,
        isInViewMode
    ]);
    switch(cardSize){
        case 'small':
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $0e14524e6cd9583a$export$3034fb223b2850b6), {
                itemId: cardId,
                link: link,
                image: (0, (/*@__PURE__*/$parcel$interopDefault($1624b1ead62161ba$exports))),
                heading: (0, $9de325cf4a898686$export$defe85febe8b728c).restrictedContent,
                subheading: (0, $9de325cf4a898686$export$defe85febe8b728c).restrictedContentButtonLabel,
                height: cardHeight,
                isInViewMode: isInViewMode
            });
        default:
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $2c721071cf26e09f$export$c1ed4f415b9e7023), {
                itemId: cardId,
                link: link,
                heading: (0, $9de325cf4a898686$export$defe85febe8b728c).restrictedContent,
                description: (0, $9de325cf4a898686$export$defe85febe8b728c).restrictedContentDescription,
                primaryAction: (0, $9de325cf4a898686$export$defe85febe8b728c).restrictedContentButtonLabel,
                image: (0, (/*@__PURE__*/$parcel$interopDefault($1624b1ead62161ba$exports))),
                itemHeight: cardHeight,
                isInViewMode: isInViewMode
            });
    }
};


const $d05619b686658084$export$2ebec9f03312245c = ({ link: link, isRestricted: isRestricted, isNoResult: isNoResult, ...erroredStatePassThroughProps })=>{
    if (isRestricted) return /*#__PURE__*/ (0, $l998X.jsx)((0, $b1a6f938c61a1a59$export$8e5bf480efc2e158), {
        link: link,
        ...erroredStatePassThroughProps
    });
    if (isNoResult) return /*#__PURE__*/ (0, $l998X.jsx)((0, $631874ee49f29a59$export$ef6006467f04ee41), {
        ...erroredStatePassThroughProps
    });
    return null;
};


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766











const $cdbcd38ab25f57db$export$d624bf5dd0929a12 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { cardHeight: cardHeight, hasImage: hasImage, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1q98mt3": (0, $7sObp.default)(`${__cmplp.cardHeight}px`)
        },
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_5g5hu2gc _14mpe23w _mxl91h6o _bo1mewfl _3bgyewfl _w062tcjq _1vzx1txw _uiwdu2gc _1obgb3bt",
            !__cmplp.hasImage ? "_vyla11wp" : "_vylacs5v",
            __cmplp.className
        ])
    });
});


const $055913a6dde137c8$var$titleBlockUnauthorizedStyles = null;
const $055913a6dde137c8$var$titleBlockHideUnauthorizedStyles = null;
const $055913a6dde137c8$var$titleBlockStyles = null;
const $055913a6dde137c8$var$customImageUploadStyles = null;
const $055913a6dde137c8$var$floatingEmojiStyles = null;
const $055913a6dde137c8$export$9f4f09e26cb56ad5 = ({ contentId: contentId, cardId: cardId, link: link, title: title, imageSrc: imageSrc, cardDimensions: cardDimensions, isAvatarShown: isAvatarShown, isPublishDateShown: isPublishDateShown, description: description, isInViewMode: isInViewMode, onCardSucceeded: onCardSucceeded, onCardFailed: onCardFailed, imageAltText: imageAltText, enableSnippetRenderer: enableSnippetRenderer, showDescription: showDescription, ...analyticsPassThroughProps })=>{
    const { errorCardStatus: errorCardStatus, isNoResult: isNoResult, isRestricted: isRestricted, isUnauthorized: isUnauthorized, trackAndCategorizeError: trackAndCategorizeError, trackSuccess: trackSuccess } = (0, $aPwHF.useTrackedSmartCardState)(cardId, link, onCardSucceeded, onCardFailed);
    const cardHeight = cardDimensions.height;
    const { emojiId: emojiId } = (0, $9e2ac3240ff02a0e$export$6ed6867e3290476)(link);
    const { showUnsplashImage: showUnsplashImage, showExternalSiteImage: showExternalSiteImage, showCustomUploadedImage: showCustomUploadedImage, hasImage: hasImage } = (0, $jqjsu.getImageTypeToShow)({
        imageSrc: imageSrc
    });
    const showCustomTitleUnauthed = isUnauthorized && !!title;
    const showCustomDescUnauthed = isUnauthorized && !!description;
    const showSnippet = (!isUnauthorized || showCustomDescUnauthed) && showDescription;
    if (isRestricted || isNoResult) return /*#__PURE__*/ (0, $l998X.jsx)((0, $d05619b686658084$export$2ebec9f03312245c), {
        isRestricted: isRestricted,
        isNoResult: isNoResult,
        link: link,
        cardId: cardId,
        cardSize: (0, $4cOi8.Height).LARGE,
        cardHeight: cardHeight,
        isInViewMode: isInViewMode,
        errorStatus: errorCardStatus,
        ...analyticsPassThroughProps
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $803bff8a67e38d1e$export$79272b9cdf6f42c6), {
        isInViewMode: isInViewMode,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $cdbcd38ab25f57db$export$d624bf5dd0929a12), {
            cardHeight: cardHeight,
            isLargeCard: true,
            hasImage: hasImage,
            children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $9CM6e.CardSSR), {
                id: cardId,
                appearance: "inline",
                frameStyle: "show",
                platform: "web",
                ui: {
                    theme: (0, $5TXU5.SmartLinkTheme).Black,
                    clickableContainer: isInViewMode,
                    size: (0, $5TXU5.SmartLinkSize).XLarge,
                    enableSnippetRenderer: enableSnippetRenderer
                },
                url: link,
                onResolve: trackSuccess,
                onError: trackAndCategorizeError,
                children: [
                    (showUnsplashImage || showExternalSiteImage) && /*#__PURE__*/ (0, $l998X.jsx)((0, $Y5kOr.default), {
                        ignoreContainerPadding: true,
                        overrideUrl: imageSrc
                    }),
                    showCustomUploadedImage && /*#__PURE__*/ (0, $l998X.jsx)((0, $2R1C4.default), {
                        className: (0, $gMc0m.default)([
                            "_18u01ivi _2hwxc10g _e0oi1ya9 _dmhj1ya9"
                        ]),
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $kHNfU.CustomImageUploadRenderer), {
                            contentId: contentId,
                            imageSrc: imageSrc,
                            imageAltText: imageAltText,
                            shouldShowErrorMessage: true
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $2R1C4.default), {
                        testId: "smart-block-link-card-emoji-container",
                        className: (0, $gMc0m.default)([
                            "_1reoewfl _18m9ewfl _kqswh2mm _154ixmi2 _94n5v77o _4t3iidpf"
                        ]),
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $89b35c68973ec39a$export$56e4c85b6a8d02e6), {
                            emojiId: emojiId
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $5znEc.default), {
                        hideIcon: true,
                        metadata: !!isAvatarShown ? [
                            {
                                name: (0, $5TXU5.ElementName).OwnedByGroup
                            }
                        ] : [],
                        text: title,
                        size: (0, $5TXU5.SmartLinkSize).XLarge,
                        anchorTarget: "_self",
                        className: (0, $gMc0m.default)([
                            "_19pku2gc _59381r31 _7hxb1r31 _9m7f1r31 _rfqo1r31 _qfs11r31 _yha2glyw _15zvglyw _w7swglyw _1bgkglyw _s41oglyw _1nmznqa1 _1xvinqa1 _15a9nqa1 _1t0pnqa1 _1k6pnqa1 _ru7v1wug _1b7m1wug _675q1wug _fn1s1wug _d6hs1wug _zh3r1wq8 _18pri7uo _2ax2idpf",
                            showCustomTitleUnauthed && "_4l6lglyw",
                            !showCustomTitleUnauthed && isUnauthorized && "_1pbykb7n _1o7bglyw"
                        ])
                    }),
                    !!isPublishDateShown && /*#__PURE__*/ (0, $l998X.jsx)((0, $1lLfV.default), {
                        primary: [
                            {
                                name: (0, $5TXU5.ElementName).ModifiedOn
                            }
                        ]
                    }),
                    showSnippet && /*#__PURE__*/ (0, $l998X.jsx)((0, $8zS2j.default), {
                        text: description,
                        showFooter: false,
                        maxLines: hasImage ? 3 : 6
                    })
                ]
            })
        })
    });
};


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");










var $1s5hv = parcelRequire("1s5hv");



const $45d43eb27f87e375$var$placeholderBackgroundColor = "var(--ds-background-accent-gray-subtlest, #F0F1F2)";
const $45d43eb27f87e375$var$legacyContainer = null;
const $45d43eb27f87e375$var$styles = {
    content: "_4t3i1osq",
    image: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1tkeidpf _bfhkysee",
    blockText: "_ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi",
    title: "_1bsb12am",
    publishedDate: "_1bsb1osq",
    descriptionFirstLine: "_1bsbuuw1",
    descriptionSecondLine: "_1bsb1178",
    itemCommon: "_4t3iftgi _bfhkysee"
};
const $45d43eb27f87e375$export$cac86eeab61c4c13 = ({ cardDimensions: cardDimensions })=>{
    const cardHeight = cardDimensions.height;
    const Content = ()=>/*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
            direction: "column",
            xcss: $45d43eb27f87e375$var$styles.content,
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    xcss: $45d43eb27f87e375$var$styles.image
                }),
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                    space: "space.075",
                    xcss: $45d43eb27f87e375$var$styles.blockText,
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                            xcss: (0, $1Whri.cx)($45d43eb27f87e375$var$styles.title, $45d43eb27f87e375$var$styles.itemCommon)
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                            xcss: (0, $1Whri.cx)($45d43eb27f87e375$var$styles.publishedDate, $45d43eb27f87e375$var$styles.itemCommon)
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                            xcss: (0, $1Whri.cx)($45d43eb27f87e375$var$styles.descriptionFirstLine, $45d43eb27f87e375$var$styles.itemCommon)
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                            xcss: (0, $1Whri.cx)($45d43eb27f87e375$var$styles.descriptionSecondLine, $45d43eb27f87e375$var$styles.itemCommon)
                        })
                    ]
                })
            ]
        });
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        "data-testId": "large-placeholder-card",
        style: {
            height: cardHeight
        },
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _2rko1mok _189ee4h9 _1h6d1l7x _1dqonqa1 _4t3i1osq"
        ]),
        children: /*#__PURE__*/ (0, $l998X.jsx)(Content, {})
    });
};


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");

































const $e01621b352de0025$var$titleBlockUnauthorizedStyles = null;
const $e01621b352de0025$var$titleBlockHideUnauthorizedStyles = null;
const $e01621b352de0025$var$titleBlockStyles = null;
const $e01621b352de0025$var$customImageUploadStyles = null;
const $e01621b352de0025$var$floatingEmojiStyles = null;
const $e01621b352de0025$export$fa129874a526090 = ({ contentId: contentId, cardId: cardId, link: link, title: title, imageSrc: imageSrc, cardDimensions: cardDimensions, isAvatarShown: isAvatarShown, isPublishDateShown: isPublishDateShown, description: description, isInViewMode: isInViewMode, onCardSucceeded: onCardSucceeded, onCardFailed: onCardFailed, imageAltText: imageAltText, enableSnippetRenderer: enableSnippetRenderer, showDescription: showDescription, ...analyticsPassThroughProps })=>{
    const cardHeight = cardDimensions.height;
    const { errorCardStatus: errorCardStatus, isNoResult: isNoResult, isRestricted: isRestricted, isUnauthorized: isUnauthorized, trackAndCategorizeError: trackAndCategorizeError, trackSuccess: trackSuccess } = (0, $aPwHF.useTrackedSmartCardState)(cardId, link, onCardSucceeded, onCardFailed);
    const { emojiId: emojiId } = (0, $9e2ac3240ff02a0e$export$6ed6867e3290476)(link);
    const { showUnsplashImage: showUnsplashImage, showExternalSiteImage: showExternalSiteImage, showCustomUploadedImage: showCustomUploadedImage, hasImage: hasImage } = (0, $jqjsu.getImageTypeToShow)({
        imageSrc: imageSrc
    });
    const showCustomTitleUnauthed = isUnauthorized && !!title;
    const showCustomDescUnauthed = isUnauthorized && !!description;
    const showSnippet = (!isUnauthorized || showCustomDescUnauthed) && showDescription;
    if (isRestricted || isNoResult) return /*#__PURE__*/ (0, $l998X.jsx)((0, $d05619b686658084$export$2ebec9f03312245c), {
        isRestricted: isRestricted,
        isNoResult: isNoResult,
        link: link,
        cardId: cardId,
        cardSize: (0, $4cOi8.Height).MEDIUM,
        cardHeight: cardHeight,
        isInViewMode: isInViewMode,
        errorStatus: errorCardStatus,
        ...analyticsPassThroughProps
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $803bff8a67e38d1e$export$79272b9cdf6f42c6), {
        isInViewMode: isInViewMode,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $cdbcd38ab25f57db$export$d624bf5dd0929a12), {
            cardHeight: cardHeight,
            hasImage: hasImage,
            children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $9CM6e.CardSSR), {
                id: cardId,
                appearance: "inline",
                frameStyle: "show",
                platform: "web",
                ui: {
                    theme: (0, $5TXU5.SmartLinkTheme).Black,
                    clickableContainer: isInViewMode,
                    size: (0, $5TXU5.SmartLinkSize).Medium,
                    enableSnippetRenderer: enableSnippetRenderer
                },
                url: link,
                onResolve: trackSuccess,
                onError: trackAndCategorizeError,
                children: [
                    (showUnsplashImage || showExternalSiteImage) && /*#__PURE__*/ (0, $l998X.jsx)((0, $Y5kOr.default), {
                        ignoreContainerPadding: true,
                        overrideUrl: imageSrc
                    }),
                    showCustomUploadedImage && /*#__PURE__*/ (0, $l998X.jsx)((0, $2R1C4.default), {
                        className: (0, $gMc0m.default)([
                            "_18u01ivi _2hwxc10g _e0oi1ya9 _dmhj1ya9"
                        ]),
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $kHNfU.CustomImageUploadRenderer), {
                            contentId: contentId,
                            imageSrc: imageSrc,
                            imageAltText: imageAltText,
                            shouldShowErrorMessage: true
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $2R1C4.default), {
                        testId: "smart-block-link-card-emoji-container",
                        className: (0, $gMc0m.default)([
                            "_1reoewfl _18m9ewfl _kqswh2mm _154ixmi2 _94n5v77o _4t3iidpf"
                        ]),
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $89b35c68973ec39a$export$56e4c85b6a8d02e6), {
                            emojiId: emojiId
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $5znEc.default), {
                        hideIcon: true,
                        metadata: !!isAvatarShown ? [
                            {
                                name: (0, $5TXU5.ElementName).OwnedByGroup
                            }
                        ] : [],
                        text: title,
                        anchorTarget: "_self",
                        className: (0, $gMc0m.default)([
                            "_19pku2gc _59381r31 _7hxb1r31 _9m7f1r31 _rfqo1r31 _qfs11r31 _yha2glyw _15zvglyw _w7swglyw _1bgkglyw _s41oglyw _1nmznqa1 _1xvinqa1 _15a9nqa1 _1t0pnqa1 _1k6pnqa1 _ru7v1wug _1b7m1wug _675q1wug _fn1s1wug _d6hs1wug _zh3r1wq8 _18pri7uo _2ax2idpf",
                            showCustomTitleUnauthed && "_4l6lglyw",
                            !showCustomTitleUnauthed && isUnauthorized && "_1pbykb7n _1o7bglyw"
                        ])
                    }),
                    !!isPublishDateShown && /*#__PURE__*/ (0, $l998X.jsx)((0, $1lLfV.default), {
                        primary: [
                            {
                                name: (0, $5TXU5.ElementName).ModifiedOn
                            }
                        ]
                    }),
                    showSnippet && /*#__PURE__*/ (0, $l998X.jsx)((0, $8zS2j.default), {
                        text: description,
                        showFooter: false,
                        maxLines: hasImage ? 3 : 6
                    })
                ]
            })
        })
    });
};


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");














const $6f7cc468af0ca045$var$placeholderBackgroundColor = "var(--ds-background-accent-gray-subtlest, #F0F1F2)";
const $6f7cc468af0ca045$var$legacyContainer = null;
const $6f7cc468af0ca045$var$styles = {
    content: "_4t3i1osq",
    image: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1tkeidpf _bfhkysee",
    blockText: "_ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi",
    title: "_1bsbldb6",
    publishedDate: "_1bsbuuw1",
    descriptionFirstLine: "_1bsbs0l4",
    descriptionSecondLine: "_1bsb1ame",
    itemCommon: "_4t3iftgi _bfhkysee"
};
const $6f7cc468af0ca045$export$dd85cb3a0f399702 = ({ cardDimensions: cardDimensions })=>{
    const cardHeight = cardDimensions.height;
    const Content = ()=>/*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
            direction: "column",
            xcss: $6f7cc468af0ca045$var$styles.content,
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    xcss: $6f7cc468af0ca045$var$styles.image
                }),
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                    space: "space.075",
                    xcss: $6f7cc468af0ca045$var$styles.blockText,
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                            xcss: (0, $1Whri.cx)($6f7cc468af0ca045$var$styles.title, $6f7cc468af0ca045$var$styles.itemCommon)
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                            xcss: (0, $1Whri.cx)($6f7cc468af0ca045$var$styles.publishedDate, $6f7cc468af0ca045$var$styles.itemCommon)
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                            xcss: (0, $1Whri.cx)($6f7cc468af0ca045$var$styles.descriptionFirstLine, $6f7cc468af0ca045$var$styles.itemCommon)
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                            xcss: (0, $1Whri.cx)($6f7cc468af0ca045$var$styles.descriptionSecondLine, $6f7cc468af0ca045$var$styles.itemCommon)
                        })
                    ]
                })
            ]
        });
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        "data-testId": "medium-placeholder-card",
        style: {
            height: cardHeight
        },
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _2rko1mok _189ee4h9 _1h6d1l7x _1dqonqa1 _4t3i1osq"
        ]),
        children: /*#__PURE__*/ (0, $l998X.jsx)(Content, {})
    });
};


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");




























const $371e0884c6e1aab2$var$titleBlockImagePaddingStyles = null;
const $371e0884c6e1aab2$var$titleBlockUnauthorizedStyles = null;
const $371e0884c6e1aab2$var$titleBlockHideUnauthorizedStyles = null;
const $371e0884c6e1aab2$var$titleBlockStyles = null;
const $371e0884c6e1aab2$var$customImageUploadStyles = null;
const $371e0884c6e1aab2$export$130b31d14822cf85 = ({ contentId: contentId, cardId: cardId, link: link, title: title, imageSrc: imageSrc, isAvatarShown: isAvatarShown, isPublishDateShown: isPublishDateShown, cardDimensions: cardDimensions, isInViewMode: isInViewMode, onCardSucceeded: onCardSucceeded, onCardFailed: onCardFailed, imageAltText: imageAltText, ...analyticsPassThroughProps })=>{
    const cardHeight = cardDimensions.height;
    const { errorCardStatus: errorCardStatus, isNoResult: isNoResult, isRestricted: isRestricted, isUnauthorized: isUnauthorized, trackAndCategorizeError: trackAndCategorizeError, trackSuccess: trackSuccess } = (0, $aPwHF.useTrackedSmartCardState)(cardId, link, onCardSucceeded, onCardFailed);
    const { showUnsplashImage: showUnsplashImage, showExternalSiteImage: showExternalSiteImage, showCustomUploadedImage: showCustomUploadedImage, hasImage: hasImage } = (0, $jqjsu.getImageTypeToShow)({
        imageSrc: imageSrc
    });
    const showCustomTitleUnauthed = isUnauthorized && !!title;
    if (isRestricted || isNoResult) return /*#__PURE__*/ (0, $l998X.jsx)((0, $d05619b686658084$export$2ebec9f03312245c), {
        isRestricted: isRestricted,
        isNoResult: isNoResult,
        link: link,
        cardId: cardId,
        cardSize: (0, $4cOi8.Height).SMALL,
        cardHeight: cardHeight,
        isInViewMode: isInViewMode,
        errorStatus: errorCardStatus,
        ...analyticsPassThroughProps
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $803bff8a67e38d1e$export$79272b9cdf6f42c6), {
        isInViewMode: isInViewMode,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $803bff8a67e38d1e$export$52c1c6df1826ade4), {
            size: (0, $4cOi8.Height).SMALL,
            cardHeight: cardHeight,
            isPublishDateShown: isPublishDateShown,
            hasImage: hasImage,
            isAvatarShown: isAvatarShown,
            children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $9CM6e.CardSSR), {
                id: cardId,
                appearance: "inline",
                frameStyle: "show",
                platform: "web",
                ui: {
                    theme: (0, $5TXU5.SmartLinkTheme).Black,
                    clickableContainer: isInViewMode,
                    size: (0, $5TXU5.SmartLinkSize).Large
                },
                url: link,
                onResolve: trackSuccess,
                onError: trackAndCategorizeError,
                children: [
                    (showUnsplashImage || showExternalSiteImage) && /*#__PURE__*/ (0, $l998X.jsx)((0, $Y5kOr.default), {
                        ignoreContainerPadding: true,
                        placement: (0, $5TXU5.MediaPlacement).Left,
                        overrideUrl: imageSrc
                    }),
                    showCustomUploadedImage && /*#__PURE__*/ (0, $l998X.jsx)((0, $2R1C4.default), {
                        className: (0, $gMc0m.default)([
                            "_kqswstnw _1bsbt9kd _154ize3t _94n5ze3t _1ltvze3t"
                        ]),
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $kHNfU.CustomImageUploadRenderer), {
                            contentId: contentId,
                            imageSrc: imageSrc,
                            imageAltText: imageAltText
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $5znEc.default), {
                        hideIcon: true,
                        text: title,
                        maxLines: 1,
                        anchorTarget: "_self",
                        ...!!isAvatarShown && {
                            metadata: [
                                {
                                    name: (0, $5TXU5.ElementName).OwnedByGroup
                                }
                            ]
                        },
                        ...!!isPublishDateShown && {
                            subtitle: [
                                {
                                    name: (0, $5TXU5.ElementName).ModifiedOn
                                }
                            ]
                        },
                        className: (0, $gMc0m.default)([
                            "_19pkze3t _59381r31 _7hxb1r31 _9m7f1r31 _rfqo1r31 _qfs11r31 _yha2glyw _15zvglyw _w7swglyw _1bgkglyw _s41oglyw _1nmznqa1 _1xvinqa1 _15a9nqa1 _1t0pnqa1 _1k6pnqa1 _ru7v1wug _1b7m1wug _675q1wug _fn1s1wug _d6hs1wug _zh3r1wq8 _18pri7uo _2ax2idpf",
                            hasImage && "_ca0qutpp _u5f3utpp _n3tdutpp _19bvutpp",
                            showCustomTitleUnauthed && "_4l6lglyw",
                            !showCustomTitleUnauthed && isUnauthorized && "_1pbykb7n _1o7bglyw"
                        ])
                    })
                ]
            })
        })
    });
};


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");














const $36f76a7ae84fce72$var$placeholderBackgroundColor = "var(--ds-background-accent-gray-subtlest, #F0F1F2)";
const $36f76a7ae84fce72$var$legacyContainer = null;
const $36f76a7ae84fce72$var$styles = {
    content: "_4t3i1osq",
    image: "_1ul9i9or _bfhkysee",
    blockText: "_16jlkb7n _1o9zkb7n _i0dlf1ug _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi",
    title: "_1bsbldb6",
    publishedDate: "_1bsb1osq",
    itemCommon: "_4t3iftgi _bfhkysee"
};
const $36f76a7ae84fce72$export$3ce911d384458973 = ({ cardDimensions: cardDimensions })=>{
    const cardHeight = cardDimensions.height;
    const Content = ()=>/*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
            xcss: $36f76a7ae84fce72$var$styles.content,
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    xcss: $36f76a7ae84fce72$var$styles.image
                }),
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                    space: "space.050",
                    xcss: $36f76a7ae84fce72$var$styles.blockText,
                    alignBlock: "center",
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                            xcss: (0, $1Whri.cx)($36f76a7ae84fce72$var$styles.title, $36f76a7ae84fce72$var$styles.itemCommon)
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                            xcss: (0, $1Whri.cx)($36f76a7ae84fce72$var$styles.publishedDate, $36f76a7ae84fce72$var$styles.itemCommon)
                        })
                    ]
                })
            ]
        });
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        "data-testId": "small-placeholder-card",
        style: {
            height: cardHeight
        },
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _2rko1mok _189ee4h9 _1h6d1l7x _1dqonqa1 _4t3i1osq"
        ]),
        children: /*#__PURE__*/ (0, $l998X.jsx)(Content, {})
    });
};


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");



















var $8cb85d3c5a5090c3$exports = {};
$8cb85d3c5a5090c3$exports = new URL("General.d0402e27.svg", import.meta.url).toString();


var $g50oa = parcelRequire("g50oa");









const $f67cc898d7c2c834$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    noResultsTitle: {
        id: "company-hub.cards-extension.dynamic-card-empty-state.no-results-title",
        defaultMessage: "Nothing yet. Check back soon."
    },
    noFilterTitle: {
        id: "company-hub.cards-extension.dynamic-card-empty-state.no-filter-title",
        defaultMessage: "Add filters to populate cards."
    }
});


const $eacc84e085bad39b$var$styles = {
    container: "_4t3i1osq",
    imageBase: "_bfhkysee",
    imageFlexibleHeight: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1tkeidpf",
    imageFixedHeightMedium: "_4t3i11ux",
    imageFixedHeightLarge: "_4t3iuuw1",
    innerImageSmall: "_1bsb1wqb _4t3i1wqb _ca0q1b66 _u5f3u2gc _n3tdu2gc _19bv1b66",
    titleBase: "_11c82smr _u5f3utpp _19bvutpp _ca0qutpp _n3tdutpp _syazi7uo",
    largeFont: "_11c81ixg",
    titleBlock: "_4t3ickbl",
    imageInline: "_1ul9ys9h _4t3i1osq",
    titleInline: "_4t3i1osq"
};
const $eacc84e085bad39b$var$SmallCard = ({ imageSrc: imageSrc, title: title })=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
        testId: "no-result-card-small",
        xcss: $eacc84e085bad39b$var$styles.container,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
                alignBlock: "center",
                alignInline: "center",
                xcss: (0, $1Whri.cx)($eacc84e085bad39b$var$styles.imageBase, $eacc84e085bad39b$var$styles.imageInline),
                children: imageSrc && /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
                    alignBlock: "center",
                    alignInline: "center",
                    xcss: $eacc84e085bad39b$var$styles.innerImageSmall,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gj7hi.default), {
                        src: imageSrc,
                        alt: "no-result",
                        testId: "no-result-image"
                    })
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
                alignBlock: "center",
                xcss: (0, $1Whri.cx)($eacc84e085bad39b$var$styles.titleBase, $eacc84e085bad39b$var$styles.titleInline),
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                    ...title
                })
            })
        ]
    });
};
const $eacc84e085bad39b$var$MediumLargeCard = ({ isImageFixedHeight: isImageFixedHeight, cardSize: cardSize = (0, $4cOi8.Height).MEDIUM, imageSrc: imageSrc, title: title })=>{
    const isLargeCard = cardSize === (0, $4cOi8.Height).LARGE;
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
        testId: "no-result-card",
        space: "space.025",
        xcss: $eacc84e085bad39b$var$styles.container,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
                alignBlock: "center",
                alignInline: "center",
                xcss: (0, $1Whri.cx)($eacc84e085bad39b$var$styles.imageBase, isImageFixedHeight ? isLargeCard ? $eacc84e085bad39b$var$styles.imageFixedHeightLarge : $eacc84e085bad39b$var$styles.imageFixedHeightMedium : $eacc84e085bad39b$var$styles.imageFlexibleHeight),
                children: imageSrc && /*#__PURE__*/ (0, $l998X.jsx)((0, $gj7hi.default), {
                    src: imageSrc,
                    alt: "no-result",
                    testId: "no-result-image"
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
                alignBlock: "center",
                alignInline: "center",
                xcss: (0, $1Whri.cx)($eacc84e085bad39b$var$styles.titleBase, $eacc84e085bad39b$var$styles.titleBlock, isLargeCard && $eacc84e085bad39b$var$styles.largeFont),
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                    ...title
                })
            })
        ]
    });
};
var $eacc84e085bad39b$export$fddf379e22a74b00 = /*#__PURE__*/ function(EmptyState) {
    EmptyState["NO_FILTER"] = "noFilter";
    EmptyState["NO_RESULTS"] = "noResults";
    return EmptyState;
}({});
const $eacc84e085bad39b$var$getStateContent = (state)=>{
    if (state === "noFilter") return {
        imageSrc: (0, (/*@__PURE__*/$parcel$interopDefault($g50oa))),
        title: (0, $f67cc898d7c2c834$export$defe85febe8b728c).noFilterTitle
    };
    return {
        imageSrc: (0, (/*@__PURE__*/$parcel$interopDefault($8cb85d3c5a5090c3$exports))),
        title: (0, $f67cc898d7c2c834$export$defe85febe8b728c).noResultsTitle
    };
};
const $eacc84e085bad39b$export$15b55049a5f7f585 = ({ cardSize: cardSize, layout: layout, cardDimensions: cardDimensions, state: state })=>{
    const { height: height, minHeight: minHeight, maxHeight: maxHeight } = cardDimensions;
    const { imageSrc: imageSrc, title: title } = $eacc84e085bad39b$var$getStateContent(state);
    if (layout === (0, $5un3P.CardsLayout).FIXED_IMAGE_HEIGHT && cardSize !== (0, $4cOi8.Height).SMALL && (0, $dh538.fg)('company_hub_cards_v2')) return /*#__PURE__*/ (0, $l998X.jsx)((0, $875e9f2f375ca359$export$8a23e74e5cf3ca41), {
        children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
            style: {
                minHeight: minHeight,
                maxHeight: maxHeight
            },
            children: /*#__PURE__*/ (0, $l998X.jsx)($eacc84e085bad39b$var$MediumLargeCard, {
                isImageFixedHeight: true,
                cardSize: cardSize,
                imageSrc: imageSrc,
                title: title
            })
        })
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $875e9f2f375ca359$export$8a23e74e5cf3ca41), {
        cardHeight: height,
        children: cardSize === (0, $4cOi8.Height).SMALL ? /*#__PURE__*/ (0, $l998X.jsx)($eacc84e085bad39b$var$SmallCard, {
            imageSrc: imageSrc,
            title: title
        }) : /*#__PURE__*/ (0, $l998X.jsx)($eacc84e085bad39b$var$MediumLargeCard, {
            imageSrc: imageSrc,
            title: title
        })
    });
};


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");




















const $639589a78901fac2$var$placeholderBackgroundColor = "var(--ds-background-accent-gray-subtlest, #F0F1F2)";
const $639589a78901fac2$var$styles = {
    content: "_4t3i1osq",
    image: "_bfhkysee",
    imageFixedHeightMedium: "_4t3i11ux",
    imageFixedHeightLarge: "_4t3iuuw1",
    imageFlexibleHeight: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1tkeidpf",
    imageSmall: "_1ul9i9or",
    body: "_ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi",
    bodySmall: "_16jlkb7n _1o9zkb7n _i0dlf1ug",
    itemCommon: "_4t3iftgi _bfhkysee",
    title: "_1bsbldb6",
    publishedDate: "_1bsb1osq",
    descriptionFirstLine: "_1bsbs0l4",
    descriptionSecondLine: "_1bsb1ame",
    titleLarge: "_1bsb12am",
    descriptionFirstLineLarge: "_1bsbuuw1",
    descriptionSecondLineLarge: "_1bsb1178"
};
const $639589a78901fac2$var$ContentSmall = ()=>/*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
        xcss: $639589a78901fac2$var$styles.content,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: (0, $1Whri.cx)($639589a78901fac2$var$styles.image, $639589a78901fac2$var$styles.imageSmall)
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                space: "space.050",
                xcss: (0, $1Whri.cx)($639589a78901fac2$var$styles.body, $639589a78901fac2$var$styles.bodySmall),
                alignBlock: "center",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                        xcss: (0, $1Whri.cx)($639589a78901fac2$var$styles.itemCommon, $639589a78901fac2$var$styles.title)
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                        xcss: (0, $1Whri.cx)($639589a78901fac2$var$styles.itemCommon, $639589a78901fac2$var$styles.publishedDate)
                    })
                ]
            })
        ]
    });
const $639589a78901fac2$var$Content = ({ isImageFixedHeight: isImageFixedHeight, cardSize: cardSize })=>{
    const isLargeCard = cardSize === (0, $4cOi8.Height).LARGE;
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
        direction: "column",
        xcss: $639589a78901fac2$var$styles.content,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: (0, $1Whri.cx)($639589a78901fac2$var$styles.image, isImageFixedHeight ? isLargeCard ? $639589a78901fac2$var$styles.imageFixedHeightLarge : $639589a78901fac2$var$styles.imageFixedHeightMedium : $639589a78901fac2$var$styles.imageFlexibleHeight)
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                space: "space.075",
                xcss: $639589a78901fac2$var$styles.body,
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                        xcss: (0, $1Whri.cx)($639589a78901fac2$var$styles.itemCommon, isLargeCard ? $639589a78901fac2$var$styles.titleLarge : $639589a78901fac2$var$styles.title)
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                        xcss: (0, $1Whri.cx)($639589a78901fac2$var$styles.itemCommon, $639589a78901fac2$var$styles.publishedDate)
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                        xcss: (0, $1Whri.cx)($639589a78901fac2$var$styles.itemCommon, isLargeCard ? $639589a78901fac2$var$styles.descriptionFirstLineLarge : $639589a78901fac2$var$styles.descriptionFirstLine)
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                        xcss: (0, $1Whri.cx)($639589a78901fac2$var$styles.itemCommon, isLargeCard ? $639589a78901fac2$var$styles.descriptionSecondLineLarge : $639589a78901fac2$var$styles.descriptionSecondLine)
                    })
                ]
            })
        ]
    });
};
const $639589a78901fac2$export$f67f215fe23c6b24 = ({ cardDimensions: cardDimensions, cardSize: cardSize, layout: layout })=>{
    const { height: height, minHeight: minHeight, maxHeight: maxHeight } = cardDimensions;
    const containerId = `${cardSize}-card-loading-state`;
    if (layout === (0, $5un3P.CardsLayout).FIXED_IMAGE_HEIGHT && cardSize !== (0, $4cOi8.Height).SMALL && (0, $dh538.fg)('company_hub_cards_v2')) return /*#__PURE__*/ (0, $l998X.jsx)((0, $875e9f2f375ca359$export$8a23e74e5cf3ca41), {
        id: `${containerId}-v2`,
        children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
            style: {
                minHeight: minHeight,
                maxHeight: maxHeight
            },
            children: /*#__PURE__*/ (0, $l998X.jsx)($639589a78901fac2$var$Content, {
                isImageFixedHeight: true,
                cardSize: cardSize
            })
        })
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $875e9f2f375ca359$export$8a23e74e5cf3ca41), {
        id: `${containerId}-v1`,
        cardHeight: height,
        children: cardSize === (0, $4cOi8.Height).SMALL ? /*#__PURE__*/ (0, $l998X.jsx)($639589a78901fac2$var$ContentSmall, {}) : /*#__PURE__*/ (0, $l998X.jsx)($639589a78901fac2$var$Content, {
            cardSize: cardSize
        })
    });
};


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ // @ts-ignore -next-line













var $hpUsb = parcelRequire("hpUsb");












var $cNgYa = parcelRequire("cNgYa");














const $11fdfe9e9c4fbcbb$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    emptyStatePlaceholderTitle: {
        id: "company-hub.cards-extension.smart-card.empty-state.placeholder-title",
        defaultMessage: "Add a title"
    }
});


const $5231293a78243846$var$titleBlockStyles = null;
const $5231293a78243846$var$titleBlockMarginTopStyles = {
    small: "_19pkze3t",
    other: "_19pku2gc"
};
const $5231293a78243846$var$titleBlockLinkTextColorStyles = null;
const $5231293a78243846$var$titleBlockLinkTextSubtlestColorStyles = null;
const $5231293a78243846$var$previewStyles = null;
const $5231293a78243846$var$customImageUploadStyles = {
    left: "_kqswstnw _1bsbt9kd _154ize3t _94n5ze3t _1ltvze3t",
    right: "_18u01ivi _2hwxc10g _e0oi1ya9 _dmhj1ya9"
};
const $5231293a78243846$export$174fdf2bc79a4e74 = ({ contentId: contentId, cardId: cardId, size: size, title: title, description: description, imageSrc: imageSrc, cardDimensions: cardDimensions, isInViewMode: isInViewMode, onCardSucceeded: onCardSucceeded, onCardFailed: onCardFailed, imageAltText: imageAltText })=>{
    const intl = (0, $8C5kA.default)();
    const { submitError: submitError } = (0, $fOKpq.useProductDependencies)();
    const handleResolve = (0, $42omo.useCallback)(()=>{
        onCardSucceeded(cardId);
    }, [
        onCardSucceeded,
        cardId
    ]);
    const handleError = (0, $42omo.useCallback)((error)=>{
        submitError?.(error);
        onCardFailed(error);
    }, [
        onCardFailed,
        submitError
    ]);
    const { showUnsplashImage: showUnsplashImage, showCustomUploadedImage: showCustomUploadedImage, hasImage: hasImage } = (0, $jqjsu.getImageTypeToShow)({
        imageSrc: imageSrc
    });
    const getSmartCardSize = (0, $42omo.useCallback)(()=>{
        switch(size){
            case (0, $4cOi8.Height).SMALL:
            case (0, $4cOi8.Height).MEDIUM:
                return (0, $5TXU5.SmartLinkSize).Medium;
            case (0, $4cOi8.Height).LARGE:
            default:
                return (0, $5TXU5.SmartLinkSize).Large;
        }
    }, [
        size
    ]);
    const getCardHeight = (0, $42omo.useCallback)(()=>{
        if (cardDimensions.height) return cardDimensions.height;
        switch(size){
            case (0, $4cOi8.Height).SMALL:
                return 84;
            case (0, $4cOi8.Height).MEDIUM:
                return 328;
            case (0, $4cOi8.Height).LARGE:
                return 424;
        }
    }, [
        cardDimensions.height,
        size
    ]);
    const fallbackUrl = (0, $cNgYa.getSmartCardFallbackUrl)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $803bff8a67e38d1e$export$79272b9cdf6f42c6), {
        isInViewMode: isInViewMode,
        isEmptyCard: true,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $803bff8a67e38d1e$export$52c1c6df1826ade4), {
            size: size,
            "data-testid": "empty-state-visual-smart-card",
            cardHeight: getCardHeight(),
            hasImage: hasImage,
            children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $hpUsb.Card), {
                id: cardId,
                onError: handleError,
                onResolve: handleResolve,
                appearance: "inline",
                ui: {
                    theme: (0, $5TXU5.SmartLinkTheme).Black,
                    clickableContainer: false,
                    size: getSmartCardSize()
                },
                url: fallbackUrl,
                children: [
                    showUnsplashImage && /*#__PURE__*/ (0, $l998X.jsx)((0, $Y5kOr.default), {
                        ignoreContainerPadding: true,
                        placement: size === (0, $4cOi8.Height).SMALL ? (0, $5TXU5.MediaPlacement).Left : undefined,
                        overrideUrl: imageSrc,
                        className: (0, $gMc0m.default)([
                            "_16jlkb7n"
                        ])
                    }),
                    showCustomUploadedImage && /*#__PURE__*/ (0, $l998X.jsx)((0, $2R1C4.default // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
                    ), {
                        className: (0, $gMc0m.default)([
                            size === (0, $4cOi8.Height).SMALL ? $5231293a78243846$var$customImageUploadStyles.left : $5231293a78243846$var$customImageUploadStyles.right
                        ]),
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $kHNfU.CustomImageUploadRenderer), {
                            contentId: contentId,
                            imageSrc: imageSrc,
                            imageAltText: imageAltText,
                            shouldShowErrorMessage: size !== (0, $4cOi8.Height).SMALL
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $5znEc.default), {
                        text: title || intl.formatMessage((0, $11fdfe9e9c4fbcbb$export$defe85febe8b728c).emptyStatePlaceholderTitle),
                        hideIcon: true,
                        anchorTarget: "_self",
                        className: (0, $gMc0m.default)([
                            "_19pkze3t _59381r31 _7hxb1r31 _9m7f1r31 _rfqo1r31 _qfs11r31 _yha2glyw _15zvglyw _w7swglyw _1bgkglyw _s41oglyw _1nmznqa1 _1xvinqa1 _15a9nqa1 _1t0pnqa1 _1k6pnqa1 _ru7vglyw _1b7mglyw _675qglyw _fn1sglyw _d6hsglyw _zh3r1wq8 _2ax2idpf",
                            title ? "_18pri7uo" : "_18pr1rpy",
                            size === (0, $4cOi8.Height).SMALL ? $5231293a78243846$var$titleBlockMarginTopStyles.small : $5231293a78243846$var$titleBlockMarginTopStyles.other
                        ])
                    }),
                    size !== (0, $4cOi8.Height).SMALL && /*#__PURE__*/ (0, $l998X.jsx)((0, $8zS2j.default), {
                        text: description
                    })
                ]
            })
        })
    });
};


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");











var $bPdpL = parcelRequire("bPdpL");


var $5tOl1 = parcelRequire("5tOl1");










const $35e23058e7b3e321$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    previous: {
        id: "company-hub.cards-extension.row-orientation.previous",
        defaultMessage: "Previous"
    },
    next: {
        id: "company-hub.cards-extension.row-orientation.next",
        defaultMessage: "Next"
    }
});


const $4869bd40ed92a09c$var$styles = {
    footer: "_1bah1yb4 _4cvr1h6o _ca0q12x7",
    footerNav: "_zulp1b66 _18u01wug",
    iconBackgroundColor: "_2rko1rr0 _bfhk1bhr"
};
const $4869bd40ed92a09c$export$d1f75a226e49cd83 = ({ isStacked: isStacked, showAIDisclaimer: showAIDisclaimer, allCardsShown: allCardsShown, isAtBeginning: isAtBeginning, isAtEnd: isAtEnd, scrollToPrevious: scrollToPrevious, scrollToNext: scrollToNext })=>{
    const showFooter = showAIDisclaimer || !isStacked && !allCardsShown;
    if (!showFooter) return null;
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
        space: "space.050",
        testId: "link-cards-content-cards-row-navigation",
        xcss: (0, $1Whri.cx)($4869bd40ed92a09c$var$styles.footer, isStacked && !showAIDisclaimer && $4869bd40ed92a09c$var$styles.footerNav),
        children: [
            showAIDisclaimer && /*#__PURE__*/ (0, $l998X.jsx)((0, $bGmGb.CardsAIDisclaimer), {}),
            !isStacked && !allCardsShown && /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                xcss: $4869bd40ed92a09c$var$styles.footerNav,
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
                        xcss: $4869bd40ed92a09c$var$styles.iconBackgroundColor,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                            shape: "circle",
                            icon: (0, (/*@__PURE__*/$parcel$interopDefault($bPdpL))),
                            isDisabled: isAtBeginning,
                            label: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                ...(0, $35e23058e7b3e321$export$defe85febe8b728c).previous
                            }),
                            onClick: scrollToPrevious
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
                        xcss: $4869bd40ed92a09c$var$styles.iconBackgroundColor,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                            shape: "circle",
                            icon: (0, (/*@__PURE__*/$parcel$interopDefault($5tOl1))),
                            isDisabled: isAtEnd,
                            label: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                ...(0, $35e23058e7b3e321$export$defe85febe8b728c).next
                            }),
                            onClick: scrollToNext
                        })
                    })
                ]
            })
        ]
    });
};


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");























const $f3904af1547a9767$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    zeroResultsTitle: {
        id: "company-hub.cards-extension.smart-card.no-results-title",
        defaultMessage: "Nothing here yet. Check back soon."
    }
});


const $54a859e34da25812$var$legacyContainer = null;
const $54a859e34da25812$var$styles = {
    container: "_4t3i1osq",
    imageBase: "_bfhkysee",
    imageFlexibleHeight: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1tkeidpf",
    imageFixedHeightMedium: "_4t3i11ux",
    imageFixedHeightLarge: "_4t3iuuw1",
    subtitleBase: "_11c81o8v _u5f3utpp _19bvutpp _ca0qutpp _n3tdutpp _syaz1rpy",
    subtitleBlock: "_4t3ickbl",
    imageInline: "_1ul9i9or _4t3i1osq",
    subtitleInline: "_4t3i1osq"
};
const $54a859e34da25812$var$SmallCard = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
        testId: "zero-results-card-small",
        xcss: $54a859e34da25812$var$styles.container,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: (0, $1Whri.cx)($54a859e34da25812$var$styles.imageBase, $54a859e34da25812$var$styles.imageInline)
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
                alignBlock: "center",
                xcss: (0, $1Whri.cx)($54a859e34da25812$var$styles.subtitleBase, $54a859e34da25812$var$styles.subtitleInline),
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                    ...(0, $f3904af1547a9767$export$defe85febe8b728c).zeroResultsTitle
                })
            })
        ]
    });
};
const $54a859e34da25812$var$MediumLargeCard = ({ isImageFixedHeight: isImageFixedHeight = false, cardSize: cardSize = (0, $4cOi8.Height).MEDIUM })=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
        testId: "zero-results-card",
        space: "space.025",
        xcss: $54a859e34da25812$var$styles.container,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: (0, $1Whri.cx)($54a859e34da25812$var$styles.imageBase, isImageFixedHeight ? cardSize === (0, $4cOi8.Height).LARGE ? $54a859e34da25812$var$styles.imageFixedHeightLarge : $54a859e34da25812$var$styles.imageFixedHeightMedium : $54a859e34da25812$var$styles.imageFlexibleHeight)
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
                alignBlock: "center",
                alignInline: "center",
                xcss: (0, $1Whri.cx)($54a859e34da25812$var$styles.subtitleBase, $54a859e34da25812$var$styles.subtitleBlock),
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                    ...(0, $f3904af1547a9767$export$defe85febe8b728c).zeroResultsTitle
                })
            })
        ]
    });
};
const $54a859e34da25812$export$eeb64318f3961c19 = ({ cardSize: cardSize, cardDimensions: cardDimensions })=>{
    const { height: height } = cardDimensions;
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        style: {
            height: height
        },
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _2rko12b0 _189ee4h9 _1dqonqa1 _1h6d1l7x _vchhusvi"
        ]),
        children: cardSize === (0, $4cOi8.Height).SMALL ? /*#__PURE__*/ (0, $l998X.jsx)($54a859e34da25812$var$SmallCard, {}) : /*#__PURE__*/ (0, $l998X.jsx)($54a859e34da25812$var$MediumLargeCard, {})
    });
};


const $75ac03d5ea4b0323$var$styles = {
    cardWrapper: "_4t3i1osq"
};
const $75ac03d5ea4b0323$var$CARD_SIZE_V1_MAP = {
    [(0, $4cOi8.Height).SMALL]: (0, $a9e75a3820d58e12$export$5c35843a47cb7bc4),
    [(0, $4cOi8.Height).MEDIUM]: (0, $39e9dc6831e8ee6a$export$42440eb4dfc95ce7),
    [(0, $4cOi8.Height).LARGE]: (0, $13e5f254f9926788$export$299421c7aa71f32d)
};
const $75ac03d5ea4b0323$var$CARD_SIZE_V2_MAP = {
    [(0, $4cOi8.Height).SMALL]: (0, $a9e75a3820d58e12$export$5c35843a47cb7bc4),
    [(0, $4cOi8.Height).MEDIUM]: (0, $10bd7f32a1f45b52$export$b38e9910221b4e7e),
    [(0, $4cOi8.Height).LARGE]: (0, $b85a19d2e323979a$export$a59c193ce67944a7)
};
const $75ac03d5ea4b0323$var$CARD_SIZE_MAP = {
    [(0, $4cOi8.Height).SMALL]: (0, $371e0884c6e1aab2$export$130b31d14822cf85),
    [(0, $4cOi8.Height).MEDIUM]: (0, $e01621b352de0025$export$fa129874a526090),
    [(0, $4cOi8.Height).LARGE]: (0, $055913a6dde137c8$export$9f4f09e26cb56ad5)
};
const $75ac03d5ea4b0323$var$getCardComponent = (cardSize, layout)=>{
    if ((0, $dh538.fg)('company_hub_cards_v2')) {
        if (layout === (0, $5un3P.CardsLayout).FIXED_IMAGE_HEIGHT) return $75ac03d5ea4b0323$var$CARD_SIZE_V2_MAP[cardSize] ?? (0, $10bd7f32a1f45b52$export$b38e9910221b4e7e);
        else if (layout === (0, $5un3P.CardsLayout).FLEXIBLE_IMAGE_HEIGHT) return $75ac03d5ea4b0323$var$CARD_SIZE_V1_MAP[cardSize] ?? (0, $39e9dc6831e8ee6a$export$42440eb4dfc95ce7);
    }
    if ((0, $dh538.fg)('company_hub_cards_visual_update')) return $75ac03d5ea4b0323$var$CARD_SIZE_V1_MAP[cardSize] ?? (0, $39e9dc6831e8ee6a$export$42440eb4dfc95ce7);
    return $75ac03d5ea4b0323$var$CARD_SIZE_MAP[cardSize] ?? (0, $e01621b352de0025$export$fa129874a526090);
};
const $75ac03d5ea4b0323$export$bab15f92b6d84cb6 = ({ extensionLocalId: extensionLocalId, parameters: parameters, isCompanyHub: isCompanyHub, isTargetAudience: isTargetAudience, isInViewMode: isInViewMode, contentId: contentId })=>{
    const validatedCardParams = (0, $7165bea3d0a8ca43$export$9a666555160249c1)(parameters);
    const { renderVariant: renderVariant, size: size, isDescriptionShown: isDescriptionShown, layout: layout } = validatedCardParams;
    const isDynamicCards = renderVariant === (0, $4cOi8.RenderVariant).DYNAMIC;
    const cardDimensions = (0, $e41f25d61305a67d$export$90cc9ab68d35b5b9)({
        cardSize: size,
        layout: layout,
        isCardsVisualUpdateEnabled: (0, $dh538.fg)('company_hub_cards_visual_update'),
        isCardsV2Enabled: (0, $dh538.fg)('company_hub_cards_v2')
    });
    const CardComponent = $75ac03d5ea4b0323$var$getCardComponent(size, layout);
    // checking specifically if isDescriptionShown is false because if it's undefined,
    // it means that the dynamic cards were created from before and we want to show the descriptions they had
    const showDescription = !(0, $dh538.fg)('company_hub_dynamic_cards_ai_descriptions') || renderVariant === (0, $4cOi8.RenderVariant).MANUAL || isDescriptionShown !== false;
    /* only autoscroll cards when all below conditions meet:
   * 1. is in company hub
   * 2. orientation is in row (handled in validateCardParams)
   * 3. Autoscroll toggle is on
   * 4. user is in renderer
   * cards macro now includes features that are company hub specific. These features will be hidden for macros in non-hub pages
   * for more details refer to https://hello.atlassian.net/wiki/spaces/CLI/pages/4436003008/Hub+only+features
   */ const shouldAutoscrollCards = Boolean(isCompanyHub && validatedCardParams.isAutoscrollEnabled && isInViewMode);
    const CardsContentComponent = isDynamicCards ? $75ac03d5ea4b0323$var$DynamicCardsContent : $75ac03d5ea4b0323$var$ManualCardsContent;
    return /*#__PURE__*/ (0, $l998X.jsx)(CardsContentComponent, {
        extensionLocalId: extensionLocalId,
        parameters: validatedCardParams,
        isCompanyHub: isCompanyHub,
        isTargetAudience: isTargetAudience,
        isInViewMode: isInViewMode,
        contentId: contentId,
        cardDimensions: cardDimensions,
        shouldAutoscrollCards: shouldAutoscrollCards,
        CardComponent: CardComponent,
        showDescription: showDescription
    });
};
const $75ac03d5ea4b0323$var$CardsContainer = ({ extensionLocalId: extensionLocalId, numberOfCards: numberOfCards, cardDimensions: cardDimensions, isStacked: isStacked, alignment: alignment, cards: cards, renderCard: renderCard, isInViewMode: isInViewMode, shouldAutoscrollCards: shouldAutoscrollCards, showAIDisclaimer: showAIDisclaimer })=>shouldAutoscrollCards ? /*#__PURE__*/ (0, $l998X.jsx)((0, $d1c18879ec5e414d$export$ac70d6b7d7a09503), {
        testId: "cards-extension",
        numberOfCards: numberOfCards,
        cardDimensions: cardDimensions,
        cards: cards,
        renderCard: renderCard,
        showAIDisclaimer: showAIDisclaimer
    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $cbc545f2775878ae$export$37f8d84bb48ae4b7), {
        testId: "cards-extension",
        extensionLocalId: extensionLocalId,
        numberOfCards: numberOfCards,
        cardDimensions: cardDimensions,
        isStacked: isStacked,
        isInViewMode: isInViewMode,
        alignment: alignment,
        cards: cards,
        renderCard: renderCard,
        showAIDisclaimer: showAIDisclaimer,
        cardsContentFooter: (0, $4869bd40ed92a09c$export$d1f75a226e49cd83)
    });
const $75ac03d5ea4b0323$var$ManualCardsContent = ({ extensionLocalId: extensionLocalId, parameters: parameters, contentId: contentId, cardDimensions: cardDimensions, CardComponent: CardComponent, shouldAutoscrollCards: shouldAutoscrollCards, isCompanyHub: isCompanyHub, isTargetAudience: isTargetAudience, isInViewMode: isInViewMode = false, showDescription: showDescription = true })=>{
    const { size: size, isPaddingEnabled: isPaddingEnabled, isAvatarShown: isAvatarShown, isPublishDateShown: isPublishDateShown, isSocialStatsShown: isSocialStatsShown, isIconShown: isIconShown, cards: cards, isSegmentationShown: isSegmentationShown, isLabelShown: isLabelShown, orientation: orientation, alignment: alignment, audienceSegmentationGroupIds: audienceSegmentationGroupIds, segmentationTarget: segmentationTarget, renderVariant: renderVariant, backgroundColor: backgroundColor, textColor: textColor, borderColor: borderColor, cornerStyle: cornerStyle } = parameters;
    const { areAllItemsLoaded: areAllItemsLoaded, itemFailureError: itemFailureError, onItemSucceeded: onItemSucceeded, onItemFailed: onItemFailed } = (0, $18092cac9334e981$export$c6c5cac0793c45d9)(cards);
    const { filteredCards: filteredCards } = (0, $ef7e4501b98ea11b$export$93c098ff84870fcb)({
        isCompanyHub: isCompanyHub,
        isSegmentationShown: isSegmentationShown,
        isTargetAudience: isTargetAudience,
        cards: cards,
        isInViewMode: isInViewMode,
        segmentationTarget: segmentationTarget,
        audienceSegmentationGroupIds: audienceSegmentationGroupIds,
        renderVariant: renderVariant
    });
    const { experienceSuccessComponent: experienceSuccessComponent, experienceStopComponent: experienceStopComponent } = (0, $fOKpq.useProductDependencies)();
    const ExperienceSuccess = experienceSuccessComponent || (()=>null);
    const ExperienceError = experienceStopComponent || (()=>null);
    const numberOfCards = filteredCards.length;
    const renderManualCard = (0, $42omo.useCallback)((card)=>{
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $eyWa4.default), {
            space: "space.075",
            xcss: (0, $1Whri.cx)($75ac03d5ea4b0323$var$styles.cardWrapper),
            children: (0, $dh538.fg)('company_hub_cards_visual_update') ? /*#__PURE__*/ (0, $l998X.jsx)(CardComponent, {
                contentId: contentId,
                cardDimensions: cardDimensions,
                isPaddingEnabled: isPaddingEnabled,
                isAvatarShown: isAvatarShown,
                isPublishDateShown: isPublishDateShown,
                isSocialStatsShown: isSocialStatsShown,
                isIconShown: isIconShown,
                isInViewMode: isInViewMode,
                isLabelShown: isLabelShown,
                onCardSucceeded: onItemSucceeded,
                onCardFailed: onItemFailed,
                isManualVariant: true,
                extensionLocalId: extensionLocalId,
                backgroundColor: backgroundColor,
                textColor: textColor,
                borderColor: borderColor,
                cornerStyle: cornerStyle,
                showDescription: showDescription,
                ...card
            }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $eagtR.ItemSelectedToEditWrapper), {
                itemId: card.cardId,
                extensionLocalId: extensionLocalId,
                children: !!card.link ? /*#__PURE__*/ (0, $l998X.jsx)(CardComponent, {
                    contentId: contentId,
                    cardDimensions: cardDimensions,
                    isAvatarShown: isAvatarShown,
                    isPublishDateShown: isPublishDateShown,
                    isInViewMode: isInViewMode,
                    onCardSucceeded: onItemSucceeded,
                    onCardFailed: onItemFailed,
                    showDescription: showDescription,
                    ...card
                }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $5231293a78243846$export$174fdf2bc79a4e74), {
                    contentId: contentId,
                    size: size,
                    cardDimensions: cardDimensions,
                    isInViewMode: isInViewMode,
                    onCardSucceeded: onItemSucceeded,
                    onCardFailed: onItemFailed,
                    ...card
                })
            }, card.cardId)
        }, card.cardId);
    }, [
        extensionLocalId,
        contentId,
        cardDimensions,
        isPaddingEnabled,
        isAvatarShown,
        isPublishDateShown,
        isLabelShown,
        isSocialStatsShown,
        isIconShown,
        showDescription,
        size,
        isInViewMode,
        onItemSucceeded,
        onItemFailed,
        CardComponent,
        backgroundColor,
        textColor,
        borderColor,
        cornerStyle
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)($75ac03d5ea4b0323$var$CardsContainer, {
                shouldAutoscrollCards: shouldAutoscrollCards,
                numberOfCards: numberOfCards,
                cardDimensions: cardDimensions,
                isStacked: orientation === (0, $5un3P.Orientation).STACKED,
                isInViewMode: isInViewMode,
                alignment: alignment,
                extensionLocalId: extensionLocalId,
                cards: filteredCards,
                renderCard: renderManualCard
            }),
            areAllItemsLoaded && /*#__PURE__*/ (0, $l998X.jsx)(ExperienceSuccess, {}),
            !!itemFailureError && /*#__PURE__*/ (0, $l998X.jsx)(ExperienceError, {
                error: itemFailureError
            })
        ]
    });
};
const $75ac03d5ea4b0323$var$PLACEHOLDER_CARD_SIZE_MAP = {
    [(0, $4cOi8.Height).SMALL]: (0, $36f76a7ae84fce72$export$3ce911d384458973),
    [(0, $4cOi8.Height).MEDIUM]: (0, $6f7cc468af0ca045$export$dd85cb3a0f399702),
    [(0, $4cOi8.Height).LARGE]: (0, $45d43eb27f87e375$export$cac86eeab61c4c13)
};
const $75ac03d5ea4b0323$var$getPlaceholderCardComponent = (cardSize)=>{
    return $75ac03d5ea4b0323$var$PLACEHOLDER_CARD_SIZE_MAP[cardSize] ?? (0, $6f7cc468af0ca045$export$dd85cb3a0f399702);
};
const $75ac03d5ea4b0323$var$DynamicCardsContent = ({ extensionLocalId: extensionLocalId, parameters: parameters, contentId: contentId, cardDimensions: cardDimensions, CardComponent: CardComponent, shouldAutoscrollCards: shouldAutoscrollCards, isCompanyHub: isCompanyHub, isTargetAudience: isTargetAudience, isInViewMode: isInViewMode = false, showDescription: showDescription })=>{
    const { size: size, orientation: orientation, alignment: alignment, isPaddingEnabled: isPaddingEnabled, isAvatarShown: isAvatarShown, isPublishDateShown: isPublishDateShown, isSocialStatsShown: isSocialStatsShown, isIconShown: isIconShown, filters: filters, isSegmentationShown: isSegmentationShown, audienceSegmentationGroupIds: audienceSegmentationGroupIds, segmentationTarget: segmentationTarget, renderVariant: renderVariant, backgroundColor: backgroundColor, textColor: textColor, borderColor: borderColor, cornerStyle: cornerStyle, layout: layout } = parameters;
    const { cards: cards, loading: loading, error: error } = (0, $08734f16b0a13216$export$5fe928848609fec7)(parameters);
    const { areAllItemsLoaded: areAllItemsLoaded, itemFailureError: itemFailureError, onItemSucceeded: onItemSucceeded, onItemFailed: onItemFailed } = (0, $18092cac9334e981$export$c6c5cac0793c45d9)(cards);
    const { isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $fOKpq.useProductDependencies)();
    const { experienceSuccessComponent: experienceSuccessComponent, experienceStopComponent: experienceStopComponent } = (0, $fOKpq.useProductDependencies)();
    const ExperienceSuccess = experienceSuccessComponent || (()=>null);
    const ExperienceError = experienceStopComponent || (()=>null);
    const numberOfCards = cards.length;
    const showAIDisclaimer = isAdminHubAIEnabled && showDescription && numberOfCards > 0 && size !== (0, $4cOi8.Height).SMALL && (0, $dh538.fg)('company_hub_dynamic_cards_ai_descriptions');
    let cardsWithEmptyDefault = cards;
    if (!filters || !numberOfCards || loading) cardsWithEmptyDefault = (0, (/*@__PURE__*/$parcel$interopDefault($069d581736ad089f$exports)))(3, ()=>({
            cardId: '',
            link: ''
        }));
    const { filteredCards: filteredCards } = (0, $ef7e4501b98ea11b$export$93c098ff84870fcb)({
        isCompanyHub: isCompanyHub,
        isSegmentationShown: isSegmentationShown,
        isTargetAudience: isTargetAudience,
        cards: cardsWithEmptyDefault,
        isInViewMode: isInViewMode,
        segmentationTarget: segmentationTarget,
        audienceSegmentationGroupIds: audienceSegmentationGroupIds,
        renderVariant: renderVariant
    });
    const renderDynamicCard = (0, $42omo.useCallback)((card)=>{
        const isResultEmpty = !numberOfCards || !card?.link;
        // Cards 1.0 and 2.0 edge cases
        if ((0, $dh538.fg)('company_hub_cards_visual_update')) {
            if (!filters) return /*#__PURE__*/ (0, $l998X.jsx)((0, $eacc84e085bad39b$export$15b55049a5f7f585), {
                cardDimensions: cardDimensions,
                cardSize: size,
                layout: layout,
                state: (0, $eacc84e085bad39b$export$fddf379e22a74b00).NO_FILTER
            });
            if (loading) return /*#__PURE__*/ (0, $l998X.jsx)((0, $639589a78901fac2$export$f67f215fe23c6b24), {
                cardDimensions: cardDimensions,
                cardSize: size,
                layout: layout
            });
            if (isResultEmpty) return /*#__PURE__*/ (0, $l998X.jsx)((0, $eacc84e085bad39b$export$15b55049a5f7f585), {
                cardDimensions: cardDimensions,
                cardSize: size,
                layout: layout,
                state: (0, $eacc84e085bad39b$export$fddf379e22a74b00).NO_RESULTS
            });
        } else {
            if (!filters) return /*#__PURE__*/ (0, $l998X.jsx)((0, $54a859e34da25812$export$eeb64318f3961c19), {
                cardDimensions: cardDimensions,
                cardSize: size
            });
            if (loading) {
                const PlaceholderCardComponent = $75ac03d5ea4b0323$var$getPlaceholderCardComponent(size);
                return /*#__PURE__*/ (0, $l998X.jsx)(PlaceholderCardComponent, {
                    cardDimensions: cardDimensions
                });
            }
            if (isResultEmpty) return /*#__PURE__*/ (0, $l998X.jsx)((0, $54a859e34da25812$export$eeb64318f3961c19), {
                cardDimensions: cardDimensions,
                cardSize: size
            });
        }
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $eyWa4.default), {
            space: "space.075",
            xcss: (0, $1Whri.cx)($75ac03d5ea4b0323$var$styles.cardWrapper),
            children: /*#__PURE__*/ (0, $l998X.jsx)(CardComponent, {
                contentId: contentId,
                cardDimensions: cardDimensions,
                isPaddingEnabled: isPaddingEnabled,
                isAvatarShown: isAvatarShown,
                isPublishDateShown: isPublishDateShown,
                isSocialStatsShown: isSocialStatsShown,
                isIconShown: isIconShown,
                isInViewMode: !!isInViewMode,
                onCardSucceeded: onItemSucceeded,
                onCardFailed: onItemFailed,
                backgroundColor: backgroundColor,
                textColor: textColor,
                borderColor: borderColor,
                cornerStyle: cornerStyle,
                enableSnippetRenderer: (0, $dh538.fg)('company_hub_dynamic_cards_ai_descriptions'),
                showDescription: showDescription,
                ...card
            })
        }, card.cardId);
    }, [
        isPaddingEnabled,
        isAvatarShown,
        isPublishDateShown,
        isSocialStatsShown,
        isIconShown,
        showDescription,
        filters,
        size,
        contentId,
        cardDimensions,
        isInViewMode,
        onItemSucceeded,
        onItemFailed,
        CardComponent,
        loading,
        backgroundColor,
        textColor,
        borderColor,
        cornerStyle,
        layout,
        numberOfCards
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)($75ac03d5ea4b0323$var$CardsContainer, {
                shouldAutoscrollCards: shouldAutoscrollCards,
                numberOfCards: numberOfCards,
                cardDimensions: cardDimensions,
                isStacked: orientation === (0, $5un3P.Orientation).STACKED,
                isInViewMode: isInViewMode,
                alignment: alignment,
                extensionLocalId: extensionLocalId,
                cards: filteredCards,
                renderCard: renderDynamicCard,
                showAIDisclaimer: showAIDisclaimer
            }),
            error && /*#__PURE__*/ (0, $l998X.jsx)((0, $92f476fa60bd9f29$export$533cd3269e981a31), {
                error: error
            }),
            areAllItemsLoaded && /*#__PURE__*/ (0, $l998X.jsx)(ExperienceSuccess, {}),
            !!itemFailureError && /*#__PURE__*/ (0, $l998X.jsx)(ExperienceError, {
                error: itemFailureError
            })
        ]
    });
};


const $3843dc6c886aff87$export$9db933359d5c5243 = ({ extensionNode: extensionNode, contentId: contentId, mode: mode = (0, $4cOi8.ExtensionMode).RENDERER })=>{
    const { isTargetAudience: isTargetAudience, isCompanyHub: isCompanyHub, smartCardProviderComponent: smartCardProviderComponent } = (0, $fOKpq.useProductDependencies)();
    const SmartCardProvider = smartCardProviderComponent || (0, $42omo.Fragment);
    const { parameters: parameters, localId: localId = '' } = extensionNode || {};
    if (!parameters) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $1Yx9c.HubExtensionsWrapper), {
        mode: mode,
        extensionNode: extensionNode,
        contentId: contentId,
        showNoDataState: !parameters,
        packageName: "cards-extension",
        analyticsAttributes: {
            renderVariant: parameters?.renderVariant,
            version: parameters?.version,
            isCompanyHub: isCompanyHub,
            hubSegementationApplied: parameters?.isSegmentationShown
        },
        children: /*#__PURE__*/ (0, $l998X.jsx)(SmartCardProvider, {
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $75ac03d5ea4b0323$export$bab15f92b6d84cb6), {
                extensionLocalId: localId,
                parameters: parameters,
                isCompanyHub: isCompanyHub,
                isTargetAudience: isTargetAudience,
                isInViewMode: mode === (0, $4cOi8.ExtensionMode).RENDERER,
                contentId: contentId
            })
        })
    });
};
const $3843dc6c886aff87$export$4956ae2d90a2bbeb = ({ propsProvider: PropsProvider, ...props })=>/*#__PURE__*/ (0, $l998X.jsx)(PropsProvider, {
        ...props,
        children: /*#__PURE__*/ (0, $l998X.jsx)($3843dc6c886aff87$export$9db933359d5c5243, {
            ...props
        })
    });
module.exports["CardsExtensionBase"] = $3843dc6c886aff87$export$9db933359d5c5243;
module.exports["CardsExtension"] = $3843dc6c886aff87$export$4956ae2d90a2bbeb;

});

parcelRegister("1Yx9c", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $hnvzE = parcelRequire("hnvzE");


var $fOKpq = parcelRequire("fOKpq");


var $4cOi8 = parcelRequire("4cOi8");


var $1m9A2 = parcelRequire("1m9A2");


var $8Ixq2 = parcelRequire("8Ixq2");


var $jrlgF = parcelRequire("jrlgF");


var $glqE9 = parcelRequire("glqE9");

const $b3bbb984d806269d$export$1b8348eac06ebe09 = ({ extensionNode: extensionNode, contentId: contentId, analyticsAttributes: analyticsAttributes, children: children, showNoDataState: showNoDataState, mode: mode = (0, $4cOi8.ExtensionMode).RENDERER, packageName: packageName })=>{
    const { analyticsContext: analyticsContext, errorBoundaryComponent: errorBoundaryComponent, experienceStartComponent: experienceStartComponent } = (0, $fOKpq.useProductDependencies)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { extensionKey: extensionKey, parameters: parameters } = extensionNode || {};
    const hasParameters = !showNoDataState || parameters;
    const ExperienceStart = experienceStartComponent || (0, $42omo.Fragment);
    const ErrorBoundaryComponent = errorBoundaryComponent || (0, $jrlgF.HubErrorBoundary);
    const errorBoundaryProps = errorBoundaryComponent ? {} : {
        id: extensionKey ?? contentId,
        packageName: packageName,
        fallback: /*#__PURE__*/ (0, $l998X.jsx)((0, $8Ixq2.GenericErrorPage), {})
    };
    (0, $42omo.useEffect)(()=>{
        if (mode === (0, $4cOi8.ExtensionMode).RENDERER) createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'viewed',
                actionSubject: 'macro',
                actionSubjectId: extensionKey,
                source: 'viewPageScreen',
                attributes: {
                    ...analyticsAttributes,
                    ...analyticsContext,
                    hasParameters: !!parameters,
                    contentId: contentId
                }
            }
        }).fire();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        mode
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $hnvzE.default), {
        name: extensionKey || 'unknown-hub-extension',
        children: /*#__PURE__*/ (0, $l998X.jsxs)(ErrorBoundaryComponent, {
            ...errorBoundaryProps,
            shouldForceError: (0, $glqE9.EXTENSIONS_CRITICAL_FOR_PAGE_LOAD).has(extensionKey || ''),
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)(ExperienceStart, {}),
                hasParameters ? children : /*#__PURE__*/ (0, $l998X.jsx)((0, $1m9A2.NoExtensionData), {
                    source: extensionKey
                })
            ]
        })
    });
};
module.exports["HubExtensionsWrapper"] = $b3bbb984d806269d$export$1b8348eac06ebe09;

});

parcelRegister("1m9A2", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gtD4K = parcelRequire("gtD4K");

var $8C5kA = parcelRequire("8C5kA");


var $1Whri = parcelRequire("1Whri");


var $abC4X = parcelRequire("abC4X");


var $gdv5Z = parcelRequire("gdv5Z");


var $fOKpq = parcelRequire("fOKpq");


var $harUV = parcelRequire("harUV");


var $dE8aF = parcelRequire("dE8aF");

const $947dafb4b85c32e6$var$styles = {
    baseStyles: "_1e0c1txw _1bah1h6o _4cvr1h6o",
    configPanelStyles: "_4t3i1vuk",
    extensionStyles: "_4t3i1osq"
};
const $947dafb4b85c32e6$export$dd91c9257a0f1cd4 = ({ source: source = '', isConfigPanel: isConfigPanel })=>{
    const intl = (0, $8C5kA.default)();
    const { submitError: submitError } = (0, $fOKpq.useProductDependencies)();
    const extensionSourceName = source?.charAt(0).toUpperCase() + source?.slice(1);
    (0, $42omo.useEffect)(()=>{
        const errorMessage = `${extensionSourceName} ${isConfigPanel ? 'config panel' : 'extension'} failed to render. No parameters.`;
        submitError?.(new Error(errorMessage));
    }, [
        extensionSourceName,
        isConfigPanel,
        submitError
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($947dafb4b85c32e6$var$styles.baseStyles, isConfigPanel ? $947dafb4b85c32e6$var$styles.configPanelStyles : $947dafb4b85c32e6$var$styles.extensionStyles),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $abC4X.default), {
            header: intl.formatMessage((0, $dE8aF.messages).noDataStateHeaderText),
            description: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                ...(0, $dE8aF.messages).noDataStateDescription
            }),
            imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($harUV)))
        })
    });
};
module.exports["NoExtensionData"] = $947dafb4b85c32e6$export$dd91c9257a0f1cd4;

});

parcelRegister("harUV", function(module, exports) {
module.exports = new URL("Warning.e56d4e3e.svg", import.meta.url).toString();

});

parcelRegister("dE8aF", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $8bb95c815845532f$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    noDataStateHeaderText: {
        id: "company-hub.company-hub-common.link-cards.error-states.no-data.header-text",
        defaultMessage: "No data to display"
    },
    noDataStateDescription: {
        id: "company-hub.company-hub-common.link-cards.error-states.no-data.description-text",
        defaultMessage: "Try deleting this macro and creating a new one."
    }
});
module.exports["messages"] = $8bb95c815845532f$export$defe85febe8b728c;

});

parcelRegister("glqE9", function(module, exports) {
// we have made a copy of the extension keys to avoid importing the constants from the extensions packages
// this is a temporary solution to avoid the bundle size increase
// todo: we will have to create a new package for the constants and import it here
const $97dcfab536b484ac$export$3617e2677e53ded6 = new Set([
    'links-menu',
    'cards',
    'spotlight',
    'carousel',
    'hub-section',
    'jsm-help'
]);
module.exports["EXTENSIONS_CRITICAL_FOR_PAGE_LOAD"] = $97dcfab536b484ac$export$3617e2677e53ded6;

});

parcelRegister("hRuRu", function(module, exports) {

var $eN7zR = parcelRequire("eN7zR");

/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */ function $d00f536c1934c36c$var$castFunction(value) {
    return typeof value == 'function' ? value : $eN7zR;
}
module.exports = $d00f536c1934c36c$var$castFunction;

});

parcelRegister("IBZYB", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $8dfa4f5c71224290$export$3d5265f8773197d = ({ maxNumberOfItemsPerRow: maxNumberOfItemsPerRow, numberOfItems: numberOfItems, isRow: isRow })=>{
    // Indices represents the leftmost item and rightmost item currently in view.
    const [window, setWindow] = (0, $42omo.useState)([
        0,
        0
    ]);
    // Used for scrolling to a particular item. Set to -1 by default as we haven't scrolled yet.
    const [scrollToIndex, setScrollToIndex] = (0, $42omo.useState)(-1);
    // Used to keep track of which item is currently being edited in the config panel to adjust window accordingly.
    const [requestedScrollIndex, setRequestedScrollIndex] = (0, $42omo.useState)(-1);
    (0, $42omo.useEffect)(()=>{
        {
            // Viewable window indexes are inclusive of left and right index, so we need to decrement by one unless maxNumberOfItemsPerRow is 0.
            // Examples:
            // Cards: 1 2 3 4 5, Card indexes: 0 1 2 3 4
            // maxNumberOfItemsPerRow is 0, current left index is at card 1 (ie. index 0) --> right index should be at card 1 (index 0), 1 card in view. Calculation: 0 + 0 - 0 = 0
            // maxNumberOfItemsPerRow is 2, current left index is at card 1 (ie. index 0) --> right index should be at card 2 (index 1), 2 cards in view. Calculation: 0 + 2 - 1 = 1
            // maxNumberOfItemsPerRow is 3, current left index is at card 2 (ie. index 1) --> right index should be at card 4 (index 3), 3 cards in view. Calculation: 1 + 3 - 1 = 3
            const extraDecrement = maxNumberOfItemsPerRow === 0 ? 0 : 1;
            const newRightIndex = window[0] + maxNumberOfItemsPerRow - extraDecrement;
            setWindow([
                window[0],
                newRightIndex
            ]);
        }
        if (requestedScrollIndex >= 0) {
            // Trigger scroll unconditionally, this works for grid view as well (which doesn't use the window logic)
            setScrollToIndex(requestedScrollIndex);
            // Only update the window in row orientation, as we don't use a window for grid view.
            if (isRow) {
                if (requestedScrollIndex !== window[0] && requestedScrollIndex !== window[1]) {
                    // This means we've scrolled somewhere left beyond the existing visible window, so we update the window to the left.
                    if (requestedScrollIndex < window[0]) setWindow([
                        requestedScrollIndex,
                        requestedScrollIndex + maxNumberOfItemsPerRow - 1
                    ]);
                    else if (requestedScrollIndex > window[1]) setWindow([
                        requestedScrollIndex - maxNumberOfItemsPerRow + 1,
                        requestedScrollIndex
                    ]);
                }
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        maxNumberOfItemsPerRow,
        requestedScrollIndex,
        isRow
    ]);
    const scrollToPrevious = (0, $42omo.useCallback)(()=>{
        const newLeftIndex = window[0] - 1;
        const newRightIndex = window[1] - 1;
        setWindow([
            newLeftIndex,
            newRightIndex
        ]);
        setScrollToIndex(newLeftIndex);
    }, [
        window
    ]);
    const scrollToNext = ()=>{
        const newLeftIndex = window[0] + 1;
        const newRightIndex = window[1] + 1;
        setWindow([
            newLeftIndex,
            newRightIndex
        ]);
        setScrollToIndex(newRightIndex);
    };
    (0, $42omo.useEffect)(()=>{
        // If user deletes an item near the end of the list, our window of
        // items being shown may need recalculating (if right index is too high)
        if (window[1] > numberOfItems - 1 && window[0] > 0) scrollToPrevious();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        numberOfItems,
        scrollToPrevious
    ]);
    const noScrollNeeded = numberOfItems <= maxNumberOfItemsPerRow;
    const isAtBeginning = noScrollNeeded || window[0] === 0;
    const isAtEnd = noScrollNeeded || window[1] === numberOfItems - 1;
    const resetScrollIndex = ()=>{
        setScrollToIndex(-1);
    };
    return {
        isAtBeginning: isAtBeginning,
        isAtEnd: isAtEnd,
        scrollToPrevious: scrollToPrevious,
        scrollToNext: scrollToNext,
        scrollToIndex: scrollToIndex,
        requestScrollIndex: setRequestedScrollIndex,
        resetScrollIndex: resetScrollIndex
    };
};
module.exports["useOrientationScrolling"] = $8dfa4f5c71224290$export$3d5265f8773197d;

});

parcelRegister("lPcXt", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");

const $fea56e716edbc72a$export$1a197eb476b94cd9 = 16;
const $fea56e716edbc72a$export$622d6c2ee56322dc = 16;
const $fea56e716edbc72a$var$MAX_NUMBER_OF_ITEMS_PER_ROW = 6;
const $fea56e716edbc72a$export$a6443181a5681c94 = ({ numberOfCards: numberOfCards, cardDimensions: cardDimensions, getItemDimensions: getItemDimensions })=>{
    const [currentCardsGridWidth, setCurrentCardsGridWidth] = (0, $42omo.useState)(0);
    const [currentCardWidth, setCurrentCardWidth] = (0, $42omo.useState)(0);
    const dimensions = getItemDimensions ? getItemDimensions() : cardDimensions;
    /*
	 * Width observer rounds the width of the container (currentCardsGridWidth) returning a whole number.
	 * This means in situations that the width is rounded up, we have an edge case where we are
	 * making calculations with a grid width larger than what we actually have leading to layout issues.
	 *
	 * It is better to adjust the width we get from the observer down (-.5px) and
	 * have some cases where we have extra space (<=.5px) than the latter problem that causes layout issues.
	 */ const currentCardsGridWidthAdjustedForRounding = currentCardsGridWidth - 0.5;
    const numberOfCardsPerRow = Math.floor((currentCardsGridWidthAdjustedForRounding + $fea56e716edbc72a$export$1a197eb476b94cd9) / (dimensions.minWidth + $fea56e716edbc72a$export$1a197eb476b94cd9));
    const maxNumberOfCardsPerRow = (0, $dh538.fg)('company_hub_cards_visual_update') ? Math.min(numberOfCardsPerRow, $fea56e716edbc72a$var$MAX_NUMBER_OF_ITEMS_PER_ROW) : numberOfCardsPerRow;
    if (currentCardsGridWidthAdjustedForRounding <= dimensions.minWidth) return {
        calculations: {
            cardWidthOnFullRow: dimensions.minWidth,
            isFirstRowFull: true,
            isFirstRowOverflown: false,
            isGridSmallerOrEqualWidthToCards: true,
            gaps: {
                spaceBetweenCards: $fea56e716edbc72a$export$1a197eb476b94cd9,
                paddingRightGapOffset: 0
            },
            maxNumberOfCardsPerRow: maxNumberOfCardsPerRow
        },
        setCurrentCardsGridWidth: setCurrentCardsGridWidth,
        setCurrentCardWidth: setCurrentCardWidth
    };
    const maxCardSizeOnFullRow = Math.floor((currentCardsGridWidthAdjustedForRounding - $fea56e716edbc72a$export$1a197eb476b94cd9 * (maxNumberOfCardsPerRow - 1)) / maxNumberOfCardsPerRow);
    const isFirstRowFull = numberOfCards >= maxNumberOfCardsPerRow;
    const isFirstRowOverflown = numberOfCards > maxNumberOfCardsPerRow;
    const cardWidthOnFullRow = Math.min(maxCardSizeOnFullRow, dimensions.maxWidth);
    const cardsOnFirstRow = Math.min(numberOfCards, maxNumberOfCardsPerRow);
    const numberOfRowGaps = Math.max(0, cardsOnFirstRow - 1);
    const extraSpaceInGrid = currentCardsGridWidthAdjustedForRounding - cardsOnFirstRow * currentCardWidth - numberOfRowGaps * $fea56e716edbc72a$export$1a197eb476b94cd9;
    const maxAdditionalSpacePerGapBetweenCards = numberOfRowGaps === 0 ? 0 : Math.min(extraSpaceInGrid / numberOfRowGaps, $fea56e716edbc72a$export$622d6c2ee56322dc - $fea56e716edbc72a$export$1a197eb476b94cd9);
    const spaceBetweenCards = $fea56e716edbc72a$export$1a197eb476b94cd9 + maxAdditionalSpacePerGapBetweenCards;
    const paddingRightGapOffset = !isFirstRowFull ? 0 : (extraSpaceInGrid - numberOfRowGaps * maxAdditionalSpacePerGapBetweenCards) / 2;
    const calculations = {
        cardWidthOnFullRow: cardWidthOnFullRow,
        isFirstRowFull: isFirstRowFull,
        isFirstRowOverflown: isFirstRowOverflown,
        isGridSmallerOrEqualWidthToCards: false,
        gaps: {
            spaceBetweenCards: spaceBetweenCards,
            paddingRightGapOffset: paddingRightGapOffset
        },
        maxNumberOfCardsPerRow: maxNumberOfCardsPerRow
    };
    return {
        calculations: calculations,
        setCurrentCardsGridWidth: setCurrentCardsGridWidth,
        setCurrentCardWidth: setCurrentCardWidth
    };
};
module.exports["useWidthAndSpacingCalculations"] = $fea56e716edbc72a$export$a6443181a5681c94;

});

parcelRegister("ahPKE", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $4JDbp = parcelRequire("4JDbp");


var $g3LxX = parcelRequire("g3LxX");


var $4cOi8 = parcelRequire("4cOi8");

const $067bbf2166381c77$export$efa81a508b70a345 = {
    [(0, $4cOi8.Height).SMALL]: {
        minWidth: 221,
        maxWidth: 380,
        height: 72
    },
    [(0, $4cOi8.Height).MEDIUM]: {
        minWidth: 240,
        maxWidth: 308,
        height: 312
    },
    [(0, $4cOi8.Height).LARGE]: {
        minWidth: 358,
        maxWidth: 640,
        height: 312
    }
};
const $067bbf2166381c77$export$1928c8795f1f40c6 = (cardSize)=>{
    return $067bbf2166381c77$export$efa81a508b70a345[cardSize];
};
const $067bbf2166381c77$var$styles = {
    wrapperStyles: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1rjcv77o _kqswh2mm",
    wrapperWithInlinePadding: "_18zrv77o"
};
const $067bbf2166381c77$export$11b226df951ea813 = ({ children: children, isFirstRowFull: isFirstRowFull, cardWidthOnFullRow: cardWidthOnFullRow, setWidth: setWidth, testId: testId = 'card-wrapper', scrollToCard: scrollToCard, clearScrollToCard: clearScrollToCard, index: index, requestScrollIndex: requestScrollIndex, cardId: cardId, extensionLocalId: extensionLocalId, itemDimensions: itemDimensions, hasInlinePadding: hasInlinePadding = false })=>{
    const cardRef = (0, $42omo.useRef)(null);
    const [{ selectedExtensionLocalId: selectedExtensionLocalId, selectedToEditCardId: selectedToEditCardId }] = (0, $g3LxX.useExtensionsState)();
    const cardDimensions = itemDimensions;
    (0, $42omo.useEffect)(()=>{
        const scrollIntoViewBehavior = {
            behavior: 'smooth',
            block: 'nearest',
            inline: 'nearest'
        };
        if (cardRef.current) {
            // Scroll to this card as long as its config panel is open OR no config panel is open.
            // If no config panel is open, that covers the case in edit mode where user has clicked
            // scroll buttons on a row-oriented cards instance which they aren't actively editing.
            if (scrollToCard && (!selectedExtensionLocalId || extensionLocalId === selectedExtensionLocalId)) {
                cardRef.current.scrollIntoView(scrollIntoViewBehavior); // Clear scrollIndex to prevent re-invoking scroll effect later unexpectedly
                clearScrollToCard();
            } // Handle the case where user has selected this card to edit from the config panel.
            if (selectedToEditCardId && selectedToEditCardId === cardId && extensionLocalId === selectedExtensionLocalId) // Now that we've reached the right card that user is selecting to edit,
            // trigger the scrolling hook to recalculate scroll window and index so
            // that we can rerender invoking the scroll effect
            requestScrollIndex(index);
            else if (!selectedToEditCardId) // if no card is selected to edit, set index to -1 indicate that it is not currently being used
            requestScrollIndex(-1);
        }
    }, [
        cardRef,
        cardId,
        extensionLocalId,
        index,
        scrollToCard,
        clearScrollToCard,
        selectedExtensionLocalId,
        selectedToEditCardId,
        requestScrollIndex
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)("div", {
        style: {
            minWidth: isFirstRowFull ? `${cardWidthOnFullRow}px` : `${cardDimensions.minWidth}px`,
            maxWidth: isFirstRowFull ? `${cardWidthOnFullRow}px` : `${cardDimensions.maxWidth}px`
        },
        ref: cardRef,
        "data-testid": testId,
        className: (0, $gMc0m.default)([
            $067bbf2166381c77$var$styles.wrapperStyles,
            hasInlinePadding && $067bbf2166381c77$var$styles.wrapperWithInlinePadding
        ]),
        children: [
            children,
            index === 0 && setWidth && /*#__PURE__*/ (0, $l998X.jsx)((0, $4JDbp.WidthObserver), {
                setWidth: setWidth,
                offscreen: true
            })
        ]
    });
};
module.exports["CardOrientationWrapper"] = $067bbf2166381c77$export$11b226df951ea813;

});

parcelRegister("eagtR", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $g3LxX = parcelRequire("g3LxX");

const $d383b1063b3ff59a$var$ItemSelectedToEditWrapperStyles = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSelectedToEdit: isSelectedToEdit, isSelectedToRemove: isSelectedToRemove, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "",
            __cmplp.isSelectedToEdit && "_1ivtdfik",
            __cmplp.isSelectedToRemove && "_1ivt19ep",
            __cmplp.isSelectedToRemove && "_8ibab3bt _zbo0stnw _xu41idpf _1dqsidpf _pbjsidpf _139fidpf _1pm8kb7n _1b0d105o _1l6t1gly",
            __cmplp.className
        ])
    });
});
const $d383b1063b3ff59a$export$d3fc0aff4df25c77 = ({ extensionLocalId: extensionLocalId, itemId: itemId, children: children })=>{
    const itemRef = (0, $42omo.useRef)(null);
    const [{ selectedExtensionLocalId: selectedExtensionLocalId, selectedToEditCardId: selectedToEditCardId, selectedToRemoveCardId: selectedToRemoveCardId }, { setIsInAutoFocusMode: setIsInAutoFocusMode, setSelectedToEditCardId: setSelectedToEditCardId }] = (0, $g3LxX.useExtensionsState)();
    const onItemClick = (0, $42omo.useCallback)(()=>{
        if (extensionLocalId === selectedExtensionLocalId) {
            setIsInAutoFocusMode(true);
            setSelectedToEditCardId(itemId);
        }
    }, [
        itemId,
        extensionLocalId,
        selectedExtensionLocalId,
        setSelectedToEditCardId,
        setIsInAutoFocusMode
    ]);
    const isSelectedToEdit = selectedToEditCardId === itemId && extensionLocalId === selectedExtensionLocalId;
    const isSelectedToRemove = selectedToRemoveCardId === itemId && extensionLocalId === selectedExtensionLocalId;
    return /*#__PURE__*/ (0, $l998X.jsx)($d383b1063b3ff59a$var$ItemSelectedToEditWrapperStyles, {
        ref: itemRef,
        isSelectedToEdit: isSelectedToEdit,
        isSelectedToRemove: isSelectedToRemove,
        onClick: onItemClick,
        children: children
    });
};
module.exports["ItemSelectedToEditWrapper"] = $d383b1063b3ff59a$export$d3fc0aff4df25c77;

});

parcelRegister("7w8ah", function(module, exports) {
var $4b12b330ff8d99c7$export$da638b84af7eb6eb = /*#__PURE__*/ function(CoverPictureIdPropertyKey) {
    CoverPictureIdPropertyKey["PUBLISHED"] = "cover-picture-id-published";
    CoverPictureIdPropertyKey["DRAFT"] = "cover-picture-id-draft";
    return CoverPictureIdPropertyKey;
}({});
function $4b12b330ff8d99c7$export$da000b5ddbbe9afc(p) {
    let value;
    let version;
    const DEFAULT_POSITION_VALUE = 50;
    try {
        value = JSON.parse(p.value);
        version = p.version ? parseInt(JSON.parse(p.version.number)) : null;
        // Counting quotes to determine if the value we receive is a string (old cover photos experience without repositioning feature)
        // or object (new cover photos experience with repositioning feature - has a position property in the object).
        // The new designs will have value as an object but stored as a string: "{"id":"http://website.com","position":45}"
        // We need to JSON.parse it again to turn it into an object. The old cover photos will just have value as a string: value: "123-abc",
        // so there is no need to JSON parse it again. We will set its position as the default position value to support this new value format.
        const quoteMatches = value.match(/"/g);
        const quoteCount = quoteMatches ? quoteMatches.length : 0;
        // if quoteCount != null this mean value is part of the new experience so we need to JSON parse the info again since it is a stored as a string and we want the object
        if (quoteCount) try {
            value = JSON.parse(value);
        } catch (e) {
            value = null;
        }
        else // otherwise it was just a regular string (part of old experience without repositioning)
        value = {
            id: value,
            position: DEFAULT_POSITION_VALUE
        };
    } catch (e) {
        value = null;
        version = null;
    }
    return p ? {
        value: value,
        version: version
    } : null;
}
module.exports["CoverPictureIdPropertyKey"] = $4b12b330ff8d99c7$export$da638b84af7eb6eb;
module.exports["propertyToId"] = $4b12b330ff8d99c7$export$da000b5ddbbe9afc;

});

parcelRegister("e51Sk", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cUcZ5 = parcelRequire("cUcZ5");


var $inPa6 = parcelRequire("inPa6");


var $dh538 = parcelRequire("dh538");


var $lhvsH = parcelRequire("lhvsH");


var $1VNax = parcelRequire("1VNax");

var $4cOi8 = parcelRequire("4cOi8");

var $7q60U = parcelRequire("7q60U");

var $g3LxX = parcelRequire("g3LxX");


var $kcoxM = parcelRequire("kcoxM");


var $5un3P = parcelRequire("5un3P");

const $a2d58ae16516956a$export$669fadbeb0d65b03 = {
    backgroundColor: "var(--ds-surface-overlay, #FFFFFF)",
    textColor: "var(--ds-text, #292A2E)"
};
const $a2d58ae16516956a$var$initialUnsplashImage = {
    imageSrc: 'https://images.unsplash.com/photo-1579547621706-1a9c79d5c9f1?auto=format&fit=crop&q=80&w=1080',
    imageAltText: 'purple and pink light illustration'
};
const $a2d58ae16516956a$var$getNewCardImage = (cardsLength)=>{
    const imageIndex = cardsLength % (0, $kcoxM.CARDS_IMAGES_V5).length;
    const { src: src, alt: alt } = (0, $kcoxM.CARDS_IMAGES_V5)[imageIndex] || (0, $kcoxM.CARDS_IMAGES_V5)[0];
    return {
        imageSrc: src,
        imageAltText: alt
    };
};
const $a2d58ae16516956a$export$d4fe2f2056b6479c = (defaultField)=>{
    return {
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        cardId: (0, (/*@__PURE__*/$parcel$interopDefault($cUcZ5)))(),
        link: '',
        isLinkUserEdited: false,
        title: '',
        isTitleUserEdited: false,
        description: '',
        isDescriptionUserEdited: false,
        imagePosition: (0, $5un3P.ImagePosition).MIDDLE,
        ...defaultField
    };
};
const $a2d58ae16516956a$export$721510bd2cdb9b4f = (link, confluencePageId, isLinkUserEdited, linkResourceType)=>{
    return {
        [(0, $4cOi8.ITEM_FIELDS).LINK]: link,
        [(0, $4cOi8.ITEM_FIELDS).CONFLUENCE_PAGE_ID]: confluencePageId || '',
        [(0, $4cOi8.ITEM_FIELDS).IS_LINK_USER_EDITED]: isLinkUserEdited || false,
        [(0, $4cOi8.ITEM_FIELDS).LINK_RESOURCE_TYPE]: linkResourceType || ''
    };
};
const $a2d58ae16516956a$var$fetchLocalIdMacroParameters = (editorActions, localId, isCardsVisualUpdateEnabled, isCardsV2GateEnabled)=>{
    const localIdNode = editorActions?.getNodeByLocalId?.(localId)?.toJSON();
    let params = localIdNode?.attrs?.parameters;
    if (params === undefined) return undefined;
    // Make a copy of the params object to avoid mutating the original object
    params = {
        ...params
    };
    // If the extension was created prior to removal of type field, remove it from object here
    // This update is/was not done in combination with a feature gate
    delete params['type'];
    params = $a2d58ae16516956a$var$updateParamsToVersion2(params);
    params = $a2d58ae16516956a$var$updateParamsToVersion3(params);
    if (isCardsVisualUpdateEnabled) params = $a2d58ae16516956a$var$updateParamsToVersion4(params);
    if (isCardsV2GateEnabled) params = $a2d58ae16516956a$var$updateParamsToVersion5(params);
    return params;
};
const $a2d58ae16516956a$var$updateParamsToVersion2 = (params)=>{
    var // Set render variant to manual only if it is not set
    _params;
    params.version = (0, $kcoxM.CARDS_EXTENSION_VERSION_2);
    (_params = params).renderVariant ?? (_params.renderVariant = (0, $4cOi8.RenderVariant).MANUAL);
    return params;
};
const $a2d58ae16516956a$var$updateParamsToVersion3 = (params)=>{
    var _params, // Set orientation to stack only if it is not set
    _params1, // Set alignment to center only if it is not set
    _params2;
    // Only set for cards extension
    // Always set version to 3
    params.version = (0, $kcoxM.CARDS_EXTENSION_VERSION_3);
    (_params = params).isAutoscrollEnabled ?? (_params.isAutoscrollEnabled = false);
    (_params1 = params).orientation ?? (_params1.orientation = (0, $5un3P.Orientation).STACKED);
    (_params2 = params).alignment ?? (_params2.alignment = (0, $5un3P.Alignment).CENTER);
    if (params.segmentationTarget === (0, $4cOi8.SegmentationTargets).ALL && params.audienceSegmentationGroupIds === undefined) params.audienceSegmentationGroupIds = params.cards[0]?.audienceSegmentationGroupIds;
    return params;
};
const $a2d58ae16516956a$var$updateParamsToVersion4 = (params)=>{
    var _params, _params1, _params2, _params3, _params4;
    params.version = (0, $kcoxM.CARDS_EXTENSION_VERSION_4);
    (_params = params).backgroundColor ?? (_params.backgroundColor = "var(--ds-surface-overlay, #FFFFFF)");
    (_params1 = params).textColor ?? (_params1.textColor = "var(--ds-text, #292A2E)");
    (_params2 = params).cornerStyle ?? (_params2.cornerStyle = (0, $4cOi8.CornerStyle).ROUNDED);
    (_params3 = params).isSocialStatsShown ?? (_params3.isSocialStatsShown = false);
    (_params4 = params).isIconShown ?? (_params4.isIconShown = false);
    return params;
};
const $a2d58ae16516956a$var$updateParamsToVersion5 = (params)=>{
    var _params, _params1, _params2, _params3;
    params.version = (0, $kcoxM.CARDS_EXTENSION_VERSION_5);
    (_params = params).layout ?? (_params.layout = (0, $5un3P.CardsLayout).FLEXIBLE_IMAGE_HEIGHT);
    (_params1 = params).isPaddingEnabled ?? (_params1.isPaddingEnabled = true);
    (_params2 = params).isLabelShown ?? (_params2.isLabelShown = true);
    (_params3 = params).borderColor ?? (_params3.borderColor = (0, $lhvsH.DEFAULT_GRAY_COLOR));
    return params;
};
const $a2d58ae16516956a$var$removeProperties = (extensionsPropertiesToRemove, extensionParameters)=>{
    const mutatedParameters = {
        ...extensionParameters
    };
    extensionsPropertiesToRemove.forEach((field)=>{
        delete mutatedParameters[field];
    });
    return mutatedParameters;
};
const $a2d58ae16516956a$var$updateCardInList = (cards, cardId, updatedField)=>cards.map((card)=>{
        if (card.cardId === cardId) return {
            ...card,
            ...updatedField
        };
        return card;
    });
const $a2d58ae16516956a$export$3c876d2ed5ae458e = ({ localId: localId, editorActions: editorActions })=>{
    const [cardsParameters, setExtensionParameters] = (0, $42omo.useState)($a2d58ae16516956a$var$fetchLocalIdMacroParameters(editorActions, localId, (0, $dh538.fg)('company_hub_cards_visual_update'), (0, $dh538.fg)('company_hub_cards_v2')));
    const { setIsInAutoFocusMode: setIsInAutoFocusMode, setSelectedToEditCardId: setSelectedToEditCardId } = (0, $g3LxX.useExtensionsActions)();
    const { cards: cards, segmentationTarget: segmentationTarget, isSegmentationShown: isSegmentationShown } = cardsParameters ?? {};
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        const extensionNodeParams = $a2d58ae16516956a$var$fetchLocalIdMacroParameters(editorActions, localId, (0, $dh538.fg)('company_hub_cards_visual_update'), (0, $dh538.fg)('company_hub_cards_v2'));
        setExtensionParameters(extensionNodeParams);
    }, [
        editorActions,
        localId
    ]);
    const updateExtensionParams = (0, $42omo.useCallback)((newExtensionParameters, options = {})=>{
        setExtensionParameters((prevParams)=>{
            let mutatedFields = {
                ...prevParams
            };
            const fieldsToRemove = [
                ...options?.fieldsToRemove || []
            ];
            if (fieldsToRemove.length > 0) mutatedFields = $a2d58ae16516956a$var$removeProperties(fieldsToRemove, prevParams);
            const updatedParams = {
                ...mutatedFields,
                ...newExtensionParameters
            };
            // Save params to ADF and state
            const success = (0, $7q60U.updateNodeParameters)(editorActions, updatedParams);
            if (!success) createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    source: 'cardsExtension',
                    action: 'error',
                    actionSubject: 'cardsConfigPanel',
                    attributes: {
                        updatedFields: newExtensionParameters,
                        version: updatedParams.version
                    }
                }
            }).fire();
            return updatedParams;
        });
    }, [
        editorActions,
        createAnalyticsEvent
    ]);
    const addCard = (0, $42omo.useCallback)(()=>{
        const newCard = $a2d58ae16516956a$export$d4fe2f2056b6479c({
            [(0, $4cOi8.ITEM_FIELDS).AUDIENCE_SEGMENTATION_GROUP_IDS]: isSegmentationShown && segmentationTarget === (0, $4cOi8.SegmentationTargets).ALL ? cards[0]?.audienceSegmentationGroupIds : undefined,
            ...(0, $dh538.fg)('company_hub_cards_visual_update') ? $a2d58ae16516956a$var$getNewCardImage(cards.length) : $a2d58ae16516956a$var$initialUnsplashImage
        });
        updateExtensionParams({
            cards: [
                ...(0, $1VNax.checkItems)(cards) || [],
                newCard
            ]
        });
        setIsInAutoFocusMode(true);
        setSelectedToEditCardId(newCard.cardId);
    }, [
        cards,
        segmentationTarget,
        isSegmentationShown,
        updateExtensionParams,
        setSelectedToEditCardId,
        setIsInAutoFocusMode
    ]);
    const removeCard = (0, $42omo.useCallback)((cardId)=>updateExtensionParams({
            cards: cards.filter((card)=>card.cardId !== cardId)
        }), [
        cards,
        updateExtensionParams
    ]);
    const updateMainFormField = (0, $42omo.useCallback)((updatedFields, options = {})=>updateExtensionParams(updatedFields, options), [
        updateExtensionParams
    ]);
    const updateCardFormField = (0, $42omo.useCallback)((cardId, updatedField)=>{
        const updatedCards = $a2d58ae16516956a$var$updateCardInList(cards, cardId, updatedField);
        updateExtensionParams({
            cards: updatedCards
        });
    }, [
        cards,
        updateExtensionParams
    ]);
    const updateCardFormFieldForAllCards = (0, $42omo.useCallback)((updatedField)=>{
        const updatedCards = cards.map((card)=>{
            return {
                ...card,
                ...updatedField
            };
        });
        updateExtensionParams({
            cards: updatedCards
        });
    }, [
        cards,
        updateExtensionParams
    ]);
    const updateLayout = (0, $42omo.useCallback)((newLayout)=>{
        updateExtensionParams({
            layout: newLayout
        });
    }, [
        updateExtensionParams
    ]);
    const updateBorderColor = (0, $42omo.useCallback)((newBorderColor)=>{
        updateExtensionParams({
            borderColor: newBorderColor
        });
    }, [
        updateExtensionParams
    ]);
    const updateCornerStyle = (0, $42omo.useCallback)((newCornerStyle)=>{
        updateExtensionParams({
            cornerStyle: newCornerStyle
        });
    }, [
        updateExtensionParams
    ]);
    const cardsActions = (0, $42omo.useMemo)(()=>({
            addCard: addCard,
            removeCard: removeCard,
            updateMainFormField: updateMainFormField,
            updateCardFormField: updateCardFormField,
            updateCardFormFieldForAllCards: updateCardFormFieldForAllCards,
            updateLayout: updateLayout,
            updateBorderColor: updateBorderColor,
            updateCornerStyle: updateCornerStyle
        }), [
        addCard,
        removeCard,
        updateMainFormField,
        updateCardFormField,
        updateCardFormFieldForAllCards,
        updateLayout,
        updateBorderColor,
        updateCornerStyle
    ]);
    return {
        cardsParameters: cardsParameters,
        cardsActions: cardsActions
    };
};
module.exports["cardNewParametersV4"] = $a2d58ae16516956a$export$669fadbeb0d65b03;
module.exports["createNewCardWithDefaultParameters"] = $a2d58ae16516956a$export$d4fe2f2056b6479c;
module.exports["updateLinkAndConfluencePageId"] = $a2d58ae16516956a$export$721510bd2cdb9b4f;
module.exports["useCardsExtensionParametersAndActions"] = $a2d58ae16516956a$export$3c876d2ed5ae458e;

});

parcelRegister("7YEWU", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0545074a7ad6867d320b793a6025aac2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5cede6a65f901a4e$var$_react = $5cede6a65f901a4e$var$_interopRequireDefault((parcelRequire("42omo")));

var $5cede6a65f901a4e$var$_baseNew = $5cede6a65f901a4e$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $5cede6a65f901a4e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "VideoPause".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for pause video in Media.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5cede6a65f901a4e$var$VideoPauseIcon = (props)=>/*#__PURE__*/ $5cede6a65f901a4e$var$_react.default.createElement($5cede6a65f901a4e$var$_baseNew.default, Object.assign({
        name: "VideoPauseIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 3a2 2 0 0 1 2-2h1a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM9 3a2 2 0 0 1 2-2h1a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5z" clip-rule="evenodd"/>`
    }, props));
$5cede6a65f901a4e$var$VideoPauseIcon.displayName = 'VideoPauseIcon';
var $5cede6a65f901a4e$var$_default = module.exports.default = $5cede6a65f901a4e$var$VideoPauseIcon;

});

parcelRegister("lOHzS", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::550a63d3b233a1e606c45af1b8952b33>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fe2012194714c5ae$var$_react = $fe2012194714c5ae$var$_interopRequireDefault((parcelRequire("42omo")));

var $fe2012194714c5ae$var$_baseNew = $fe2012194714c5ae$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $fe2012194714c5ae$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "VideoPlay".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for play video in Media.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fe2012194714c5ae$var$VideoPlayIcon = (props)=>/*#__PURE__*/ $fe2012194714c5ae$var$_react.default.createElement($fe2012194714c5ae$var$_baseNew.default, Object.assign({
        name: "VideoPlayIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 3.112C2 1.592 3.63.627 4.963 1.36l8.902 4.888c1.383.76 1.383 2.747 0 3.506l-8.902 4.888C3.63 15.373 2 14.408 2 12.888zm2.24-.438a.5.5 0 0 0-.74.438v9.776a.5.5 0 0 0 .74.438l8.903-4.888a.5.5 0 0 0 0-.876z" clip-rule="evenodd"/>`
    }, props));
$fe2012194714c5ae$var$VideoPlayIcon.displayName = 'VideoPlayIcon';
var $fe2012194714c5ae$var$_default = module.exports.default = $fe2012194714c5ae$var$VideoPlayIcon;

});

parcelRegister("bGmGb", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $eXmBZ = parcelRequire("eXmBZ");


var $auNCB = parcelRequire("auNCB");

var $iXCQx = parcelRequire("iXCQx");


var $DrhU3 = parcelRequire("DrhU3");

const $e96164e2c3666e0d$var$styles = {
    anchor: "_zulp1b66 _4bfu1r31 _1hmsglyw _ajmmnqa1 _1e0c1txw _4cvr1h6o _1ydc1r31 _1x28glyw _1726nqa1 _9oik1r31 _1bnxglyw _jf4cnqa1"
};
const $e96164e2c3666e0d$export$ddd36803697578b9 = ()=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const disclaimerMessage = formatMessage((0, $DrhU3.messages).disclaimerMessage);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $auNCB.default), {
        href: "https://www.atlassian.com/trust/atlassian-intelligence",
        xcss: $e96164e2c3666e0d$var$styles.anchor,
        target: "_blank",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eXmBZ))), {
                label: "",
                color: "var(--ds-icon-subtle, #505258)",
                size: "small"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                size: "small",
                color: "color.text.subtlest",
                children: disclaimerMessage
            })
        ]
    });
};
module.exports["CardsAIDisclaimer"] = $e96164e2c3666e0d$export$ddd36803697578b9;

});

parcelRegister("DrhU3", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $598d867c4680f9f5$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    disclaimerMessage: {
        id: "company-hub.cards-extension.ai-disclaimer.disclaimer-message",
        defaultMessage: "AI generated content"
    }
});
module.exports["messages"] = $598d867c4680f9f5$export$defe85febe8b728c;

});

parcelRegister("3LC7V", function(module, exports) {
/**
 * This file contains export components and API for FlexibleCard components.
 * For internal usage for access to all available props, please use following
 * - ./components/elements for metadata component
 * - ./components/actions for action component
 *
 * DO NOT add a new prop to these components until we are ready to support it externally.
 */ 
var $42omo = parcelRequire("42omo");


var $5TXU5 = parcelRequire("5TXU5");


var $apOlf = parcelRequire("apOlf");

var $6FZ6a = parcelRequire("6FZ6a");

var $j5Rp4 = parcelRequire("j5Rp4");

var $cLh5D = parcelRequire("cLh5D");

var $9l03X = parcelRequire("9l03X");

var $2vLbR = parcelRequire("2vLbR");

var $lVA2Y = parcelRequire("lVA2Y");


var $6cbph = parcelRequire("6cbph");

var $4wLtQ = parcelRequire("4wLtQ");

var $iNImz = parcelRequire("iNImz");

var $LrBxG = parcelRequire("LrBxG");

var $bWsCB = parcelRequire("bWsCB");

var $azCqP = parcelRequire("azCqP");

var $kexiH = parcelRequire("kexiH");

var $3nul2 = parcelRequire("3nul2");

var $e8W8a = parcelRequire("e8W8a");

var $jKoRo = parcelRequire("jKoRo");

var $bmx11 = parcelRequire("bmx11");

var $jI5eg = parcelRequire("jI5eg");

var $8iOdP = parcelRequire("8iOdP");

var $jW9GW = parcelRequire("jW9GW");

var $1WqHG = parcelRequire("1WqHG");

var $ful5o = parcelRequire("ful5o");

var $41AV3 = parcelRequire("41AV3");

var $ikM9T = parcelRequire("ikM9T");

var $8YJtM = parcelRequire("8YJtM");

var $6Ed8U = parcelRequire("6Ed8U");

var $2ZgNz = parcelRequire("2ZgNz");

var $iuEuh = parcelRequire("iuEuh");

var $2GDee = parcelRequire("2GDee");

var $h2WFd = parcelRequire("h2WFd");

var $49WiA = parcelRequire("49WiA");

var $aGsNO = parcelRequire("aGsNO");

var $emfmd = parcelRequire("emfmd");

var $jpKes = parcelRequire("jpKes");

var $a0Yyn = parcelRequire("a0Yyn");

var $b8mrt = parcelRequire("b8mrt");

var $hIbqn = parcelRequire("hIbqn");

var $gHW9t = parcelRequire("gHW9t");

var $zH0mb = parcelRequire("zH0mb");

var $6LJqp = parcelRequire("6LJqp");

const $18cd6f93eedff66b$export$46d56fa2aa324fa6 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6cbph.default), null);
const $18cd6f93eedff66b$export$c1142bebae312275 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4wLtQ.default), null);
const $18cd6f93eedff66b$export$fd86792b0d618eef = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iNImz.default), null);
const $18cd6f93eedff66b$export$85c1cdc45fbd445c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $LrBxG.default), null);
const $18cd6f93eedff66b$export$ceec5736924de4d3 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bWsCB.default), null);
const $18cd6f93eedff66b$export$145bed937364849e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $azCqP.default), null);
const $18cd6f93eedff66b$export$a43b6bbf2f1b5e96 = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kexiH.default), {
        color: props?.color,
        onRender: props?.onRender
    });
};
const $18cd6f93eedff66b$export$fcb9afb4cbcee73a = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e8W8a.default), null);
const $18cd6f93eedff66b$export$85780eaea5e9340b = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3nul2.default), null);
const $18cd6f93eedff66b$export$514e2dbf44bf7dec = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jKoRo.default), null);
const $18cd6f93eedff66b$export$a8c002f6544d07d4 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bmx11.default), null);
const $18cd6f93eedff66b$export$4d177e8e493d864d = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jI5eg.default), {
        size: props?.iconTileSize === 24 ? (0, $5TXU5.SmartLinkSize).Large : (0, $5TXU5.SmartLinkSize).Medium,
        render: props?.render
    });
};
const $18cd6f93eedff66b$export$af6f82ac48d2952d = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8iOdP.default), null);
const $18cd6f93eedff66b$export$6ddb078bc7afcbf = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jW9GW.default), null);
const $18cd6f93eedff66b$export$cb2b1990006f041b = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1WqHG.default), {
        hideDatePrefix: props?.hideDatePrefix,
        color: props?.color,
        onRender: props?.onRender,
        fontSize: props?.fontSize
    });
};
const $18cd6f93eedff66b$export$d630834382353545 = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ful5o.default), {
        hideFormat: props?.hideFormat,
        color: props?.color,
        onRender: props?.onRender,
        textPrefix: props?.textPrefix,
        fontSize: props?.fontSize
    });
};
const $18cd6f93eedff66b$export$633ffcc4029e4e39 = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $41AV3.default), {
        onRender: props?.onRender
    });
};
const $18cd6f93eedff66b$export$5b3c009928f1ce72 = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ikM9T.default), {
        overrideUrl: props?.url
    });
};
const $18cd6f93eedff66b$export$9f98f75e82cffae = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8YJtM.default), null);
const $18cd6f93eedff66b$export$dc976923d15b4909 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6Ed8U.default), null);
const $18cd6f93eedff66b$export$7fce19392096f26f = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2ZgNz.default), null);
const $18cd6f93eedff66b$export$5ecf9c2b4f9ce084 = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iuEuh.default), {
        color: props?.color,
        onRender: props?.onRender
    });
};
const $18cd6f93eedff66b$export$27f88025ed20e742 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2GDee.default), null);
const $18cd6f93eedff66b$export$c49fe7f9d49294b6 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $h2WFd.default), null);
const $18cd6f93eedff66b$export$80ac7ae64759451e = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $49WiA.default), {
        maxLines: props?.maxLines,
        content: props?.text
    });
const $18cd6f93eedff66b$export$f56004dbb02efc8a = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aGsNO.default), null);
const $18cd6f93eedff66b$export$28ad9e2ec019f34c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $emfmd.default), null);
const $18cd6f93eedff66b$export$2815de51cd1f37b1 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jpKes.default), null);
const $18cd6f93eedff66b$export$8d3e182130d8b766 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a0Yyn.default), null);
const $18cd6f93eedff66b$export$3d178478c7cef7e6 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b8mrt.default), null);
const $18cd6f93eedff66b$export$da2d835ee85f951d = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hIbqn.default), null);
const $18cd6f93eedff66b$export$56726d258a7004ee = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gHW9t.default), {
        hideTooltip: props?.hideTooltip,
        maxLines: props?.maxLines,
        target: props?.target,
        theme: props?.theme,
        size: props?.size,
        testId: props?.testId,
        ...props?.text ? {
            text: props?.text
        } : undefined
    });
const $18cd6f93eedff66b$export$fff7f783105f14f1 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $zH0mb.default), null);
const $18cd6f93eedff66b$export$b5dd74337242162e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6LJqp.default), null);
const $18cd6f93eedff66b$export$b639603370d1ca44 = (props)=>({
        appearance: props?.appearance ?? 'default',
        icon: undefined
    });
const $18cd6f93eedff66b$export$4c2bfaba2cf0128a = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $apOlf.default), $18cd6f93eedff66b$export$b639603370d1ca44(props));
const $18cd6f93eedff66b$export$b605bf507f6a39c = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6FZ6a.default), {
        ...$18cd6f93eedff66b$export$b639603370d1ca44(props),
        content: props.children,
        onClick: props.onClick
    });
const $18cd6f93eedff66b$export$7a2b423858a679ca = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cLh5D.default), $18cd6f93eedff66b$export$b639603370d1ca44(props));
const $18cd6f93eedff66b$export$efdca248636f91bf = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9l03X.default), $18cd6f93eedff66b$export$b639603370d1ca44(props));
const $18cd6f93eedff66b$export$56dfecf361778c5b = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2vLbR.default), $18cd6f93eedff66b$export$b639603370d1ca44(props));
const $18cd6f93eedff66b$export$8687dc32e81b32c2 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lVA2Y.default), props);
module.exports["CommentCountElement"] = $18cd6f93eedff66b$export$a43b6bbf2f1b5e96;
module.exports["LinkIconElement"] = $18cd6f93eedff66b$export$4d177e8e493d864d;
module.exports["ModifiedOnElement"] = $18cd6f93eedff66b$export$cb2b1990006f041b;
module.exports["OwnedByElement"] = $18cd6f93eedff66b$export$d630834382353545;
module.exports["OwnedByGroupElement"] = $18cd6f93eedff66b$export$633ffcc4029e4e39;
module.exports["ReactCountElement"] = $18cd6f93eedff66b$export$5ecf9c2b4f9ce084;
module.exports["UnresolvedAction"] = $18cd6f93eedff66b$export$8687dc32e81b32c2;

});

parcelRegister("9CM6e", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $lAJUP = parcelRequire("lAJUP");


var $dQl1W = parcelRequire("dQl1W");


var $bYRk6 = parcelRequire("bYRk6");


var $lgqac = parcelRequire("lgqac");


var $aylI0 = parcelRequire("aylI0");


var $5Tie7 = parcelRequire("5Tie7");

const $21c8f9d8a5ab2bc3$export$7b5e1b7f9a325b6 = (props)=>{
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const [id] = (0, $42omo.useState)(()=>props.id ?? (0, (/*@__PURE__*/$parcel$interopDefault($dQl1W)))());
    const cardProps = {
        ...props,
        id: id
    };
    const ErrorFallbackComponent = cardProps.fallbackComponent;
    const errorBoundaryFallbackComponent = ()=>{
        if (ErrorFallbackComponent) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ErrorFallbackComponent, null);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5Tie7.LoadingCardLink), cardProps);
    };
    const Component = cardProps.appearance === 'inline' ? 'span' : 'div';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bYRk6.default), {
        data: (0, $lgqac.context)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAJUP.ErrorBoundary), {
        FallbackComponent: errorBoundaryFallbackComponent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Component, {
        className: "loader-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aylI0.CardWithUrlContent), cardProps))));
};
module.exports["CardSSR"] = $21c8f9d8a5ab2bc3$export$7b5e1b7f9a325b6;

});

parcelRegister("aPwHF", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fOKpq = parcelRequire("fOKpq");

const $fbac79744aa5216e$export$9e87ed1f12141293 = (cardId, link, onCardSucceeded, onCardFailed)=>{
    const [isResolved, setIsResolved] = (0, $42omo.useState)(false);
    const [errorCardStatus, setErrorCardStatus] = (0, $42omo.useState)('');
    const { submitError: submitError } = (0, $fOKpq.useProductDependencies)();
    const shouldPreserveErrorStatus = (0, $42omo.useRef)(false);
    // Other error types [`errored`, `fallback`] should not be caught. We will let the card UI render, even though
    // the SmartCard cannot fetch data for them
    const isRestricted = errorCardStatus === 'forbidden';
    const isUnauthorized = errorCardStatus === 'unauthorized';
    const isNoResult = errorCardStatus === 'not_found';
    (0, $42omo.useEffect)(()=>{
        setErrorCardStatus('');
    }, [
        link,
        setErrorCardStatus
    ]);
    const failExperienceAndSendErrorMonitoring = (0, $42omo.useCallback)((err)=>{
        onCardFailed(err);
        submitError?.(err);
    }, [
        onCardFailed,
        submitError
    ]);
    const trackAndCategorizeError = (0, $42omo.useCallback)(({ status: status, err: err })=>{
        setErrorCardStatus(status);
        setIsResolved(true);
        if (status === 'unauthorized') shouldPreserveErrorStatus.current = true;
        if (err) failExperienceAndSendErrorMonitoring(err);
        else onCardSucceeded(cardId);
    }, [
        setErrorCardStatus,
        cardId,
        onCardSucceeded,
        failExperienceAndSendErrorMonitoring
    ]);
    const trackSuccess = (0, $42omo.useCallback)(()=>{
        onCardSucceeded(cardId);
        setIsResolved(true);
        // For Smart Cards with an unauthorized state, it calls onResolve, but we don't want to clear the error status.
        // shouldPreserveErrorStatus is used b/c we need to skip clearing the error status for one cycle
        if (shouldPreserveErrorStatus.current) {
            shouldPreserveErrorStatus.current = false;
            return;
        }
        setErrorCardStatus('');
    }, [
        setErrorCardStatus,
        cardId,
        onCardSucceeded
    ]);
    return {
        isNoResult: isNoResult,
        isRestricted: isRestricted,
        isUnauthorized: isUnauthorized,
        errorCardStatus: errorCardStatus,
        isResolved: isResolved,
        trackAndCategorizeError: trackAndCategorizeError,
        trackSuccess: trackSuccess
    };
};
module.exports["useTrackedSmartCardState"] = $fbac79744aa5216e$export$9e87ed1f12141293;

});

parcelRegister("e0Oqq", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $fT2ta = parcelRequire("fT2ta");

const $c85123d895112cbb$var$skeletonWrapperStyles = null;
const $c85123d895112cbb$var$emojiSkeletonStyles = null;
const $c85123d895112cbb$export$9fc60f86d5a6479f = ({ height: height, loadingMargin: loadingMargin })=>{
    const PLACEHOLDER_SIZE = height;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fT2ta.default), {
        entranceDirection: "left",
        children: (animationProps)=>/*#__PURE__*/ (0, $l998X.jsx)("span", {
                ...animationProps,
                "data-testid": "emoji-placeholder",
                "data-css-target": "emoji-placeholder",
                className: (0, $gMc0m.default)([
                    "_1e0c1txw _1bah1h6o _4cvr1h6o _1bumglyw _sedtglyw"
                ]),
                children: /*#__PURE__*/ (0, $l998X.jsx)("span", {
                    style: {
                        width: `${PLACEHOLDER_SIZE}px`,
                        height: `${PLACEHOLDER_SIZE}px`,
                        margin: loadingMargin
                    },
                    className: (0, $gMc0m.default)([
                        "_2rkofajl _1e0c1o8l _bfhkizff _19pkze3t _2hwxze3t _otyrze3t _18u0ze3t _ca0qze3t"
                    ])
                })
            })
    });
};
module.exports["EmojiPlaceholder"] = $c85123d895112cbb$export$9fc60f86d5a6479f;

});

parcelRegister("aNq5K", function(module, exports) {

let $7dc2b84170e8b205$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $7dc2b84170e8b205$var$load("6wr18"),
    $7dc2b84170e8b205$var$load("ffEVr"),
    $7dc2b84170e8b205$var$load("mYwau")
]).then(()=>parcelRequire('45jPm'));

});

parcelRegister("89YPL", function(module, exports) {
module.exports = new URL("NoResults.9d75157a.svg", import.meta.url).toString();

});

parcelRegister("g50oa", function(module, exports) {
module.exports = new URL("NoDynamicCards.7cd8fd7d.svg", import.meta.url).toString();

});

parcelRegister("cNgYa", function(module, exports) {
const $851669374477a92c$export$1861ee29fc9bca35 = 'https://www.atlassian.com/';
const $851669374477a92c$export$ea1683885a045a91 = ()=>{
    if (typeof window === 'undefined' || !window.location?.href) return $851669374477a92c$export$1861ee29fc9bca35;
    return window.location.href;
};
module.exports["getSmartCardFallbackUrl"] = $851669374477a92c$export$ea1683885a045a91;

});

parcelRegister("5mB97", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $3e7bd247c2a15a57$var$_react = $3e7bd247c2a15a57$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $3e7bd247c2a15a57$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $3e7bd247c2a15a57$var$Document16Icon = (props)=>/*#__PURE__*/ $3e7bd247c2a15a57$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m2 3a1 1 0 1 0 0 2h8a1 1 0 0 0 0-2zm0 4a1 1 0 1 0 0 2h8a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h4a1 1 0 0 0 0-2z"/></svg>`
    }, props, {
        size: 'small'
    }));
$3e7bd247c2a15a57$var$Document16Icon.displayName = 'Document16Icon';
var $3e7bd247c2a15a57$var$_default = module.exports.default = $3e7bd247c2a15a57$var$Document16Icon;

});

parcelRegister("i9cac", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $d36280b20a14c4f7$var$_react = $d36280b20a14c4f7$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $d36280b20a14c4f7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d36280b20a14c4f7$var$Document24Icon = (props)=>/*#__PURE__*/ $d36280b20a14c4f7$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1 18c0 .556.446 1 .995 1h8.01c.54 0 .995-.448.995-1 0-.556-.446-1-.995-1h-8.01c-.54 0-.995.448-.995 1m0-4c0 .556.448 1 1 1h14c.555 0 1-.448 1-1 0-.556-.448-1-1-1H5c-.555 0-1 .448-1 1m0-4c0 .556.448 1 1 1h14c.555 0 1-.448 1-1 0-.556-.448-1-1-1H5c-.555 0-1 .448-1 1m0-4c0 .556.448 1 1 1h14c.555 0 1-.448 1-1 0-.556-.448-1-1-1H5c-.555 0-1 .448-1 1"/></svg>`
    }, props, {
        size: 'medium'
    }));
$d36280b20a14c4f7$var$Document24Icon.displayName = 'Document24Icon';
var $d36280b20a14c4f7$var$_default = module.exports.default = $d36280b20a14c4f7$var$Document24Icon;

});

parcelRegister("j6GAe", function(module, exports) {
$parcel$export(module.exports, "default", () => $90028f2cad692a01$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::db70e40168178b4ae8431bb0df789052>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $9RVmI = parcelRequire("9RVmI");


var $fP78j = parcelRequire("fP78j");

function $90028f2cad692a01$export$2e2bcd8739ae039({ label: label = 'Blog', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fP78j.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9RVmI))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)",
        backgroundColor: isBold ? 'color.background.accent.blue.subtle' : undefined
    });
}

});

parcelRegister("fP78j", function(module, exports) {
$parcel$export(module.exports, "default", () => $fce53c8d1c9f5417$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $dRnqM = parcelRequire("dRnqM");


var $i7jPX = parcelRequire("i7jPX");

function $fce53c8d1c9f5417$export$2e2bcd8739ae039({ label: label = '', size: size = 'medium', testId: testId, color: color, backgroundColor: backgroundColor, icon: Icon }) {
    // Validate that size is a valid `ObjectTileSize` (and won't allow Tile's `xxsmall` size to be passed)
    const validSizes = [
        'xsmall',
        'small',
        'medium',
        'large',
        'xlarge'
    ];
    (0, $dRnqM.default)(validSizes.includes(size), `ObjectTile: size "${size}" is not valid. Valid sizes are: ${validSizes.join(', ')}`);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $i7jPX.default), {
        label: "",
        backgroundColor: backgroundColor,
        size: size,
        children: /*#__PURE__*/ (0, $l998X.jsx)(Icon, {
            label: label,
            color: color,
            testId: testId,
            // @ts-expect-error - Internal, undocumented prop
            shouldScale: true
        })
    });
}

});

parcelRegister("e0ycV", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f5f2152e50a3b99db24df80b6d3e591d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a32b99a806197ff2$var$_react = $a32b99a806197ff2$var$_interopRequireDefault((parcelRequire("42omo")));

var $a32b99a806197ff2$var$_baseNew = $a32b99a806197ff2$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $a32b99a806197ff2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PageLiveDoc".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for Live Document content type.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a32b99a806197ff2$var$PageLiveDocIcon = (props)=>/*#__PURE__*/ $a32b99a806197ff2$var$_react.default.createElement($a32b99a806197ff2$var$_baseNew.default, Object.assign({
        name: "PageLiveDocIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 3.5H1V2h14zm-9 5H1V7h5zM6 14H1v-1.5h5zm2.72-6.78a.75.75 0 0 1 .79-.17l6 2.25a.75.75 0 0 1-.08 1.43l-2.56.64-.64 2.56a.75.75 0 0 1-1.43.08l-2.25-6a.75.75 0 0 1 .17-.79" clip-rule="evenodd"/>`
    }, props));
$a32b99a806197ff2$var$PageLiveDocIcon.displayName = 'PageLiveDocIcon';
var $a32b99a806197ff2$var$_default = module.exports.default = $a32b99a806197ff2$var$PageLiveDocIcon;

});

parcelRegister("66dpz", function(module, exports) {
$parcel$export(module.exports, "default", () => $893c7e3925139b9a$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1c9832fbd4a1ca0bae327cc20e7bdf16>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $e0ycV = parcelRequire("e0ycV");


var $kXb3C = parcelRequire("kXb3C");

function $893c7e3925139b9a$export$2e2bcd8739ae039({ label: label = 'Page Live Doc', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($e0ycV))),
        color: "var(--ds-icon-accent-magenta, #CD519D)"
    });
}

});

parcelRegister("fAGae", function(module, exports) {
$parcel$export(module.exports, "default", () => $0f3b40ffeda05888$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a95f50e5543417b936016ac441fe40a9>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $e0ycV = parcelRequire("e0ycV");


var $fP78j = parcelRequire("fP78j");

function $0f3b40ffeda05888$export$2e2bcd8739ae039({ label: label = 'Page Live Doc', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fP78j.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($e0ycV))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-magenta, #CD519D)",
        backgroundColor: isBold ? 'color.background.accent.magenta.subtle' : undefined
    });
}

});

parcelRegister("6Eovk", function(module, exports) {
$parcel$export(module.exports, "default", () => $4d797c8c4e4c6494$export$2e2bcd8739ae039);
/* eslint-disable import/no-default-export */ /* eslint-disable react/prop-types */ 
var $42omo = parcelRequire("42omo");


var $cMypa = parcelRequire("cMypa");

function $4d797c8c4e4c6494$export$2e2bcd8739ae039(props) {
    // Produce the image tag as is because there is no onLoad event in SSR
    // Also render image tag directly if the page was SSRed because react-render-image always render placeholder first.
    // This will make image flicker
    return props.src && (0, window.__SSR_RENDERED__) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, props.loaded) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cMypa))), props);
}

});

parcelRegister("cMypa", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $94e4a7d853f8088a$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $42omo = parcelRequire("42omo");

var $94e4a7d853f8088a$var$React = $94e4a7d853f8088a$var$_interopRequireWildcard($42omo);
function $94e4a7d853f8088a$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $94e4a7d853f8088a$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $94e4a7d853f8088a$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $94e4a7d853f8088a$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function $94e4a7d853f8088a$var$loading(image) {
    return {
        image: image,
        isLoaded: false,
        isErrored: false
    };
}
function $94e4a7d853f8088a$var$loaded() {
    return {
        isLoaded: true
    };
}
function $94e4a7d853f8088a$var$errored() {
    return {
        isErrored: true
    };
}
function $94e4a7d853f8088a$var$hasPropsChanged(prevProps, nextProps) {
    var prevSrc = prevProps.src;
    var nextSrc = nextProps.src;
    return prevSrc !== nextSrc;
}
var $94e4a7d853f8088a$var$ImageRenderer = function(_React$Component) {
    $94e4a7d853f8088a$var$_inherits(ImageRenderer, _React$Component);
    function ImageRenderer() {
        var _ref;
        var _temp, _this, _ret;
        $94e4a7d853f8088a$var$_classCallCheck(this, ImageRenderer);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $94e4a7d853f8088a$var$_possibleConstructorReturn(this, (_ref = ImageRenderer.__proto__ || Object.getPrototypeOf(ImageRenderer)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this.state = {
            isLoaded: false,
            isErrored: false
        }, _this.handleLoad = function() {
            var onLoad = _this.props.onLoad;
            _this.unload();
            _this.setState($94e4a7d853f8088a$var$loaded(), function() {
                if (onLoad) onLoad();
            });
        }, _this.handleError = function() {
            var onError = _this.props.onError;
            _this.unload();
            _this.setState($94e4a7d853f8088a$var$errored(), function() {
                if (onError) onError();
            });
        }, _temp), $94e4a7d853f8088a$var$_possibleConstructorReturn(_this, _ret);
    }
    $94e4a7d853f8088a$var$_createClass(ImageRenderer, [
        {
            key: 'load',
            value: function load() {
                var src = this.props.src;
                var image = this.state.image;
                if (image) {
                    image.onload = this.handleLoad;
                    image.onerror = this.handleError;
                    image.src = src;
                }
            }
        },
        {
            key: 'unload',
            value: function unload() {
                var image = this.state.image;
                if (image) {
                    image.onload = undefined;
                    image.onerror = undefined;
                }
            }
        },
        {
            key: 'componentWillMount',
            value: function componentWillMount() {
                if (typeof window === 'undefined') return;
                this.setState($94e4a7d853f8088a$var$loading(new Image()));
            }
        },
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                this.load();
            }
        },
        {
            key: 'componentWillReceiveProps',
            value: function componentWillReceiveProps(nextProps) {
                if ($94e4a7d853f8088a$var$hasPropsChanged(this.props, nextProps)) this.setState($94e4a7d853f8088a$var$loading(new Image()));
            }
        },
        {
            key: 'componentDidUpdate',
            value: function componentDidUpdate(prevProps) {
                if ($94e4a7d853f8088a$var$hasPropsChanged(prevProps, this.props)) {
                    this.unload();
                    this.load();
                }
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                this.unload();
            }
        },
        {
            key: 'render',
            value: function render() {
                var _props = this.props, loading = _props.loading, loaded = _props.loaded, errored = _props.errored, children = _props.children;
                var _state = this.state, image = _state.image, isLoaded = _state.isLoaded, isErrored = _state.isErrored;
                if (isLoaded && loaded) return loaded;
                if (isErrored && errored) return errored;
                if (!isLoaded && !isErrored && loading) return loading;
                if (children) return children({
                    image: isLoaded ? image : undefined,
                    loaded: isLoaded,
                    errored: isErrored
                });
                return null;
            }
        }
    ]);
    return ImageRenderer;
}($94e4a7d853f8088a$var$React.Component);
module.exports.default = $94e4a7d853f8088a$var$ImageRenderer;

});

parcelRegister("1Okf1", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dDhJe = parcelRequire("dDhJe");

const $6833d9101ef67c08$export$d08617a365fbe694 = (cardClient)=>(0, $42omo.useMemo)(()=>(0, $dDhJe.getResolverUrl)(cardClient?.envKey, cardClient?.baseUrlOverride), [
        cardClient?.baseUrlOverride,
        cardClient?.envKey
    ]);
module.exports["useResolverUrl"] = $6833d9101ef67c08$export$d08617a365fbe694;

});

parcelRegister("hcMBV", function(module, exports) {
var $87ac0097385af1df$export$f40b7e0b762b928b = /*#__PURE__*/ function(CardAction) {
    CardAction["DownloadAction"] = "DownloadAction";
    CardAction["PreviewAction"] = "PreviewAction";
    CardAction["ViewAction"] = "ViewAction";
    CardAction["ChangeStatusAction"] = "ChangeStatusAction";
    CardAction["FollowAction"] = "FollowAction";
    CardAction["CopyLinkAction"] = "CopyLinkAction";
    CardAction["AISummaryAction"] = "AISummaryAction";
    CardAction["AutomationAction"] = "AutomationAction";
    return CardAction;
}({});
module.exports["CardAction"] = $87ac0097385af1df$export$f40b7e0b762b928b;

});


//# sourceMappingURL=cards-extension.08243a25.js.map
